<div class="overlay animated fadeIn" *ngIf="this.parent.hasSearchResults() || ClearGridQuestion || AskAddNewRFQasPOQuestion || AskAddNewRFQQuestion || AskAddNewOfferQuestion || showStockReadjustedPopup;" (click)="this.parent.closeSearchResults();"></div>

<!-- ✅ Deselect overlay - covers entire page when items are selected, clicking deselects all -->
<div class="deselect-page-overlay" *ngIf="hasSelectedCartItems()" (click)="deselectAllCartItems()"></div>

<!-- ✅ Red Row Edit Popup - OUTSIDE NewQuotationMainContent for proper z-index stacking -->
<div class="ModernPopupOverlay" *ngIf="ShowRedRowEditPopup" (click)="CloseRedRowEditPopup()">
  <div class="ModernPopup medium" style="max-width: 500px;" (click)="$event.stopPropagation()">

    <!-- Popup Header -->
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">edit</i>
        <span>{{ CurrentRedRowEditCartItem?.CartItemStatus?.ID === 0 ? 'Edit Unknown Product' : 'Edit Product Details' }}</span>
        <span class="ModernPopupSubtitle">Row #{{ CurrentRedRowEditRowIndex + 1 }} - {{ CurrentRedRowEditCartItem?.Product?.Name || 'No Name' }}</span>
      </div>
      <button class="ModernPopupClose" (click)="CloseRedRowEditPopup()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Tab Navigation -->
    <div class="RedRowEditTabsWrapper">
      <div class="RedRowEditTab"
           [ngClass]="{'RedRowEditTabActive': RedRowEditSelectedTab === 'General'}"
           (click)="RedRowEditSelectedTab = 'General'">
        <i class="material-icons">info</i>
        <span>{{ 'General' | translate }}</span>
      </div>
      <div class="RedRowEditTab"
           [ngClass]="{'RedRowEditTabActive': RedRowEditSelectedTab === 'Master-Data'}"
           (click)="RedRowEditSelectedTab = 'Master-Data'">
        <i class="material-icons">straighten</i>
        <span>{{ 'Master-Data' | translate }}</span>
      </div>
      <div class="RedRowEditTab"
           [ngClass]="{'RedRowEditTabActive': RedRowEditSelectedTab === 'Availability'}"
           (click)="RedRowEditSelectedTab = 'Availability'">
        <i class="material-icons">inventory_2</i>
        <span>{{ 'Availability' | translate }}</span>
      </div>
      <div class="RedRowEditTab"
           [ngClass]="{'RedRowEditTabActive': RedRowEditSelectedTab === 'Conditions'}"
           (click)="RedRowEditSelectedTab = 'Conditions'">
        <i class="material-icons">verified</i>
        <span>{{ 'Conditions' | translate }}</span>
      </div>
    </div>

    <!-- Popup Body -->
    <div class="ModernPopupBody RedRowEditBody" style="padding: 12px 2%; min-height: 500px;" (click)="closeAllRedRowEditDropdowns()">

    <!-- ========== GENERAL TAB ========== -->
    <div *ngIf="RedRowEditSelectedTab === 'General'" class="RedRowEditTabContent">

    <!-- Brand (with backend identification on blur) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">Brand</label>
      <div class="PartnerSearchContainer" style="position: relative;" (click)="$event.stopPropagation()">
        <div class="PartnerSearchBar">
          <i class="material-icons search-icon" *ngIf="!RedRowEditCartItemClone?.Product?.Brand?.Name">label</i>
          <i class="material-icons clear-icon" *ngIf="RedRowEditCartItemClone?.Product?.Brand?.Name" (click)="RedRowEditCartItemClone.Product.Brand = null; RedRowEditBrandSearchResults = [];">close</i>
          <input type="text" class="PartnerSearchInput" placeholder="Type brand name..."
            [(ngModel)]="RedRowEditCartItemClone.Product.Brand.Name"
            (ngModelChange)="RedRowEditSearchBrands()"
            (blur)="RedRowEditIdentifyBrand()" />
        </div>
        <div class="PartnerSearchResults" *ngIf="RedRowEditBrandSearchResults.length > 0" style="position: absolute; top: 100%; left: 0; right: 0; z-index: 100;">
          <div class="PartnerSearchResult" *ngFor="let brand of RedRowEditBrandSearchResults" (click)="RedRowEditSelectBrand(brand)">
            <span class="PartnerName">{{ brand.Name }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- PartNumber -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">Part Number</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">tag</i>
        <input type="text" class="PartnerSearchInput" placeholder="Enter part number..."
          [(ngModel)]="RedRowEditCartItemClone.Product.PartNumber" />
      </div>
    </div>

    <!-- Name -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">Product Name</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">inventory_2</i>
        <input type="text" class="PartnerSearchInput" placeholder="Enter product name..."
          [(ngModel)]="RedRowEditCartItemClone.Product.Name" />
      </div>
    </div>

    <!-- Quantity -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">Quantity</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">numbers</i>
        <input type="number" class="PartnerSearchInput" placeholder="Enter quantity..."
          [(ngModel)]="RedRowEditCartItemClone.Quantity" min="0" step="1" />
      </div>
    </div>

    <!-- List Price (only editable on Admin Grid) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">List Price ({{RedRowEditCartItemClone?.SelectedOffer?.SellPrice?.Currency?.Symbol || 'N/A'}})</label>
      <div class="PartnerSearchBar RedRowEditListPriceBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">sell</i>
        <input type="number" class="PartnerSearchInput" placeholder="List price..."
          [(ngModel)]="RedRowEditCartItemClone.Product.Stats.StandardListPrice.UIUnitPrice" min="0" step="0.01"
          [disabled]="!useAdminGrid"
          (blur)="RedRowEditRecalculateFinalPrice()" />
      </div>
    </div>

    <!-- Discount % (only editable on Admin Grid) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">Discount %</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">percent</i>
        <input type="number" class="PartnerSearchInput" placeholder="Discount..."
          [(ngModel)]="RedRowEditCartItemClone.Product.Stats.StandardListPrice.Discount.Value" min="0" max="100" step="0.1"
          [disabled]="!useAdminGrid"
          (blur)="RedRowEditRecalculateFinalPrice()" />
      </div>
    </div>

    <!-- Final Price (only editable on Admin Grid) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">Final Price ({{RedRowEditCartItemClone?.SelectedOffer?.SellPrice?.Currency?.Symbol || 'N/A'}})</label>
      <div class="PartnerSearchBar RedRowEditFinalPriceBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">paid</i>
        <input type="number" class="PartnerSearchInput" placeholder="Final price..."
          [(ngModel)]="RedRowEditCartItemClone.SelectedOffer.SellPrice.UIUnitPrice" min="0" step="0.01"
          [disabled]="!useAdminGrid"
          (blur)="RedRowEditRecalculateDiscount()" />
      </div>
    </div>

    <!-- Supplier - ADMIN ONLY -->
    <div class="RedRowEditField" *ngIf="useAdminGrid">
      <label class="RedRowEditLabel">Supplier</label>
      <div class="PartnerSearchContainer" style="position: relative;" (click)="$event.stopPropagation()">
        <!-- ✅ Supplier Alternatives - Opens UPWARD on focus -->
        <div class="PartnerSearchResults RedRowEditSupplierAlternatives"
             *ngIf="RedRowEditShowSupplierAlternatives && CurrentRedRowEditCartItem?.Product?.ID"
             (click)="$event.stopPropagation()"
             (mousedown)="$event.stopPropagation()">
          <!-- Loading Spinner -->
          <div *ngIf="RedRowEditLoadingSideOffers" class="PartnerSearchResult" style="text-align: center; padding: 16px;">
            <mat-spinner class="smallSpinner" [diameter]="20" style="margin: 0 auto;"></mat-spinner>
            <span style="display: block; margin-top: 6px; color: #666; font-size: 11px;">{{'LoadingAlternatives' | translate}}</span>
          </div>
          <!-- Side Offers List -->
          <div *ngIf="!RedRowEditLoadingSideOffers && RedRowEditSideOffers?.length > 0">
            <div class="PartnerSearchResult" *ngFor="let offer of RedRowEditSideOffers"
                 (mousedown)="RedRowEditSelectSideOffer(offer); RedRowEditShowSupplierAlternatives = false; $event.preventDefault();">
              <div class="PartnerResultMain">
                <span class="PartnerName" style="flex: 2;">
                  <span *ngIf="offer?.SelectedOffer?.MOQ > 0" style="color: #888;">[{{ offer?.SelectedOffer?.MOQ }}] </span>{{ offer?.SelectedOffer?.Partner?.Name || 'N/A' }}
                </span>
                <span class="PartnerCountryBadge" style="background: #e3f2fd; color: #1976d2;">
                  {{ offer?.SelectedOffer?.ListPrice | number:'1.2-2' }} {{ offer?.SelectedOffer?.PurchaseCurrency?.Symbol || offer?.SelectedOffer?.Currency?.Symbol || '' }}
                </span>
                <span *ngIf="offer?.SelectedOffer?.StockQuantity > 0" class="PartnerCountryBadge" style="background: #e8f5e9; color: #388e3c;">
                  STOCK
                </span>
                <span *ngIf="offer?.SelectedOffer?.LeadTime?.Units > 0" class="PartnerSecondary" style="font-size: 11px; color: #666;">
                  {{ offer?.SelectedOffer?.LeadTime?.Units }} {{ offer?.SelectedOffer?.LeadTime?.Type?.Name || '' }}
                </span>
              </div>
            </div>
          </div>
          <!-- No Alternatives -->
          <div *ngIf="!RedRowEditLoadingSideOffers && (!RedRowEditSideOffers || RedRowEditSideOffers?.length === 0)"
               class="PartnerSearchResult" style="text-align: center; color: #999; font-size: 12px;">
            {{'NoSupplierAlternatives' | translate}}
          </div>
        </div>
        <div class="PartnerSearchBar">
          <i class="material-icons search-icon" *ngIf="!RedRowEditCartItemClone?.SelectedOffer?.Partner?.Name">business</i>
          <i class="material-icons clear-icon" *ngIf="RedRowEditCartItemClone?.SelectedOffer?.Partner?.Name" (click)="RedRowEditClearSupplier()">close</i>
          <input type="text" class="PartnerSearchInput" placeholder="Type supplier name..."
            [(ngModel)]="RedRowEditCartItemClone.SelectedOffer.Partner.Name"
            (ngModelChange)="RedRowEditSearchPartners()"
            (focus)="RedRowEditShowSupplierAlternatives = true"
            (blur)="RedRowEditIdentifySupplier()" />
        </div>
        <div class="PartnerSearchResults" *ngIf="RedRowEditPartnerSearchResults.length > 0" style="position: absolute; top: 100%; left: 0; right: 0; z-index: 100;">
          <div class="PartnerSearchResult" *ngFor="let partner of RedRowEditPartnerSearchResults" (click)="RedRowEditSelectPartner(partner)">
            <div class="PartnerResultMain">
              <span class="PartnerName">{{ partner.Name }}</span>
              <span class="PartnerSecondary" *ngIf="partner.VATNumber || partner.Country">
                <span *ngIf="partner.VATNumber">{{ partner.VATNumber }}</span>
                <span *ngIf="partner.Country"> • {{ partner.Country.Name }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Purchase Price - ADMIN ONLY -->
    <div class="RedRowEditField" *ngIf="useAdminGrid">
      <label class="RedRowEditLabel">Purchase Price</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">shopping_cart</i>
        <input type="number" class="PartnerSearchInput" placeholder="0.00"
          [(ngModel)]="RedRowEditCartItemClone.SelectedOffer.ListPrice" step="0.01" min="0" />
      </div>
    </div>

    <!-- Purchase Currency - ADMIN ONLY -->
    <div class="RedRowEditField" *ngIf="useAdminGrid" [style.z-index]="RedRowEditPurchaseCurrencyDropdownOpen ? 200 : 1" style="position: relative;">
      <label class="RedRowEditLabel">Purchase Currency</label>
      <div class="ConfigStatusDropdownContainer" style="position: relative;" (click)="$event.stopPropagation()">
        <div class="CustomDropdownBar ConfigStatusDropdownBar" (click)="RedRowEditPurchaseCurrencyDropdownOpen = !RedRowEditPurchaseCurrencyDropdownOpen">
          <i class="material-icons dropdown-icon-left">currency_exchange</i>
          <input type="text" class="CustomDropdownInput" [value]="(RedRowEditCartItemClone?.SelectedOffer?.PurchaseCurrency?.Symbol || '') + ' - ' + (RedRowEditCartItemClone?.SelectedOffer?.PurchaseCurrency?.Name || 'Select Currency')" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>
        <div class="CustomDropdownResults" *ngIf="RedRowEditPurchaseCurrencyDropdownOpen" style="position: absolute; top: 100%; left: 0; right: 0; z-index: 200;">
          <div class="CustomDropdownResult" *ngFor="let currency of currencies" (click)="RedRowEditCartItemClone.SelectedOffer.PurchaseCurrency = currency; RedRowEditPurchaseCurrencyDropdownOpen = false;">
            {{ currency.Symbol }} - {{ currency.Name }}
          </div>
        </div>
      </div>
    </div>

    <!-- Offer MOQ (SelectedOffer.MOQ) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">MOQ
        <span *ngIf="RedRowEditDBOfferLoading" style="font-size: 10px; color: #999; margin-left: 6px;">(loading...)</span>
        <span *ngIf="!RedRowEditDBOfferLoading && RedRowEditDBOfferMOQ != null" style="font-size: 10px; color: #666; margin-left: 6px;">(DB: {{ RedRowEditDBOfferMOQ }})</span>
      </label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">production_quantity_limits</i>
        <input type="number" class="PartnerSearchInput" placeholder="MOQ"
          [(ngModel)]="RedRowEditCartItemClone.SelectedOffer.MOQ" min="0" step="1" />
      </div>
    </div>

    </div>
    <!-- END GENERAL TAB -->

    <!-- ========== MASTER-DATA TAB ========== -->
    <div *ngIf="RedRowEditSelectedTab === 'Master-Data'" class="RedRowEditTabContent">

    <!-- HS Code -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">HS Code</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">qr_code</i>
        <input type="text" class="PartnerSearchInput" placeholder="Enter HS Code..."
          [(ngModel)]="RedRowEditCartItemClone.Product.Stats.HSCode" />
      </div>
    </div>

    <!-- Country of Origin (with backend identification on blur) -->
    <div class="RedRowEditField" [style.z-index]="RedRowEditCOOSearchResults?.length > 0 ? 200 : 1" style="position: relative;">
      <label class="RedRowEditLabel">Country of Origin</label>
      <div class="PartnerSearchContainer" style="position: relative;" (click)="$event.stopPropagation()">
        <div class="PartnerSearchBar">
          <i class="material-icons search-icon" *ngIf="!RedRowEditCartItemClone?.Product?.Stats?.COO?.ShortName">public</i>
          <i class="material-icons clear-icon" *ngIf="RedRowEditCartItemClone?.Product?.Stats?.COO?.ShortName" (click)="RedRowEditCartItemClone.Product.Stats.COO = null; RedRowEditCOOSearchResults = [];">close</i>
          <input type="text" class="PartnerSearchInput" placeholder="Type country..."
            [(ngModel)]="RedRowEditCartItemClone.Product.Stats.COO.ShortName"
            (ngModelChange)="RedRowEditSearchCountries()"
            (blur)="RedRowEditIdentifyCOO()"
            (keydown.enter)="RedRowEditIdentifyCOO(); $event.target.blur()"
            (keydown.tab)="RedRowEditIdentifyCOO()" />
        </div>
        <div class="PartnerSearchResults RedRowEditDropdownUpward" *ngIf="RedRowEditCOOSearchResults.length > 0" style="position: absolute; bottom: 100%; left: 0; right: 0; z-index: 200; margin-bottom: 4px;">
          <div class="PartnerSearchResult" *ngFor="let country of RedRowEditCOOSearchResults" (mousedown)="RedRowEditSelectCountry(country); $event.preventDefault();" style="justify-content: flex-start; text-align: left;">
            <span style="font-weight: 600; margin-right: 6px;">{{ country.ShortName }}</span>
            <span style="color: #666;">({{ country.Name }})</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Weight (with backend identification on blur/enter/tab) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">Weight</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">scale</i>
        <input type="text" class="PartnerSearchInput" placeholder="e.g., 2.5 kg"
          [(ngModel)]="RedRowEditCartItemClone.Product.Stats.Weight.UIOutput"
          (blur)="RedRowEditIdentifyWeight()"
          (keydown.enter)="RedRowEditIdentifyWeight(); $event.target.blur()"
          (keydown.tab)="RedRowEditIdentifyWeight()" />
      </div>
    </div>

    <!-- Datasheet Link -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">{{ 'DatasheetLink' | translate }}</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">link</i>
        <input type="text" class="PartnerSearchInput" placeholder="Enter datasheet URL..."
          [(ngModel)]="RedRowEditCartItemClone.Product.Stats.DatasheetLink" />
      </div>
    </div>

    <!-- Group Name -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">{{ 'GroupName' | translate }}</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">category</i>
        <input type="text" class="PartnerSearchInput" placeholder="Enter group name..."
          [(ngModel)]="RedRowEditCartItemClone.Product.Stats.GroupName" />
      </div>
    </div>

    <!-- Product MOQ (Product.Stats.MOQ) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">MOQ</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">production_quantity_limits</i>
        <input type="number" class="PartnerSearchInput" placeholder="MOQ"
          [(ngModel)]="RedRowEditCartItemClone.Product.Stats.MOQ" min="0" step="1" />
      </div>
    </div>

    <!-- EAN (Product.Stats.EAN) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">EAN</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">qr_code</i>
        <input type="text" class="PartnerSearchInput" placeholder="EAN"
          [(ngModel)]="RedRowEditCartItemClone.Product.Stats.EAN" />
      </div>
    </div>

    <!-- Description (Product.Description) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">Description</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()" style="height: auto; align-items: flex-start;">
        <i class="material-icons search-icon" style="margin-top: 10px;">description</i>
        <textarea class="PartnerSearchInput" placeholder="Description"
          [(ngModel)]="RedRowEditCartItemClone.Product.Description" rows="3" style="resize: vertical; min-height: 60px;"></textarea>
      </div>
    </div>

    <!-- Length -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">{{ 'Length' | translate }}</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">straighten</i>
        <input type="number" class="PartnerSearchInput" placeholder="Enter length..."
          [(ngModel)]="RedRowEditCartItemClone.Product.Stats.Length" min="0" step="0.01" />
      </div>
    </div>

    <!-- Width -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">{{ 'Width' | translate }}</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">swap_horiz</i>
        <input type="number" class="PartnerSearchInput" placeholder="Enter width..."
          [(ngModel)]="RedRowEditCartItemClone.Product.Stats.Width" min="0" step="0.01" />
      </div>
    </div>

    <!-- Height -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">{{ 'Height' | translate }}</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">height</i>
        <input type="number" class="PartnerSearchInput" placeholder="Enter height..."
          [(ngModel)]="RedRowEditCartItemClone.Product.Stats.Height" min="0" step="0.01" />
      </div>
    </div>

    </div>
    <!-- END MASTER-DATA TAB -->

    <!-- ========== AVAILABILITY TAB ========== -->
    <div *ngIf="RedRowEditSelectedTab === 'Availability'" class="RedRowEditTabContent">

    <!-- Current Offer Lead-Time (with backend identification on blur) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">{{ 'CurrentOfferLeadTime' | translate }}
        <span *ngIf="RedRowEditDBOfferLoading" style="font-size: 10px; color: #999; margin-left: 6px;">(loading...)</span>
        <span *ngIf="!RedRowEditDBOfferLoading && RedRowEditDBOfferLeadTimeUIOutput" style="font-size: 10px; color: #666; margin-left: 6px;">(DB: {{ RedRowEditDBOfferLeadTimeUIOutput }})</span>
      </label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">schedule</i>
        <div style="flex: 1; position: relative; display: flex; align-items: center;">
          <div class="lead-time-suggestion-overlay">
            <span style="visibility: hidden;">{{ RedRowEditCartItemClone?.SelectedOffer?.LeadTime?.UIOutput }}</span><span style="color: #777; font-weight: 600;">{{ RedRowEditLeadTimeInlineSuggestion?.substring(RedRowEditCartItemClone?.SelectedOffer?.LeadTime?.UIOutput?.length || 0) }}</span>
          </div>
          <input type="text" class="PartnerSearchInput"
            [(ngModel)]="RedRowEditCartItemClone.SelectedOffer.LeadTime.UIOutput"
            (ngModelChange)="RedRowEditOnLeadTimeSmartInputChange($event)"
            (keydown.tab)="RedRowEditOnLeadTimeSmartInputTab($event)"
            (keydown.enter)="RedRowEditOnLeadTimeSmartInputEnter($event)"
            (keydown.arrowRight)="RedRowEditOnLeadTimeSmartInputArrowRight($event)"
            (blur)="RedRowEditIdentifyLeadTime()"
            autocomplete="off"
            placeholder="e.g., 2 weeks, 1 month"
            style="position: relative; z-index: 2; background: transparent;" />
        </div>
        <i class="material-icons clear-icon" (click)="RedRowEditClearLeadTime()"
          *ngIf="RedRowEditCartItemClone?.SelectedOffer?.LeadTime?.UIOutput?.length > 0" style="color: #d32f2f;">close</i>
      </div>
    </div>

    <!-- Current Stock (SelectedOffer.StockQuantityClone) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">{{ 'CurrentStock' | translate }}</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">store</i>
        <input type="number" class="PartnerSearchInput" placeholder="Enter current stock quantity..."
          [(ngModel)]="RedRowEditCartItemClone.SelectedOffer.StockQuantityClone" min="0" step="1" />
      </div>
    </div>

    <!-- Manufacturer Stock -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">{{ 'ManufacturerStock' | translate }}</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">inventory</i>
        <input type="number" class="PartnerSearchInput" placeholder="Enter manufacturer stock quantity..."
          [(ngModel)]="RedRowEditCartItemClone.Product.Stats.ManufacturerStock" min="0" step="1" />
      </div>
    </div>

    <!-- Manufacturer Stock Lead Time (smart autocomplete) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">{{ 'ManufacturerStockLeadTime' | translate }}</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">schedule</i>
        <div style="flex: 1; position: relative; display: flex; align-items: center;">
          <div class="lead-time-suggestion-overlay">
            <span style="visibility: hidden;">{{ RedRowEditCartItemClone?.Product?.Stats?.ManufacturerStockLeadTime?.UIOutput }}</span><span style="color: #777; font-weight: 600;">{{ RedRowEditManufacturerStockLeadTimeInlineSuggestion?.substring(RedRowEditCartItemClone?.Product?.Stats?.ManufacturerStockLeadTime?.UIOutput?.length || 0) }}</span>
          </div>
          <input type="text" class="PartnerSearchInput"
            [(ngModel)]="RedRowEditCartItemClone.Product.Stats.ManufacturerStockLeadTime.UIOutput"
            (ngModelChange)="RedRowEditOnManufacturerStockLeadTimeSmartInputChange($event)"
            (keydown.tab)="RedRowEditOnManufacturerStockLeadTimeSmartInputTab($event)"
            (keydown.enter)="RedRowEditOnManufacturerStockLeadTimeSmartInputEnter($event)"
            (keydown.arrowRight)="RedRowEditOnManufacturerStockLeadTimeSmartInputArrowRight($event)"
            (blur)="RedRowEditIdentifyManufacturerStockLeadTime()"
            autocomplete="off"
            placeholder="e.g., 2 weeks, 1 month"
            style="position: relative; z-index: 2; background: transparent;" />
        </div>
        <i class="material-icons clear-icon" (click)="RedRowEditClearManufacturerStockLeadTime()"
          *ngIf="RedRowEditCartItemClone?.Product?.Stats?.ManufacturerStockLeadTime?.UIOutput?.length > 0" style="color: #d32f2f;">close</i>
      </div>
    </div>

    <!-- Manufacturer Overrequest Stock Lead Time (smart autocomplete) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel">{{ 'ManufacturerOverrequestStockLeadTime' | translate }}</label>
      <div class="PartnerSearchBar" (click)="$event.stopPropagation()">
        <i class="material-icons search-icon">update</i>
        <div style="flex: 1; position: relative; display: flex; align-items: center;">
          <div class="lead-time-suggestion-overlay">
            <span style="visibility: hidden;">{{ RedRowEditCartItemClone?.Product?.Stats?.ManufacturerOverrequestStockLeadTime?.UIOutput }}</span><span style="color: #777; font-weight: 600;">{{ RedRowEditManufacturerOverrequestStockLeadTimeInlineSuggestion?.substring(RedRowEditCartItemClone?.Product?.Stats?.ManufacturerOverrequestStockLeadTime?.UIOutput?.length || 0) }}</span>
          </div>
          <input type="text" class="PartnerSearchInput"
            [(ngModel)]="RedRowEditCartItemClone.Product.Stats.ManufacturerOverrequestStockLeadTime.UIOutput"
            (ngModelChange)="RedRowEditOnManufacturerOverrequestStockLeadTimeSmartInputChange($event)"
            (keydown.tab)="RedRowEditOnManufacturerOverrequestStockLeadTimeSmartInputTab($event)"
            (keydown.enter)="RedRowEditOnManufacturerOverrequestStockLeadTimeSmartInputEnter($event)"
            (keydown.arrowRight)="RedRowEditOnManufacturerOverrequestStockLeadTimeSmartInputArrowRight($event)"
            (blur)="RedRowEditIdentifyManufacturerOverrequestStockLeadTime()"
            autocomplete="off"
            placeholder="e.g., 4 weeks, 2 months"
            style="position: relative; z-index: 2; background: transparent;" />
        </div>
        <i class="material-icons clear-icon" (click)="RedRowEditClearManufacturerOverrequestStockLeadTime()"
          *ngIf="RedRowEditCartItemClone?.Product?.Stats?.ManufacturerOverrequestStockLeadTime?.UIOutput?.length > 0" style="color: #d32f2f;">close</i>
      </div>
    </div>

    <!-- Trusted Manufacturer Lead Time (iOS-style toggle) -->
    <div class="RedRowEditField">
      <label class="RedRowEditLabel" style="float: unset; margin-top:10px;margin-bottom: 5px;">{{ 'TrustedManufacturerLeadTime' | translate }}</label>
      <div class="RedRowEditToggleContainer">
        <i class="material-icons RedRowEditToggleIcon" [style.color]="RedRowEditCartItemClone?.Product?.Stats?.TrustedManufacturerLeadTime ? '#34c759' : '#999'">verified</i>
        <label class="RedRowEditToggle">
          <input type="checkbox" [(ngModel)]="RedRowEditCartItemClone.Product.Stats.TrustedManufacturerLeadTime" (ngModelChange)="onTrustedManufacturerLeadTimeToggle($event)">
          <span class="RedRowEditToggleSlider"></span>
        </label>
        <span class="RedRowEditToggleLabel">{{ RedRowEditCartItemClone?.Product?.Stats?.TrustedManufacturerLeadTime ? ('Trusted' | translate) : ('NotTrusted' | translate) }}</span>
      </div>
    </div>

    <!-- Product Activated (iOS-style toggle) -->
    <div class="RedRowEditField" *ngIf="RedRowEditCartItemClone?.Product?.ID">
      <label class="RedRowEditLabel" style="float: unset; margin-top:10px;margin-bottom: 5px;">{{ 'ProductActivatedLabel' | translate }}</label>
      <div class="RedRowEditToggleContainer">
        <i class="material-icons RedRowEditToggleIcon" [style.color]="RedRowEditCartItemClone?.Product?.Activated !== false ? '#34c759' : '#f44336'">{{ RedRowEditCartItemClone?.Product?.Activated !== false ? 'visibility' : 'visibility_off' }}</i>
        <label class="RedRowEditToggle">
          <input type="checkbox" [ngModel]="RedRowEditCartItemClone?.Product?.Activated !== false" (ngModelChange)="RedRowEditCartItemClone.Product.Activated = $event">
          <span class="RedRowEditToggleSlider"></span>
        </label>
        <span class="RedRowEditToggleLabel">{{ RedRowEditCartItemClone?.Product?.Activated !== false ? ('Active' | translate) : ('Inactive' | translate) }}</span>
      </div>
      <p class="RedRowEditHelperText">{{ 'ProductActivatedDescription' | translate }}</p>
    </div>

    <!-- Delete Offer Button (only visible when SelectedOffer.ID > 0) -->
    <div class="RedRowEditField" *ngIf="RedRowEditCartItemClone?.SelectedOffer?.ID > 0">
      <button class="GridCommandButton GridCommandButtonRed" style="width: 100%;"
              (click)="OpenDeleteOfferConfirmation()"
              [disabled]="RedRowEditDeletingOffer">
        <mat-spinner *ngIf="RedRowEditDeletingOffer" [diameter]="20" style="display: inline-block;"></mat-spinner>
        <ng-container *ngIf="!RedRowEditDeletingOffer">
          <i class="material-icons">delete</i>
          <span>{{ 'DeleteOfferButton' | translate }}</span>
        </ng-container>
      </button>
    </div>

    </div>
    <!-- END AVAILABILITY TAB -->

    <!-- ========== CONDITIONS TAB ========== -->
    <div *ngIf="RedRowEditSelectedTab === 'Conditions'" class="RedRowEditTabContent">

    <!-- Manufacturing Status (Product.ManufacturingStatus) -->
    <div class="RedRowEditField" style="position: relative; z-index: 104;">
      <label class="RedRowEditLabel">{{ 'ManufacturingStatus' | translate }}</label>
      <div class="SendEmailSearchContainer" (click)="$event.stopPropagation()">
        <!-- Transparent Overlay -->
        <div class="SendEmailOverlayTransparent" *ngIf="showRedRowEditManufacturingStatusDropdown" (click)="showRedRowEditManufacturingStatusDropdown = false"></div>

        <div class="SendEmailSearchBar" (click)="showRedRowEditManufacturingStatusDropdown = !showRedRowEditManufacturingStatusDropdown">
          <i class="material-icons send-email-icon" style="color: #4a7bb8;">precision_manufacturing</i>
          <input type="text" class="SendEmailSearchInput" [value]="RedRowEditCartItemClone?.Product?.ManufacturingStatus?.Name || 'Select...'" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>

        <!-- Dropdown Results -->
        <div class="SendEmailSearchResults" *ngIf="showRedRowEditManufacturingStatusDropdown" style="z-index: 1000;">
          <div class="SendEmailSearchResult" *ngFor="let status of ProductManufacturingStatuses" (click)="selectRedRowEditManufacturingStatus(status)">
            <div class="SendEmailResultMain">
              <i class="material-icons" [style.color]="RedRowEditCartItemClone?.Product?.ManufacturingStatus?.ID === status.ID ? '#4caf50' : '#f44336'">
                {{ RedRowEditCartItemClone?.Product?.ManufacturingStatus?.ID === status.ID ? 'check_circle' : 'cancel' }}
              </i>
              <span class="SendEmailResultLabel">{{ status.Name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Version Status (Product.VersionStatus) -->
    <div class="RedRowEditField" style="position: relative; z-index: 103;">
      <label class="RedRowEditLabel">{{ 'VersionStatus' | translate }}</label>
      <div class="SendEmailSearchContainer" (click)="$event.stopPropagation()">
        <!-- Transparent Overlay -->
        <div class="SendEmailOverlayTransparent" *ngIf="showRedRowEditVersionStatusDropdown" (click)="showRedRowEditVersionStatusDropdown = false"></div>

        <div class="SendEmailSearchBar" (click)="showRedRowEditVersionStatusDropdown = !showRedRowEditVersionStatusDropdown">
          <i class="material-icons send-email-icon" style="color: #4a7bb8;">new_releases</i>
          <input type="text" class="SendEmailSearchInput" [value]="RedRowEditCartItemClone?.Product?.VersionStatus?.Name || 'Select...'" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>

        <!-- Dropdown Results -->
        <div class="SendEmailSearchResults" *ngIf="showRedRowEditVersionStatusDropdown" style="z-index: 1000;">
          <div class="SendEmailSearchResult" *ngFor="let status of ProductVersionStatuses" (click)="selectRedRowEditVersionStatus(status)">
            <div class="SendEmailResultMain">
              <i class="material-icons" [style.color]="RedRowEditCartItemClone?.Product?.VersionStatus?.ID === status.ID ? '#4caf50' : '#f44336'">
                {{ RedRowEditCartItemClone?.Product?.VersionStatus?.ID === status.ID ? 'check_circle' : 'cancel' }}
              </i>
              <span class="SendEmailResultLabel">{{ status.Name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Offer Box Status (uses intermediate variable to avoid ListPriceOffers[0] binding) -->
    <div class="RedRowEditField" style="position: relative; z-index: 102;">
      <label class="RedRowEditLabel">{{ 'BoxStatus' | translate }}</label>
      <div class="SendEmailSearchContainer" (click)="$event.stopPropagation()">
        <!-- Transparent Overlay -->
        <div class="SendEmailOverlayTransparent" *ngIf="showRedRowEditOfferBoxStatusDropdown" (click)="showRedRowEditOfferBoxStatusDropdown = false"></div>

        <div class="SendEmailSearchBar" (click)="showRedRowEditOfferBoxStatusDropdown = !showRedRowEditOfferBoxStatusDropdown">
          <i class="material-icons send-email-icon" style="color: #4a7bb8;">inventory_2</i>
          <input type="text" class="SendEmailSearchInput" [value]="RedRowEditOfferBoxStatus?.Name || 'Select...'" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>

        <!-- Dropdown Results -->
        <div class="SendEmailSearchResults" *ngIf="showRedRowEditOfferBoxStatusDropdown" style="z-index: 1000;">
          <div class="SendEmailSearchResult" *ngFor="let status of ProductBoxStatuses" (click)="selectRedRowEditOfferBoxStatus(status)">
            <div class="SendEmailResultMain">
              <i class="material-icons" [style.color]="RedRowEditOfferBoxStatus?.ID === status.ID ? '#4caf50' : '#f44336'">
                {{ RedRowEditOfferBoxStatus?.ID === status.ID ? 'check_circle' : 'cancel' }}
              </i>
              <span class="SendEmailResultLabel">{{ status.Name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Offer Condition Status (uses intermediate variable to avoid ListPriceOffers[0] binding) -->
    <div class="RedRowEditField" style="position: relative; z-index: 101;">
      <label class="RedRowEditLabel">{{ 'ConditionStatus' | translate }}</label>
      <div class="SendEmailSearchContainer" (click)="$event.stopPropagation()">
        <!-- Transparent Overlay -->
        <div class="SendEmailOverlayTransparent" *ngIf="showRedRowEditOfferConditionStatusDropdown" (click)="showRedRowEditOfferConditionStatusDropdown = false"></div>

        <div class="SendEmailSearchBar" (click)="showRedRowEditOfferConditionStatusDropdown = !showRedRowEditOfferConditionStatusDropdown">
          <i class="material-icons send-email-icon" style="color: #4a7bb8;">verified</i>
          <input type="text" class="SendEmailSearchInput" [value]="RedRowEditOfferConditionStatus?.Name || 'Select...'" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>

        <!-- Dropdown Results -->
        <div class="SendEmailSearchResults" *ngIf="showRedRowEditOfferConditionStatusDropdown" style="z-index: 1000;">
          <div class="SendEmailSearchResult" *ngFor="let status of ProductConditionStatuses" (click)="selectRedRowEditOfferConditionStatus(status)">
            <div class="SendEmailResultMain">
              <i class="material-icons" [style.color]="RedRowEditOfferConditionStatus?.ID === status.ID ? '#4caf50' : '#f44336'">
                {{ RedRowEditOfferConditionStatus?.ID === status.ID ? 'check_circle' : 'cancel' }}
              </i>
              <span class="SendEmailResultLabel">{{ status.Name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>
    <!-- END CONDITIONS TAB -->

    </div>

    <!-- Popup Footer -->
    <div class="ModernPopupFooter">
      <button class="ModernPopupButton secondary" (click)="CloseRedRowEditPopup()" [disabled]="RedRowEditSaving">
        <i class="material-icons">close</i>
        <span>Cancel</span>
      </button>
      <!-- ✅ OK button - apply changes locally without DB save -->
      <button class="ModernPopupButton secondary" (click)="SaveRedRowEdit()" [disabled]="RedRowEditSaving">
        <i class="material-icons">check</i>
        <span>OK</span>
      </button>
      <!-- ✅ Save button (with DB save) - ONLY for AwaitingSelection (status -1) -->
      <button class="ModernPopupButton primary" *ngIf="CurrentRedRowEditCartItem?.CartItemStatus?.ID === -1" (click)="SaveRedRowEditAndSaveToDatabase()" [disabled]="RedRowEditSaving">
        <mat-spinner *ngIf="RedRowEditSaving" [diameter]="16" style="margin-right: 8px;"></mat-spinner>
        <i class="material-icons" *ngIf="!RedRowEditSaving">save</i>
        <span>{{ RedRowEditSaving ? 'Saving...' : 'Save' }}</span>
      </button>
      <!-- ✅ Save/Save New button - for all other statuses -->
      <!-- For RED ROWS (status 0): Always save to DB (creates new product) -->
      <!-- For VALID ROWS (status 1): Save to DB if product has ID -->
      <!-- Changes to "Save New" with green background when supplier changed (new offer will be created) -->
      <button class="ModernPopupButton"
              [ngClass]="RedRowEditIsNewOffer || CurrentRedRowEditCartItem?.CartItemStatus?.ID === 0 ? 'success' : 'primary'"
              *ngIf="CurrentRedRowEditCartItem?.CartItemStatus?.ID !== -1"
              (click)="SaveRedRowEditAndSaveToDatabase()"
              [disabled]="RedRowEditSaving">
        <mat-spinner *ngIf="RedRowEditSaving" [diameter]="16" style="margin-right: 6px;"></mat-spinner>
        <i class="material-icons" *ngIf="!RedRowEditSaving">{{ (RedRowEditIsNewOffer || CurrentRedRowEditCartItem?.CartItemStatus?.ID === 0) ? 'add' : 'save' }}</i>
        <span>{{ RedRowEditSaving ? 'Saving...' : ((RedRowEditIsNewOffer || CurrentRedRowEditCartItem?.CartItemStatus?.ID === 0) ? 'Save New' : ('Save' | translate)) }}</span>
      </button>
    </div>

  </div>
</div>

<!-- ✅ Delete Offer Confirmation Popup (stacked over Red Row Edit popup) -->
<div class="ModernPopupOverlay ModernPopupOverlayTop" *ngIf="ShowDeleteOfferConfirmation" (click)="CancelDeleteOffer()">
  <div class="ModernPopup" style="width: 420px; min-height: auto;" (click)="$event.stopPropagation()">
    <!-- Popup Header -->
    <div class="ModernPopupHeader" style="padding: 16px 20px;">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #f44336;">warning</i>
        <span>{{ 'DeleteOfferConfirmTitle' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="CancelDeleteOffer()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Popup Body -->
    <div class="ModernPopupBody" style="padding: 24px; text-align: center; padding-bottom: 0;">
      <i class="material-icons" style="font-size: 48px; color: #f44336; margin-bottom: 12px;">delete_forever</i>
      <p style="margin: 0; font-size: 14px; color: #666; line-height: 1.5;">
        {{ 'DeleteOfferConfirmDescription' | translate }}
      </p>
    </div>

    <!-- Popup Footer -->
    <div class="ModernPopupFooter" style="display: flex; gap: 10px; justify-content: flex-end; padding: 16px 20px;">
      <button class="ModernPopupButton outline" (click)="CancelDeleteOffer()" [disabled]="RedRowEditDeletingOffer">
        <span>{{ 'No' | translate }}</span>
      </button>
      <button class="ModernPopupButton danger" (click)="ConfirmDeleteOffer()" [disabled]="RedRowEditDeletingOffer">
        <mat-spinner *ngIf="RedRowEditDeletingOffer" [diameter]="16" style="margin-right: 6px;"></mat-spinner>
        <i class="material-icons" *ngIf="!RedRowEditDeletingOffer">delete</i>
        <span>{{ 'Yes' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<div class="NewQuotationMainContent">

  <!-- Transparent Overlay (closes search results when clicking outside) -->
  <div class="SearchOverlayTransparent" *ngIf="showPartnerResults" (click)="showPartnerResults = false"></div>
  <div class="SearchOverlayTransparent" *ngIf="showCurrencyResults" (click)="showCurrencyResults = false"></div>
  <div class="SearchOverlayTransparent" *ngIf="showSendEmailResults" (click)="showSendEmailResults = false"></div>

  <!-- Page Title -->
  <div class="QuotationPageHeader">
    <div class="QuotationPageTitle">
      <i class="material-icons">description</i>
      <span>{{'RequestedIndividualItems' | translate}}</span>
    </div>
    <div class="QuotationPageTitle QuotationPageTitleRight">
      <span>{{'OfferingAgent' | translate}}: {{parent.User?.Email}}</span>
      <i class="material-icons">person</i>
    </div>
    <div style="clear: both;"></div>
    <div class="QuotationPageSubtitle">
      {{'RequestedIndividualItems' | translate}}
    </div>
  </div>

  <!-- ✅ Revert Confirmation Popup -->
  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowRevertConfirmationPopup" style="width: 380px; left: calc(50% - 190px); top: 30%;">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="CancelRevertRow()">close</i>
    </div>
    <div class="InfoQuestionTitle" style="font-size: 16px; font-weight: 500; padding: 20px 24px; border-bottom: 1px solid #e5e7eb;">
      Revert to Original Values
    </div>
    <div class="InfoQuestionBody" style="text-align: center; padding: 20px 24px;">
      <p style="margin-bottom: 8px; font-size: 13px; color: #333; line-height: 1.5;">Do you want to revert this row to its original values?</p>
      <p style="font-size: 12px; color: #999; margin: 0; line-height: 1.4;">This will undo all manual edits.</p>
    </div>
    <div style="display: flex; gap: 10px; justify-content: flex-end; padding: 16px 24px; border-top: 1px solid #e5e7eb; background: #f9fafb;">
      <button mat-stroked-button
              (click)="CancelRevertRow()"
              style="color: #666;
                     font-weight: 500;
                     font-size: 13px;
                     padding: 6px 20px;
                     border-radius: 4px;
                     border: 1px solid #d1d5db;
                     cursor: pointer;
                     min-width: auto;">
        Cancel
      </button>
      <button mat-raised-button
              (click)="ConfirmRevertRow()"
              style="background-color: #32aa3a;
                     color: white;
                     font-weight: 500;
                     font-size: 13px;
                     padding: 6px 20px;
                     border-radius: 4px;
                     border: none;
                     cursor: pointer;
                     min-width: auto;">
        Revert
      </button>
    </div>
  </div>

  <!-- ✅ Order Confirmation Popup - ModernPopup style -->
  <div class="ModernPopupOverlay ModernPopupOverlayTop" *ngIf="AskAddNewRFQasPOQuestion" (click)="AskAddNewRFQasPOQuestion = false;">
    <div class="ModernPopup" style="width: 50%; max-width: 700px; max-height: 90vh;" (click)="$event.stopPropagation()">
      <!-- Popup Header -->
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons" style="color: #4caf50;">shopping_cart</i>
          <span>{{ 'AskSendAsOrderConfirmationQuestion' | translate }}</span>
        </div>
        <button class="ModernPopupClose" (click)="AskAddNewRFQasPOQuestion = false;">
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Popup Body -->
      <div class="ModernPopupBody" style="padding: 20px 24px; overflow-y: auto; max-height: calc(90vh - 140px); padding-bottom: 0;">

      <!-- Contact Info Section -->
      <div class="ModernFormSection" style="width: 100%; margin-bottom: 20px;">
        <div class="ModernFormSectionHeader AppleSectionHeader" (click)="toggleSection('contactInfoOC')">
          <div class="AppleSectionHeaderLeft">
            <i class="material-icons AppleSectionIcon">contact_mail</i>
            <span class="AppleSectionTitle">{{ 'ContactInfoSection' | translate }}</span>
          </div>
          <i class="material-icons AppleSectionChevron" [class.collapsed]="sectionCollapsed['contactInfoOC']">expand_more</i>
        </div>

        <div class="AppleSectionContent" *ngIf="!sectionCollapsed['contactInfoOC']">
        <!-- Send Email Dropdown -->
        <div class="SendEmailSearchContainer" style="float:left; margin-top: 20px;">
        <!-- Transparent Overlay for Send Email Dropdown -->
        <div class="SendEmailOverlayTransparent" *ngIf="showSendEmailResults" (click)="showSendEmailResults = false"></div>

        <div class="SendEmailSearchBar" (click)="onSendEmailFocus()">
          <span class="send-email-label">Send Email</span>
          <i class="material-icons send-email-icon" [style.color]="SendEmail ? '#4caf50' : '#f44336'">
            {{ SendEmail ? 'check_circle' : 'cancel' }}
          </i>
          <input
            type="text"
            class="SendEmailSearchInput"
            [value]="getSendEmailLabel()"
            readonly
          />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>

        <!-- Send Email Results Dropdown -->
        <div class="SendEmailSearchResults" *ngIf="showSendEmailResults">
          <div class="SendEmailSearchResult" *ngFor="let option of sendEmailOptions" (click)="selectSendEmailOption(option)">
            <div class="SendEmailResultMain">
              <i class="material-icons" [style.color]="option.value ? '#4caf50' : '#f44336'">
                {{ option.value ? 'check_circle' : 'cancel' }}
              </i>
              <span class="SendEmailResultLabel">{{option.label}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ✅ Partner Agents Dropdown (Custom Style - Multi-select) -->
      <div class="CustomDropdownContainer" *ngIf="this.parent.B2BPartner?.PartnerAgents?.length > 0">
        <div class="SendEmailOverlayTransparent" *ngIf="showAgentsResults" (click)="showAgentsResults = false"></div>

        <div class="CustomDropdownBar" (click)="onAgentsFocus()">
          <span class="dropdown-label">{{ 'SelectAgents' | translate }}</span>
          <i class="material-icons dropdown-icon-left">people</i>
          <i class="material-icons send-email-icon" [style.color]="selectedAgents.length > 0 ? '#4caf50' : '#f44336'">
            {{ selectedAgents.length > 0 ? 'check_circle' : 'cancel' }}
          </i>
          <input
            type="text"
            class="CustomDropdownInput"
            [class.placeholder]="selectedAgents.length === 0"
            [value]="getAgentsLabel()"
            readonly
          />
          <span class="selected-count" *ngIf="selectedAgents.length > 0">{{selectedAgents.length}}</span>
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>

        <div class="CustomDropdownResults" *ngIf="showAgentsResults">
          <!-- ✅ First Row: Email Input for Adding New Agent -->
          <div class="CustomDropdownResult NewAgentInputRow">
            <div class="NewAgentInputColumn">
              <div class="NewAgentInputWrapper">
                <i class="material-icons" style="color: #f60; margin-right: 8px;">person_add</i>
                <input
                  type="email"
                  class="NewAgentEmailInput"
                  [(ngModel)]="newAgentEmail"
                  (input)="onNewAgentEmailChange()"
                  placeholder="Enter email to add new agent..."
                  (click)="$event.stopPropagation()"
                />
              </div>
              <button
                *ngIf="isValidEmail"
                class="NewAgentAddButton"
                (click)="createNewAgentFromEmail(); $event.stopPropagation()"
                type="button">
                <i class="material-icons">check</i>
                <span>{{ 'AddNewAgent' | translate }}</span>
              </button>
            </div>
          </div>

          <!-- ✅ Existing Agents List -->
          <div class="CustomDropdownResult"
               *ngFor="let agent of this.parent.B2BPartner.PartnerAgents"
               (click)="toggleAgent(agent)">
            <div class="CustomDropdownResultMain">
              <i class="material-icons" [style.color]="isAgentSelected(agent) ? '#4caf50' : '#f44336'">
                {{ isAgentSelected(agent) ? 'check_circle' : 'cancel' }}
              </i>
              <span class="CustomDropdownResultText">{{agent.Name}} - {{agent.Email}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Customer Internal Reference -->
      <div class="ModernFormGroup" style="width: 100%; margin-top: 10px;">
        <input type="text" class="ModernFormInput ModernFormInputOrange"
               placeholder="{{ 'CustomerInternalReferenceNumber' | translate }} ({{ 'Recommended' | translate }})"
               [(ngModel)]="parent.OfferRequest.DebatorPO" />
      </div>
        </div>
      </div>

      <!-- Terms Section -->
      <div class="ModernFormSection" style="width: 100%; margin-bottom: 20px;">
        <div class="ModernFormSectionHeader AppleSectionHeader" (click)="toggleSection('termsOC')">
          <div class="AppleSectionHeaderLeft">
            <i class="material-icons AppleSectionIcon">receipt_long</i>
            <span class="AppleSectionTitle">{{ 'TermsSection' | translate }}</span>
          </div>
          <i class="material-icons AppleSectionChevron" [class.collapsed]="sectionCollapsed['termsOC']">expand_more</i>
        </div>

        <div class="AppleSectionContent" *ngIf="!sectionCollapsed['termsOC']">
        <!-- Payment Term Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showPaymentTermDropdownOC" (click)="showPaymentTermDropdownOC = false"></div>
          <div class="CustomDropdownBar" (click)="showPaymentTermDropdownOC = !showPaymentTermDropdownOC">
            <span class="dropdown-label">{{ 'SelectPaymentTerm' | translate }}</span>
            <i class="material-icons dropdown-icon-left">receipt_long</i>
            <i class="material-icons send-email-icon" [style.color]="selectedPaymentTerms?.ID ? '#4caf50' : '#f44336'">
              {{ selectedPaymentTerms?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!selectedPaymentTerms" [value]="selectedPaymentTerms?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showPaymentTermDropdownOC">
            <div class="CustomDropdownResult" *ngFor="let term of parent.CartMasterData?.PaymentTerms" (click)="selectPaymentTerms(term); showPaymentTermDropdownOC = false;">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="selectedPaymentTerms?.ID === term.ID ? '#4caf50' : '#f44336'">
                  {{ selectedPaymentTerms?.ID === term.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{ term.Name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Payment Type Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showPaymentTypeDropdownOC" (click)="showPaymentTypeDropdownOC = false"></div>
          <div class="CustomDropdownBar" (click)="showPaymentTypeDropdownOC = !showPaymentTypeDropdownOC">
            <span class="dropdown-label">{{ 'SelectPaymentType' | translate }}</span>
            <i class="material-icons dropdown-icon-left">payment</i>
            <i class="material-icons send-email-icon" [style.color]="selectedPaymentType?.ID ? '#4caf50' : '#f44336'">
              {{ selectedPaymentType?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!selectedPaymentType" [value]="selectedPaymentType?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showPaymentTypeDropdownOC">
            <div class="CustomDropdownResult" *ngFor="let type of parent.CartMasterData?.PaymentTypes" (click)="selectPaymentType(type); showPaymentTypeDropdownOC = false;">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="selectedPaymentType?.ID === type.ID ? '#4caf50' : '#f44336'">
                  {{ selectedPaymentType?.ID === type.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{ type.Name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Discount Row -->
        <div class="CustomDropdownContainer" style="margin-top: 12px;">
          <div style="display: flex; align-items: center; gap: 8px; width: 100%;">
            <span style="font-size: 13px; font-weight: 500; color: #6c757d; min-width: 70px;">{{ 'Discount' | translate }}:</span>
            <!-- Discount Type Dropdown -->
            <div style="flex: 1; min-width: 120px; max-width: 150px;">
              <div class="SendEmailOverlayTransparent" *ngIf="showDiscountTypeDropdownOC" (click)="showDiscountTypeDropdownOC = false"></div>
              <div class="CustomDropdownBar" (click)="showDiscountTypeDropdownOC = !showDiscountTypeDropdownOC" style="height: 36px;">
                <i class="material-icons dropdown-icon-left" style="font-size: 18px;">percent</i>
                <input type="text" class="CustomDropdownInput" readonly
                       [class.placeholder]="!parent.Cart?.Total?.Discount?.Type"
                       [value]="parent.Cart?.Total?.Discount?.Type?.Name || 'Select...'"
                       style="font-size: 12px;" />
                <i class="material-icons dropdown-icon" style="font-size: 18px;">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showDiscountTypeDropdownOC">
                <div class="CustomDropdownResult" *ngFor="let type of parent.masterData?.DiscountTypes"
                     (click)="selectDiscountType(type, 'OC')">
                  <div class="CustomDropdownResultMain">
                    <span class="CustomDropdownResultText">{{type.Name}}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Discount Value Input -->
            <div style="flex: 0 0 80px;">
              <div class="CustomDropdownBar" style="height: 36px; padding: 0 8px;">
                <input type="text" class="CustomDropdownInput"
                       [(ngModel)]="parent.Cart.Total.Discount.Value"
                       (keypress)="validateDiscountInput($event)"
                       placeholder="0"
                       style="font-size: 12px; text-align: center;" />
              </div>
            </div>
            <!-- Apply Button -->
            <button class="GridCommandButton GridCommandButtonBlue" (click)="ApplyOrderConfirmationDiscount()"
                    [disabled]="!parent.Cart?.Total?.Discount?.Type || !parent.Cart?.Total?.Discount?.Value"
                    style="height: 36px; width: 36px; padding: 0; min-width: 36px;">
              <i class="material-icons" style="font-size: 18px;">check</i>
            </button>
            <!-- Clear Button -->
            <button class="GridCommandButton GridCommandButtonRed" (click)="ClearOrderConfirmationDiscount()"
                    [disabled]="!parent.Cart?.Total?.Discount?.Type && !parent.Cart?.Total?.Discount?.Value"
                    style="height: 36px; width: 36px; padding: 0; min-width: 36px;">
              <i class="material-icons" style="font-size: 18px;">close</i>
            </button>
          </div>
        </div>

        <!-- ✅ Totals Section (like offers page) -->
        <div class="totals-section" *ngIf="parent.Cart?.Total" style="margin-top: 12px;">
          <!-- Subtotal (from OriginalTotal - before any project discount) -->
          <div class="total-row subtotal-row">
            <span class="total-label">{{'Subtotal' | translate}}:</span>
            <span class="total-value subtotal-value">{{ parent.Cart.OriginalTotal?.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ parent.Cart?.Currency?.Symbol }}</span>
          </div>

          <!-- Project Discount Row (only shown if discount exists) -->
          <div class="total-row discount-row" *ngIf="parent.Cart.Total?.Discount?.Value > 0">
            <span class="total-label discount-label">
              {{'ProjectDiscount' | translate}}
              (<ng-container *ngIf="parent.Cart.Total.Discount.Type?.ID === 1">{{ parent.Cart.Total.Discount.Value | number:'1.2-2' }}%</ng-container><ng-container *ngIf="parent.Cart.Total.Discount.Type?.ID === 2">{{ parent.Cart.Total.Discount.Value | number:'1.2-2' }} {{ parent.Cart?.Currency?.Symbol }}</ng-container>):
            </span>
            <span class="total-value discount-value">- {{ getProjectDiscountAmount() }} {{ parent.Cart?.Currency?.Symbol }}</span>
          </div>

          <!-- Subtotal After Discount (only shown if discount exists) -->
          <div class="total-row subtotal-after-discount-row" *ngIf="parent.Cart.Total?.Discount?.Value > 0">
            <span class="total-label">{{'SubtotalAfterDiscount' | translate}}:</span>
            <span class="total-value">{{ parent.Cart.Total.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ parent.Cart?.Currency?.Symbol }}</span>
          </div>

          <!-- Shipping + Purchase Total Row (side by side) -->
          <div class="shipping-purchase-row">
            <div class="total-row shipping-row">
              <span class="total-label">{{'ShippingCost' | translate}}:</span>
              <span class="total-value shipping-value">{{ parent.Cart.ShippingCost?.UIUnitPrice != null ? (parent.Cart.ShippingCost.UIUnitPrice | number:'1.2-2') : '--,--' }} {{ parent.Cart?.Currency?.Symbol }}</span>
            </div>
            <div class="total-row purchase-total-row" *ngIf="parent.Cart.PurchaseTotal?.TotalQtyPriceNOVAT > 0">
              <span class="total-label">{{'PurchaseTotalNoVAT' | translate}}:</span>
              <span class="total-value">{{ parent.Cart.PurchaseTotal.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ parent.Cart.PurchaseTotal?.Currency?.Symbol || parent.Cart?.Currency?.Symbol }}</span>
            </div>
          </div>
          <!-- Pure Profit Row -->
          <div class="total-row pure-profit-row" *ngIf="parent.Cart.Total?.TotalPureProfit != null" [ngClass]="{'profit-positive': parent.Cart.Total.TotalPureProfit > 0, 'profit-negative': parent.Cart.Total.TotalPureProfit < 0}">
            <span class="total-label">{{'PureProfit' | translate}}:</span>
            <span class="total-value">{{ parent.Cart.Total.TotalPureProfit | number:'1.2-2' }} {{ parent.Cart?.Currency?.Symbol }}</span>
          </div>

          <!-- Final Total (Subtotal + Shipping) -->
          <div class="total-row absolute-total-row">
            <span class="total-label">{{'GrandTotal' | translate}}:</span>
            <span class="total-value absolute-total-value">{{ getAbsoluteTotal() }} {{ parent.Cart?.Currency?.Symbol }}</span>
          </div>
        </div>
        </div>
      </div>

      <!-- Shipping Section -->
      <div class="ModernFormSection" style="width: 100%; margin-bottom: 20px;">
        <div class="ModernFormSectionHeader AppleSectionHeader" (click)="toggleSection('shippingOC')">
          <div class="AppleSectionHeaderLeft">
            <i class="material-icons AppleSectionIcon">local_shipping</i>
            <span class="AppleSectionTitle">{{ 'ShippingSection' | translate }}</span>
          </div>
          <i class="material-icons AppleSectionChevron" [class.collapsed]="sectionCollapsed['shippingOC']">expand_more</i>
        </div>

        <div class="AppleSectionContent" *ngIf="!sectionCollapsed['shippingOC']">
        <!-- Shipping Company Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showShippingCompanyDropdownOC" (click)="showShippingCompanyDropdownOC = false"></div>
          <div class="CustomDropdownBar" (click)="showShippingCompanyDropdownOC = !showShippingCompanyDropdownOC">
            <span class="dropdown-label">{{ 'SelectShippingCompany' | translate }}</span>
            <i class="material-icons dropdown-icon-left">local_shipping</i>
            <i class="material-icons send-email-icon" [style.color]="selectedShippingCompany?.ID ? '#4caf50' : '#f44336'">
              {{ selectedShippingCompany?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!selectedShippingCompany" [value]="selectedShippingCompany?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showShippingCompanyDropdownOC">
            <div class="CustomDropdownResult" *ngFor="let company of parent.CartMasterData?.ShippingCompanies" (click)="selectShippingCompany(company); showShippingCompanyDropdownOC = false;">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="selectedShippingCompany?.ID === company.ID ? '#4caf50' : '#f44336'">
                  {{ selectedShippingCompany?.ID === company.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{ company.Name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Shipping Cost Input -->
        <div class="CustomDropdownContainer">
          <div class="PartnerSearchBar">
            <i class="material-icons search-icon">payments</i>
            <input type="number" class="PartnerSearchInput"
                   placeholder="{{ 'ShippingCost' | translate }}"
                   [(ngModel)]="parent.Cart.ShippingCost.UIUnitPrice"
                   step="0.01" min="0" />
            <span style="margin-left: 8px; font-weight: 600; color: #666;">{{parent.Cart?.Currency?.Symbol || parent.Cart?.Currency?.Name || ''}}</span>
          </div>
        </div>

        <!-- Weight Input -->
        <div class="CustomDropdownContainer">
          <div class="PartnerSearchBar">
            <i class="material-icons search-icon">scale</i>
            <input type="text" class="PartnerSearchInput"
                   placeholder="{{ 'Weight' | translate }}"
                   [(ngModel)]="parent.Cart.Weight"
                   (ngModelChange)="validateWeightInput()"
                   (keypress)="allowOnlyNumbersAndDot($event)"
                   (blur)="validateWeightInput()" />
          </div>
        </div>

        <!-- Weight Measurement Type Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showWeightMeasurementTypeDropdownOC" (click)="showWeightMeasurementTypeDropdownOC = false"></div>
          <div class="CustomDropdownBar" (click)="showWeightMeasurementTypeDropdownOC = !showWeightMeasurementTypeDropdownOC">
            <span class="dropdown-label">{{ 'WeightMeasurementType' | translate }}</span>
            <i class="material-icons dropdown-icon-left">straighten</i>
            <i class="material-icons send-email-icon" [style.color]="parent.Cart.WeightMeasurementType?.ID ? '#4caf50' : '#f44336'">
              {{ parent.Cart.WeightMeasurementType?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!parent.Cart.WeightMeasurementType" [value]="parent.Cart.WeightMeasurementType?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showWeightMeasurementTypeDropdownOC">
            <div class="CustomDropdownResult" *ngFor="let wmt of WeightMeasurementTypes" (click)="selectWeightMeasurementType(wmt); showWeightMeasurementTypeDropdownOC = false;">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="parent.Cart.WeightMeasurementType?.ID === wmt.ID ? '#4caf50' : '#f44336'">
                  {{ parent.Cart.WeightMeasurementType?.ID === wmt.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{ wmt.Name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Shipping Responsability Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showShippingResponsabilityDropdownOC" (click)="showShippingResponsabilityDropdownOC = false"></div>
          <div class="CustomDropdownBar" (click)="showShippingResponsabilityDropdownOC = !showShippingResponsabilityDropdownOC">
            <span class="dropdown-label">{{ 'SelectShippingResponsability' | translate }}</span>
            <i class="material-icons dropdown-icon-left">assignment_ind</i>
            <i class="material-icons send-email-icon" [style.color]="selectedShippingResponsability?.ID ? '#4caf50' : '#f44336'">
              {{ selectedShippingResponsability?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!selectedShippingResponsability" [value]="selectedShippingResponsability?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showShippingResponsabilityDropdownOC">
            <div class="CustomDropdownResult" *ngFor="let resp of parent.CartMasterData?.ShippingResponsabilities" (click)="selectShippingResponsability(resp); showShippingResponsabilityDropdownOC = false;">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="selectedShippingResponsability?.ID === resp.ID ? '#4caf50' : '#f44336'">
                  {{ selectedShippingResponsability?.ID === resp.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{ resp.Name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Insurance Toggle (shown when RequiresInsurance is not null) -->
        <div class="InsuranceToggleContainer" *ngIf="selectedShippingResponsability?.RequiresInsurance != null">
          <mat-slide-toggle
            class="InsuranceToggle"
            [(ngModel)]="parent.Cart.HasInsurance"
            matTooltip="{{ 'RequestProductsInsuranceDescription' | translate }}"
            matTooltipClass="neutral-tool-tip">
          </mat-slide-toggle>
          <span class="InsuranceToggleLabel">{{ 'RequestProductsInsurance' | translate }}</span>
        </div>

        <!-- Shipping Service Type Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showShippingServiceTypeDropdownOC" (click)="showShippingServiceTypeDropdownOC = false"></div>
          <div class="CustomDropdownBar" (click)="showShippingServiceTypeDropdownOC = !showShippingServiceTypeDropdownOC">
            <span class="dropdown-label">{{ 'SelectShippingServiceType' | translate }}</span>
            <i class="material-icons dropdown-icon-left">speed</i>
            <i class="material-icons send-email-icon" [style.color]="selectedShippingServiceType?.ID ? '#4caf50' : '#f44336'">
              {{ selectedShippingServiceType?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!selectedShippingServiceType" [value]="selectedShippingServiceType?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showShippingServiceTypeDropdownOC">
            <div class="CustomDropdownResult" *ngFor="let serviceType of parent.CartMasterData?.ShippingServiceTypes" (click)="selectShippingServiceType(serviceType); showShippingServiceTypeDropdownOC = false;">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="selectedShippingServiceType?.ID === serviceType.ID ? '#4caf50' : '#f44336'">
                  {{ selectedShippingServiceType?.ID === serviceType.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{ serviceType.Name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Delivery Preference Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showDeliveryPreferenceResults" (click)="showDeliveryPreferenceResults = false"></div>
          <div class="CustomDropdownBar" (click)="onDeliveryPreferenceFocus()" [class.disabled]="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true">
            <span class="dropdown-label">{{ 'SelectDeliveryPrefference' | translate }}</span>
            <i class="material-icons dropdown-icon-left">local_shipping</i>
            <i class="material-icons send-email-icon" [style.color]="this.parent.Cart?.DeliveryPreference?.ID ? '#4caf50' : '#f44336'">
              {{ this.parent.Cart?.DeliveryPreference?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.parent.Cart?.DeliveryPreference?.Name" [value]="getDeliveryPreferenceLabel()" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showDeliveryPreferenceResults">
            <div class="CustomDropdownResult" *ngFor="let d of this.parent.CartMasterData.DeliveryPreferences" (click)="selectDeliveryPreference(d)" [matTooltip]="d.Description" matTooltipClass='neutral-tool-tip'>
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="this.parent.Cart?.DeliveryPreference?.ID === d.ID ? '#4caf50' : '#f44336'">
                  {{ this.parent.Cart?.DeliveryPreference?.ID === d.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{d.Name}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="DeliveryPrefferenceBlockedForChange" *ngIf="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true;">
          <i class="material-icons">info_outline</i>
          <span>{{this.parent.Cart?.DeliveryPreference?.BlockedForChangeDescription}}</span>
        </div>

        <!-- Shipping Address Dropdown -->
        <div class="CustomDropdownContainer" *ngIf="this.parent.B2BPartner?.ShippingAddresses?.length > 0">
          <div class="SendEmailOverlayTransparent" *ngIf="showShippingAddressResults" (click)="showShippingAddressResults = false"></div>
          <div class="CustomDropdownBar" (click)="onShippingAddressFocus()">
            <span class="dropdown-label">{{ 'ShippingAddress' | translate }}</span>
            <i class="material-icons dropdown-icon-left">location_on</i>
            <i class="material-icons send-email-icon" [style.color]="this.parent.OfferRequest?.ShippingAddress?.ID ? '#4caf50' : '#f44336'">
              {{ this.parent.OfferRequest?.ShippingAddress?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.parent.OfferRequest?.ShippingAddress" [value]="getShippingAddressLabel(false)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showShippingAddressResults">
            <div class="CustomDropdownResult" *ngFor="let addr of this.parent.B2BPartner.ShippingAddresses" (click)="selectShippingAddress(addr, false)">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="this.parent.OfferRequest.ShippingAddress?.ID === addr.ID ? '#4caf50' : '#f44336'">
                  {{ this.parent.OfferRequest.ShippingAddress?.ID === addr.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{addr.Country?.Name}} - {{addr.City}} - {{addr.AddressLine}}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Order Consolidation Type Dropdown -->
        <div class="CustomDropdownContainer" *ngIf="this.OfferRequestMasterData?.OrderConsolidationTypes?.length > 0">
          <div class="SendEmailOverlayTransparent" *ngIf="showConsolidationTypeResults" (click)="showConsolidationTypeResults = false"></div>
          <div class="CustomDropdownBar" (click)="onConsolidationTypeFocus()">
            <span class="dropdown-label">{{ 'OrderConsolidationType' | translate }}</span>
            <i class="material-icons dropdown-icon-left">inventory_2</i>
            <i class="material-icons send-email-icon" [style.color]="this.parent.OfferRequest?.ConsolidationType?.ID ? '#4caf50' : '#f44336'">
              {{ this.parent.OfferRequest?.ConsolidationType?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.parent.OfferRequest?.ConsolidationType" [value]="getConsolidationTypeLabel(false)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showConsolidationTypeResults">
            <div class="CustomDropdownResult" *ngFor="let type of this.OfferRequestMasterData.OrderConsolidationTypes" (click)="selectConsolidationType(type, false)" [matTooltip]="type.Description" matTooltipClass='neutral-tool-tip'>
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="this.parent.OfferRequest.ConsolidationType?.ID === type.ID ? '#4caf50' : '#f44336'">
                  {{ this.parent.OfferRequest.ConsolidationType?.ID === type.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{type.Name}}</span>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>

      <!-- Popup Footer -->
      <div class="ModernPopupFooter" style="display: flex; gap: 12px; justify-content: flex-end; padding: 16px 20px; border-top: 1px solid #e5e7eb; background: #f9fafb;">
        <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="AskAddNewRFQasPOQuestion = false;">
          {{ 'Configuration.DeleteNoButton' | translate }}
        </button>
        <button class="ModernButton success" [disabled]="this.parent.loading" (click)="this.AddNewOfferRequest(true, this.parent.Cart);">
          <i class="material-icons" *ngIf="!this.parent.loading">arrow_forward</i>
          <mat-spinner *ngIf="this.parent.loading" [diameter]="18" style="margin-right: 8px;"></mat-spinner>
          {{ 'RegisterasClientOrderConfirmation' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- ✅ Add New RFQ Popup - ModernPopup style -->
  <div class="ModernPopupOverlay" *ngIf="AskAddNewRFQQuestion" (click)="AskAddNewRFQQuestion = false;">
    <div class="ModernPopup" style="width: 50%; max-width: 700px; max-height: 85vh;" (click)="$event.stopPropagation()">
      <!-- Popup Header -->
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons" style="color: #f60;">request_quote</i>
          <span>{{ 'AskAddNewRFQQuestion' | translate }}</span>
        </div>
        <button class="ModernPopupClose" (click)="AskAddNewRFQQuestion = false;">
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Popup Body -->
      <div class="ModernPopupBody" style="padding: 20px 24px; overflow-y: auto; max-height: calc(85vh - 140px); padding-bottom: 0;">
      <p>{{ 'AskAddNewRFQQuestionDescription' | translate }}</p>
      <p class="Disclaimer">{{'QuotationDisclaimer' | translate}}</p>

      <!-- Shipping Section -->
      <div class="ModernFormSection" style="width: 100%; margin-bottom: 20px;">
        <div class="ModernFormSectionHeader AppleSectionHeader" (click)="toggleSection('shippingRFQ')">
          <div class="AppleSectionHeaderLeft">
            <i class="material-icons AppleSectionIcon">local_shipping</i>
            <span class="AppleSectionTitle">{{ 'ShippingSection' | translate }}</span>
          </div>
          <i class="material-icons AppleSectionChevron" [class.collapsed]="sectionCollapsed['shippingRFQ']">expand_more</i>
        </div>

        <div class="AppleSectionContent" *ngIf="!sectionCollapsed['shippingRFQ']">
        <!-- Delivery Preference Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showDeliveryPreferenceResults" (click)="showDeliveryPreferenceResults = false"></div>
          <div class="CustomDropdownBar" (click)="onDeliveryPreferenceFocus()" [class.disabled]="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true">
            <span class="dropdown-label">{{ 'SelectDeliveryPrefference' | translate }}</span>
            <i class="material-icons dropdown-icon-left">local_shipping</i>
            <i class="material-icons send-email-icon" [style.color]="this.parent.Cart?.DeliveryPreference?.ID ? '#4caf50' : '#f44336'">
              {{ this.parent.Cart?.DeliveryPreference?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.parent.Cart?.DeliveryPreference?.Name" [value]="getDeliveryPreferenceLabel()" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showDeliveryPreferenceResults">
            <div class="CustomDropdownResult" *ngFor="let d of this.parent.CartMasterData.DeliveryPreferences" (click)="selectDeliveryPreference(d)" [matTooltip]="d.Description" matTooltipClass='neutral-tool-tip'>
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="this.parent.Cart?.DeliveryPreference?.ID === d.ID ? '#4caf50' : '#f44336'">
                  {{ this.parent.Cart?.DeliveryPreference?.ID === d.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{d.Name}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="DeliveryPrefferenceBlockedForChange" *ngIf="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true;">
          <i class="material-icons">info_outline</i>
          <span>{{this.parent.Cart?.DeliveryPreference?.BlockedForChangeDescription}}</span>
        </div>

        <!-- Shipping Address Dropdown -->
        <div class="CustomDropdownContainer" *ngIf="this.parent.B2BPartner?.ShippingAddresses?.length > 0">
          <div class="SendEmailOverlayTransparent" *ngIf="showShippingAddressResults" (click)="showShippingAddressResults = false"></div>
          <div class="CustomDropdownBar" (click)="onShippingAddressFocus()">
            <span class="dropdown-label">{{ 'ShippingAddress' | translate }}</span>
            <i class="material-icons dropdown-icon-left">location_on</i>
            <i class="material-icons send-email-icon" [style.color]="this.parent.OfferRequest?.ShippingAddress?.ID ? '#4caf50' : '#f44336'">
              {{ this.parent.OfferRequest?.ShippingAddress?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.parent.OfferRequest?.ShippingAddress" [value]="getShippingAddressLabel(false)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showShippingAddressResults">
            <div class="CustomDropdownResult" *ngFor="let addr of this.parent.B2BPartner.ShippingAddresses" (click)="selectShippingAddress(addr, false)">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="this.parent.OfferRequest.ShippingAddress?.ID === addr.ID ? '#4caf50' : '#f44336'">
                  {{ this.parent.OfferRequest.ShippingAddress?.ID === addr.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{addr.Country?.Name}} - {{addr.City}} - {{addr.AddressLine}}</span>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>

      <!-- Contact Info Section -->
      <div class="ModernFormSection" style="width: 100%; margin-bottom: 20px;">
        <div class="ModernFormSectionHeader AppleSectionHeader" (click)="toggleSection('contactInfoRFQ')">
          <div class="AppleSectionHeaderLeft">
            <i class="material-icons AppleSectionIcon">contact_mail</i>
            <span class="AppleSectionTitle">{{ 'ContactInfoSection' | translate }}</span>
          </div>
          <i class="material-icons AppleSectionChevron" [class.collapsed]="sectionCollapsed['contactInfoRFQ']">expand_more</i>
        </div>

        <div class="AppleSectionContent" *ngIf="!sectionCollapsed['contactInfoRFQ']">
        <!-- Partner Agents Dropdown -->
        <div class="CustomDropdownContainer" *ngIf="this.parent.B2BPartner?.PartnerAgents?.length > 0">
          <div class="SendEmailOverlayTransparent" *ngIf="showAgentsResults" (click)="showAgentsResults = false"></div>
          <div class="CustomDropdownBar" (click)="onAgentsFocus()">
            <span class="dropdown-label">{{ 'SelectAgents' | translate }}</span>
          <i class="material-icons dropdown-icon-left">people</i>
          <i class="material-icons send-email-icon" [style.color]="selectedAgents.length > 0 ? '#4caf50' : '#f44336'">
            {{ selectedAgents.length > 0 ? 'check_circle' : 'cancel' }}
          </i>
          <input
            type="text"
            class="CustomDropdownInput"
            [class.placeholder]="selectedAgents.length === 0"
            [value]="getAgentsLabel()"
            readonly
          />
          <span class="selected-count" *ngIf="selectedAgents.length > 0">{{selectedAgents.length}}</span>
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>

        <div class="CustomDropdownResults" *ngIf="showAgentsResults">
          <!-- ✅ First Row: Email Input for Adding New Agent -->
          <div class="CustomDropdownResult NewAgentInputRow">
            <div class="NewAgentInputColumn">
              <div class="NewAgentInputWrapper">
                <i class="material-icons" style="color: #f60; margin-right: 8px;">person_add</i>
                <input
                  type="email"
                  class="NewAgentEmailInput"
                  [(ngModel)]="newAgentEmail"
                  (input)="onNewAgentEmailChange()"
                  placeholder="Enter email to add new agent..."
                  (click)="$event.stopPropagation()"
                />
              </div>
              <button
                *ngIf="isValidEmail"
                class="NewAgentAddButton"
                (click)="createNewAgentFromEmail(); $event.stopPropagation()"
                type="button">
                <i class="material-icons">check</i>
                <span>{{ 'AddNewAgent' | translate }}</span>
              </button>
            </div>
          </div>

          <!-- ✅ Existing Agents List -->
          <div class="CustomDropdownResult"
               *ngFor="let agent of this.parent.B2BPartner.PartnerAgents"
               (click)="toggleAgent(agent)">
            <div class="CustomDropdownResultMain">
              <i class="material-icons" [style.color]="isAgentSelected(agent) ? '#4caf50' : '#f44336'">
                {{ isAgentSelected(agent) ? 'check_circle' : 'cancel' }}
              </i>
              <span class="CustomDropdownResultText">{{agent.Name}} - {{agent.Email}}</span>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>

      <div class="TextBoxTitle">{{'UIPartnerReferenceNumberDescription' | translate}} ({{'Recommended' | translate}})</div>
      <mat-form-field appearance="outline" class="CentralTextBoxContainer">
        <mat-icon matPrefix color="warn" class="CartItemSummaryContainerIcon" [matTooltip]="'UIPartnerReferenceNumberDescription' | translate"  [matTooltipZIndex]="1000"  matTooltipClass='neutral-tool-tip'>
          info_outline
        </mat-icon>
        <mat-label>
          {{ 'UIPartnerReferenceNumber' | translate }} ({{ 'Recommended' | translate }})
        </mat-label>
        <input matInput type="text" style="color: #fd4f57;font-weight: 500;" [(ngModel)]="parent.OfferRequest.DebatorPO"/>
      </mat-form-field>
    </div>

      <!-- Popup Footer -->
      <div class="ModernPopupFooter" style="display: flex; gap: 12px; justify-content: flex-end; padding: 16px 20px; border-top: 1px solid #e5e7eb; background: #f9fafb;">
        <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="AskAddNewRFQQuestion = false;">
          {{ 'Configuration.DeleteNoButton' | translate }}
        </button>
        <!-- Send RFQ button (when Cart Status != 1) -->
        <button class="ModernButton warning" *ngIf="this.parent.Cart?.Status?.ID != 1" [disabled]="this.parent.loading" (click)="this.AddNewOffer(false, this.parent.Cart);">
          <i class="material-icons" *ngIf="!this.parent.loading">arrow_forward</i>
          <mat-spinner *ngIf="this.parent.loading" [diameter]="18" style="margin-right: 8px;"></mat-spinner>
          {{ 'SendRFQ' | translate }}
        </button>
        <!-- Register as Order Confirmation button (when Cart Status == 1) -->
        <button class="ModernButton success" *ngIf="this.parent.Cart?.Status?.ID == 1" [disabled]="this.parent.loading" (click)="this.AddNewOffer(true, this.parent.Cart);">
          <i class="material-icons" *ngIf="!this.parent.loading">arrow_forward</i>
          <mat-spinner *ngIf="this.parent.loading" [diameter]="18" style="margin-right: 8px;"></mat-spinner>
          {{ 'RegisterasClientOrderConfirmation' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- ✅ Register New Offer Popup - ModernPopup style -->
  <div class="ModernPopupOverlay ModernPopupOverlayTop" *ngIf="AskAddNewOfferQuestion" (click)="AskAddNewOfferQuestion = false;">
    <div class="ModernPopup" style="width: 50%; max-width: 700px; max-height: 90vh;" (click)="$event.stopPropagation()">
      <!-- Popup Header -->
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons" style="color: #f60;">local_offer</i>
          <span>{{ 'RegisterNewOffer' | translate }}</span>
        </div>
        <button class="ModernPopupClose" (click)="AskAddNewOfferQuestion = false;">
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Popup Body -->
      <div class="ModernPopupBody" style="padding: 20px 24px; overflow-y: auto; max-height: calc(90vh - 140px); padding-bottom: 0;">

      <!-- Contact Info Section -->
      <div class="ModernFormSection" style="width: 100%; margin-bottom: 20px;">
        <div class="ModernFormSectionHeader AppleSectionHeader" (click)="toggleSection('contactInfoOffer')">
          <div class="AppleSectionHeaderLeft">
            <i class="material-icons AppleSectionIcon">contact_mail</i>
            <span class="AppleSectionTitle">{{ 'ContactInfoSection' | translate }}</span>
          </div>
          <i class="material-icons AppleSectionChevron" [class.collapsed]="sectionCollapsed['contactInfoOffer']">expand_more</i>
        </div>

        <div class="AppleSectionContent" *ngIf="!sectionCollapsed['contactInfoOffer']">
        <!-- Send Email Dropdown -->
        <div class="SendEmailSearchContainer" style="float:left; margin-top: 20px;">
        <!-- Transparent Overlay for Send Email Dropdown -->
        <div class="SendEmailOverlayTransparent" *ngIf="showSendEmailResults" (click)="showSendEmailResults = false"></div>

        <div class="SendEmailSearchBar" (click)="onSendEmailFocus()">
          <span class="send-email-label">Send Email</span>
          <i class="material-icons send-email-icon" [style.color]="SendEmail ? '#4caf50' : '#f44336'">
            {{ SendEmail ? 'check_circle' : 'cancel' }}
          </i>
          <input
            type="text"
            class="SendEmailSearchInput"
            [value]="getSendEmailLabel()"
            readonly
          />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>

        <!-- Send Email Results Dropdown -->
        <div class="SendEmailSearchResults" *ngIf="showSendEmailResults">
          <div class="SendEmailSearchResult" *ngFor="let option of sendEmailOptions" (click)="selectSendEmailOption(option)">
            <div class="SendEmailResultMain">
              <i class="material-icons" [style.color]="option.value ? '#4caf50' : '#f44336'">
                {{ option.value ? 'check_circle' : 'cancel' }}
              </i>
              <span class="SendEmailResultLabel">{{option.label}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ✅ Partner Agents Dropdown (Custom Style - Multi-select) -->
      <div class="CustomDropdownContainer" *ngIf="this.parent.B2BPartner?.PartnerAgents?.length > 0">
        <div class="SendEmailOverlayTransparent" *ngIf="showAgentsResults" (click)="showAgentsResults = false"></div>

        <div class="CustomDropdownBar" (click)="onAgentsFocus()">
          <span class="dropdown-label">{{ 'SelectAgents' | translate }}</span>
          <i class="material-icons dropdown-icon-left">people</i>
          <i class="material-icons send-email-icon" [style.color]="selectedAgents.length > 0 ? '#4caf50' : '#f44336'">
            {{ selectedAgents.length > 0 ? 'check_circle' : 'cancel' }}
          </i>
          <input
            type="text"
            class="CustomDropdownInput"
            [class.placeholder]="selectedAgents.length === 0"
            [value]="getAgentsLabel()"
            readonly
          />
          <span class="selected-count" *ngIf="selectedAgents.length > 0">{{selectedAgents.length}}</span>
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>

        <div class="CustomDropdownResults" *ngIf="showAgentsResults">
          <!-- ✅ First Row: Email Input for Adding New Agent -->
          <div class="CustomDropdownResult NewAgentInputRow">
            <div class="NewAgentInputColumn">
              <div class="NewAgentInputWrapper">
                <i class="material-icons" style="color: #f60; margin-right: 8px;">person_add</i>
                <input
                  type="email"
                  class="NewAgentEmailInput"
                  [(ngModel)]="newAgentEmail"
                  (input)="onNewAgentEmailChange()"
                  placeholder="Enter email to add new agent..."
                  (click)="$event.stopPropagation()"
                />
              </div>
              <button
                *ngIf="isValidEmail"
                class="NewAgentAddButton"
                (click)="createNewAgentFromEmail(); $event.stopPropagation()"
                type="button">
                <i class="material-icons">check</i>
                <span>{{ 'AddNewAgent' | translate }}</span>
              </button>
            </div>
          </div>

          <!-- ✅ Existing Agents List -->
          <div class="CustomDropdownResult"
               *ngFor="let agent of this.parent.B2BPartner.PartnerAgents"
               (click)="toggleAgent(agent)">
            <div class="CustomDropdownResultMain">
              <i class="material-icons" [style.color]="isAgentSelected(agent) ? '#4caf50' : '#f44336'">
                {{ isAgentSelected(agent) ? 'check_circle' : 'cancel' }}
              </i>
              <span class="CustomDropdownResultText">{{agent.Name}} - {{agent.Email}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Customer Internal Reference -->
      <div class="ModernFormGroup" style="width: 100%; margin-top: 10px;">
        <input type="text" class="ModernFormInput ModernFormInputOrange"
               placeholder="{{ 'CustomerInternalReferenceNumber' | translate }} ({{ 'Recommended' | translate }})"
               [(ngModel)]="parent.Offer.DebatorPO" />
      </div>
        </div>
      </div>

      <!-- Terms Section -->
      <div class="ModernFormSection" style="width: 100%; margin-bottom: 20px;">
        <div class="ModernFormSectionHeader AppleSectionHeader" (click)="toggleSection('termsOffer')">
          <div class="AppleSectionHeaderLeft">
            <i class="material-icons AppleSectionIcon">receipt_long</i>
            <span class="AppleSectionTitle">{{ 'TermsSection' | translate }}</span>
          </div>
          <i class="material-icons AppleSectionChevron" [class.collapsed]="sectionCollapsed['termsOffer']">expand_more</i>
        </div>

        <div class="AppleSectionContent" *ngIf="!sectionCollapsed['termsOffer']">
        <!-- Payment Term Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showPaymentTermDropdownOffer" (click)="showPaymentTermDropdownOffer = false"></div>
          <div class="CustomDropdownBar" (click)="showPaymentTermDropdownOffer = !showPaymentTermDropdownOffer">
            <span class="dropdown-label">{{ 'SelectPaymentTerm' | translate }}</span>
            <i class="material-icons dropdown-icon-left">receipt_long</i>
            <i class="material-icons send-email-icon" [style.color]="selectedPaymentTerms?.ID ? '#4caf50' : '#f44336'">
              {{ selectedPaymentTerms?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!selectedPaymentTerms" [value]="selectedPaymentTerms?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showPaymentTermDropdownOffer">
            <div class="CustomDropdownResult" *ngFor="let term of parent.CartMasterData?.PaymentTerms" (click)="selectPaymentTerms(term); showPaymentTermDropdownOffer = false;">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="selectedPaymentTerms?.ID === term.ID ? '#4caf50' : '#f44336'">
                  {{ selectedPaymentTerms?.ID === term.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{ term.Name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Payment Type Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showPaymentTypeDropdownOffer" (click)="showPaymentTypeDropdownOffer = false"></div>
          <div class="CustomDropdownBar" (click)="showPaymentTypeDropdownOffer = !showPaymentTypeDropdownOffer">
            <span class="dropdown-label">{{ 'SelectPaymentType' | translate }}</span>
            <i class="material-icons dropdown-icon-left">payment</i>
            <i class="material-icons send-email-icon" [style.color]="selectedPaymentType?.ID ? '#4caf50' : '#f44336'">
              {{ selectedPaymentType?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!selectedPaymentType" [value]="selectedPaymentType?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showPaymentTypeDropdownOffer">
            <div class="CustomDropdownResult" *ngFor="let type of parent.CartMasterData?.PaymentTypes" (click)="selectPaymentType(type); showPaymentTypeDropdownOffer = false;">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="selectedPaymentType?.ID === type.ID ? '#4caf50' : '#f44336'">
                  {{ selectedPaymentType?.ID === type.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{ type.Name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Discount Row -->
        <div class="CustomDropdownContainer" style="margin-top: 12px;">
          <div style="display: flex; align-items: center; gap: 8px; width: 100%;">
            <span style="font-size: 13px; font-weight: 500; color: #6c757d; min-width: 70px;">{{ 'Discount' | translate }}:</span>
            <!-- Discount Type Dropdown -->
            <div style="flex: 1; min-width: 120px; max-width: 150px;">
              <div class="SendEmailOverlayTransparent" *ngIf="showDiscountTypeDropdownOffer" (click)="showDiscountTypeDropdownOffer = false"></div>
              <div class="CustomDropdownBar" (click)="showDiscountTypeDropdownOffer = !showDiscountTypeDropdownOffer" style="height: 36px;">
                <i class="material-icons dropdown-icon-left" style="font-size: 18px;">percent</i>
                <input type="text" class="CustomDropdownInput" readonly
                       [class.placeholder]="!parent.Cart?.Total?.Discount?.Type"
                       [value]="parent.Cart?.Total?.Discount?.Type?.Name || 'Select...'"
                       style="font-size: 12px;" />
                <i class="material-icons dropdown-icon" style="font-size: 18px;">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showDiscountTypeDropdownOffer">
                <div class="CustomDropdownResult" *ngFor="let type of parent.masterData?.DiscountTypes"
                     (click)="selectDiscountType(type, 'Offer')">
                  <div class="CustomDropdownResultMain">
                    <span class="CustomDropdownResultText">{{type.Name}}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Discount Value Input -->
            <div style="flex: 0 0 80px;">
              <div class="CustomDropdownBar" style="height: 36px; padding: 0 8px;">
                <input type="text" class="CustomDropdownInput"
                       [(ngModel)]="parent.Cart.Total.Discount.Value"
                       (keypress)="validateDiscountInput($event)"
                       placeholder="0"
                       style="font-size: 12px; text-align: center;" />
              </div>
            </div>
            <!-- Apply Button -->
            <button class="GridCommandButton GridCommandButtonBlue" (click)="ApplyOfferDiscount()"
                    [disabled]="!parent.Cart?.Total?.Discount?.Type || !parent.Cart?.Total?.Discount?.Value"
                    style="height: 36px; width: 36px; padding: 0; min-width: 36px;">
              <i class="material-icons" style="font-size: 18px;">check</i>
            </button>
            <!-- Clear Button -->
            <button class="GridCommandButton GridCommandButtonRed" (click)="ClearOfferDiscount()"
                    [disabled]="!parent.Cart?.Total?.Discount?.Type && !parent.Cart?.Total?.Discount?.Value"
                    style="height: 36px; width: 36px; padding: 0; min-width: 36px;">
              <i class="material-icons" style="font-size: 18px;">close</i>
            </button>
          </div>
        </div>

        <!-- ✅ Totals Section (like offers page) -->
        <div class="totals-section" *ngIf="parent.Cart?.Total" style="margin-top: 12px;">
          <!-- Subtotal (from OriginalTotal - before any project discount) -->
          <div class="total-row subtotal-row">
            <span class="total-label">{{'Subtotal' | translate}}:</span>
            <span class="total-value subtotal-value">{{ parent.Cart.OriginalTotal?.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ parent.Cart?.Currency?.Symbol }}</span>
          </div>

          <!-- Project Discount Row (only shown if discount exists) -->
          <div class="total-row discount-row" *ngIf="parent.Cart.Total?.Discount?.Value > 0">
            <span class="total-label discount-label">
              {{'ProjectDiscount' | translate}}
              (<ng-container *ngIf="parent.Cart.Total.Discount.Type?.ID === 1">{{ parent.Cart.Total.Discount.Value | number:'1.2-2' }}%</ng-container><ng-container *ngIf="parent.Cart.Total.Discount.Type?.ID === 2">{{ parent.Cart.Total.Discount.Value | number:'1.2-2' }} {{ parent.Cart?.Currency?.Symbol }}</ng-container>):
            </span>
            <span class="total-value discount-value">- {{ getProjectDiscountAmount() }} {{ parent.Cart?.Currency?.Symbol }}</span>
          </div>

          <!-- Subtotal After Discount (only shown if discount exists) -->
          <div class="total-row subtotal-after-discount-row" *ngIf="parent.Cart.Total?.Discount?.Value > 0">
            <span class="total-label">{{'SubtotalAfterDiscount' | translate}}:</span>
            <span class="total-value">{{ parent.Cart.Total.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ parent.Cart?.Currency?.Symbol }}</span>
          </div>

          <!-- Shipping + Purchase Total Row (side by side) -->
          <div class="shipping-purchase-row">
            <div class="total-row shipping-row">
              <span class="total-label">{{'ShippingCost' | translate}}:</span>
              <span class="total-value shipping-value">{{ parent.Cart.ShippingCost?.UIUnitPrice != null ? (parent.Cart.ShippingCost.UIUnitPrice | number:'1.2-2') : '--,--' }} {{ parent.Cart?.Currency?.Symbol }}</span>
            </div>
            <div class="total-row purchase-total-row" *ngIf="parent.Cart.PurchaseTotal?.TotalQtyPriceNOVAT > 0">
              <span class="total-label">{{'PurchaseTotalNoVAT' | translate}}:</span>
              <span class="total-value">{{ parent.Cart.PurchaseTotal.TotalQtyPriceNOVAT | number:'1.2-2' }} {{ parent.Cart.PurchaseTotal?.Currency?.Symbol || parent.Cart?.Currency?.Symbol }}</span>
            </div>
          </div>
          <!-- Pure Profit Row -->
          <div class="total-row pure-profit-row" *ngIf="parent.Cart.Total?.TotalPureProfit != null" [ngClass]="{'profit-positive': parent.Cart.Total.TotalPureProfit > 0, 'profit-negative': parent.Cart.Total.TotalPureProfit < 0}">
            <span class="total-label">{{'PureProfit' | translate}}:</span>
            <span class="total-value">{{ parent.Cart.Total.TotalPureProfit | number:'1.2-2' }} {{ parent.Cart?.Currency?.Symbol }}</span>
          </div>

          <!-- Final Total (Subtotal + Shipping) -->
          <div class="total-row absolute-total-row">
            <span class="total-label">{{'GrandTotal' | translate}}:</span>
            <span class="total-value absolute-total-value">{{ getAbsoluteTotal() }} {{ parent.Cart?.Currency?.Symbol }}</span>
          </div>
        </div>
        </div>
      </div>

      <!-- Shipping Section -->
      <div class="ModernFormSection" style="width: 100%; margin-bottom: 20px;">
        <div class="ModernFormSectionHeader AppleSectionHeader" (click)="toggleSection('shippingOffer')">
          <div class="AppleSectionHeaderLeft">
            <i class="material-icons AppleSectionIcon">local_shipping</i>
            <span class="AppleSectionTitle">{{ 'ShippingSection' | translate }}</span>
          </div>
          <i class="material-icons AppleSectionChevron" [class.collapsed]="sectionCollapsed['shippingOffer']">expand_more</i>
        </div>

        <div class="AppleSectionContent" *ngIf="!sectionCollapsed['shippingOffer']">
        <!-- Shipping Company Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showShippingCompanyDropdownOffer" (click)="showShippingCompanyDropdownOffer = false"></div>
          <div class="CustomDropdownBar" (click)="showShippingCompanyDropdownOffer = !showShippingCompanyDropdownOffer">
            <span class="dropdown-label">{{ 'SelectShippingCompany' | translate }}</span>
            <i class="material-icons dropdown-icon-left">local_shipping</i>
            <i class="material-icons send-email-icon" [style.color]="selectedShippingCompany?.ID ? '#4caf50' : '#f44336'">
              {{ selectedShippingCompany?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!selectedShippingCompany" [value]="selectedShippingCompany?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showShippingCompanyDropdownOffer">
            <div class="CustomDropdownResult" *ngFor="let company of parent.CartMasterData?.ShippingCompanies" (click)="selectShippingCompany(company); showShippingCompanyDropdownOffer = false;">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="selectedShippingCompany?.ID === company.ID ? '#4caf50' : '#f44336'">
                  {{ selectedShippingCompany?.ID === company.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{ company.Name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Shipping Cost Input -->
        <div class="CustomDropdownContainer">
          <div class="PartnerSearchBar">
            <i class="material-icons search-icon">payments</i>
            <input type="number" class="PartnerSearchInput"
                   placeholder="{{ 'ShippingCost' | translate }}"
                   [(ngModel)]="parent.Cart.ShippingCost.UIUnitPrice"
                   step="0.01" min="0" />
            <span style="margin-left: 8px; font-weight: 600; color: #666;">{{parent.Cart?.Currency?.Symbol || parent.Cart?.Currency?.Name || ''}}</span>
          </div>
        </div>

        <!-- Weight Input -->
        <div class="CustomDropdownContainer">
          <div class="PartnerSearchBar">
            <i class="material-icons search-icon">scale</i>
            <input type="text" class="PartnerSearchInput"
                   placeholder="{{ 'Weight' | translate }}"
                   [(ngModel)]="parent.Cart.Weight"
                   (ngModelChange)="validateWeightInput()"
                   (keypress)="allowOnlyNumbersAndDot($event)"
                   (blur)="validateWeightInput()" />
          </div>
        </div>

        <!-- Weight Measurement Type Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showWeightMeasurementTypeDropdownOffer" (click)="showWeightMeasurementTypeDropdownOffer = false"></div>
          <div class="CustomDropdownBar" (click)="showWeightMeasurementTypeDropdownOffer = !showWeightMeasurementTypeDropdownOffer">
            <span class="dropdown-label">{{ 'WeightMeasurementType' | translate }}</span>
            <i class="material-icons dropdown-icon-left">straighten</i>
            <i class="material-icons send-email-icon" [style.color]="parent.Cart.WeightMeasurementType?.ID ? '#4caf50' : '#f44336'">
              {{ parent.Cart.WeightMeasurementType?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!parent.Cart.WeightMeasurementType" [value]="parent.Cart.WeightMeasurementType?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showWeightMeasurementTypeDropdownOffer">
            <div class="CustomDropdownResult" *ngFor="let wmt of WeightMeasurementTypes" (click)="selectWeightMeasurementType(wmt); showWeightMeasurementTypeDropdownOffer = false;">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="parent.Cart.WeightMeasurementType?.ID === wmt.ID ? '#4caf50' : '#f44336'">
                  {{ parent.Cart.WeightMeasurementType?.ID === wmt.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{ wmt.Name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Shipping Responsability Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showShippingResponsabilityDropdownOffer" (click)="showShippingResponsabilityDropdownOffer = false"></div>
          <div class="CustomDropdownBar" (click)="showShippingResponsabilityDropdownOffer = !showShippingResponsabilityDropdownOffer">
            <span class="dropdown-label">{{ 'SelectShippingResponsability' | translate }}</span>
            <i class="material-icons dropdown-icon-left">assignment_ind</i>
            <i class="material-icons send-email-icon" [style.color]="selectedShippingResponsability?.ID ? '#4caf50' : '#f44336'">
              {{ selectedShippingResponsability?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!selectedShippingResponsability" [value]="selectedShippingResponsability?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showShippingResponsabilityDropdownOffer">
            <div class="CustomDropdownResult" *ngFor="let resp of parent.CartMasterData?.ShippingResponsabilities" (click)="selectShippingResponsability(resp); showShippingResponsabilityDropdownOffer = false;">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="selectedShippingResponsability?.ID === resp.ID ? '#4caf50' : '#f44336'">
                  {{ selectedShippingResponsability?.ID === resp.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{ resp.Name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Insurance Toggle (shown when RequiresInsurance is not null) -->
        <div class="InsuranceToggleContainer" *ngIf="selectedShippingResponsability?.RequiresInsurance != null">
          <mat-slide-toggle
            class="InsuranceToggle"
            [(ngModel)]="parent.Cart.HasInsurance"
            matTooltip="{{ 'RequestProductsInsuranceDescription' | translate }}"
            matTooltipClass="neutral-tool-tip">
          </mat-slide-toggle>
          <span class="InsuranceToggleLabel">{{ 'RequestProductsInsurance' | translate }}</span>
        </div>

        <!-- Shipping Service Type Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showShippingServiceTypeDropdownOffer" (click)="showShippingServiceTypeDropdownOffer = false"></div>
          <div class="CustomDropdownBar" (click)="showShippingServiceTypeDropdownOffer = !showShippingServiceTypeDropdownOffer">
            <span class="dropdown-label">{{ 'SelectShippingServiceType' | translate }}</span>
            <i class="material-icons dropdown-icon-left">speed</i>
            <i class="material-icons send-email-icon" [style.color]="selectedShippingServiceType?.ID ? '#4caf50' : '#f44336'">
              {{ selectedShippingServiceType?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!selectedShippingServiceType" [value]="selectedShippingServiceType?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showShippingServiceTypeDropdownOffer">
            <div class="CustomDropdownResult" *ngFor="let serviceType of parent.CartMasterData?.ShippingServiceTypes" (click)="selectShippingServiceType(serviceType); showShippingServiceTypeDropdownOffer = false;">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="selectedShippingServiceType?.ID === serviceType.ID ? '#4caf50' : '#f44336'">
                  {{ selectedShippingServiceType?.ID === serviceType.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{ serviceType.Name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Delivery Preference Dropdown -->
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showDeliveryPreferenceResults" (click)="showDeliveryPreferenceResults = false"></div>
          <div class="CustomDropdownBar" (click)="onDeliveryPreferenceFocus()" [class.disabled]="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true">
            <span class="dropdown-label">{{ 'SelectDeliveryPrefference' | translate }}</span>
            <i class="material-icons dropdown-icon-left">local_shipping</i>
            <i class="material-icons send-email-icon" [style.color]="this.parent.Cart?.DeliveryPreference?.ID ? '#4caf50' : '#f44336'">
              {{ this.parent.Cart?.DeliveryPreference?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.parent.Cart?.DeliveryPreference?.Name" [value]="getDeliveryPreferenceLabel()" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showDeliveryPreferenceResults">
            <div class="CustomDropdownResult" *ngFor="let d of this.parent.CartMasterData.DeliveryPreferences" (click)="selectDeliveryPreference(d)" [matTooltip]="d.Description" matTooltipClass='neutral-tool-tip'>
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="this.parent.Cart?.DeliveryPreference?.ID === d.ID ? '#4caf50' : '#f44336'">
                  {{ this.parent.Cart?.DeliveryPreference?.ID === d.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{d.Name}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="DeliveryPrefferenceBlockedForChange" *ngIf="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true;">
          <i class="material-icons">info_outline</i>
          <span>{{this.parent.Cart?.DeliveryPreference?.BlockedForChangeDescription}}</span>
        </div>

        <!-- Shipping Address Dropdown -->
        <div class="CustomDropdownContainer" *ngIf="this.parent.B2BPartner?.ShippingAddresses?.length > 0">
          <div class="SendEmailOverlayTransparent" *ngIf="showShippingAddressResults" (click)="showShippingAddressResults = false"></div>
          <div class="CustomDropdownBar" (click)="onShippingAddressFocus()">
            <span class="dropdown-label">{{ 'ShippingAddress' | translate }}</span>
            <i class="material-icons dropdown-icon-left">location_on</i>
            <i class="material-icons send-email-icon" [style.color]="this.parent.Offer?.ShippingAddress?.ID ? '#4caf50' : '#f44336'">
              {{ this.parent.Offer?.ShippingAddress?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.parent.Offer?.ShippingAddress" [value]="getShippingAddressLabel(true)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showShippingAddressResults">
            <div class="CustomDropdownResult" *ngFor="let addr of this.parent.B2BPartner.ShippingAddresses" (click)="selectShippingAddress(addr, true)">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="this.parent.Offer.ShippingAddress?.ID === addr.ID ? '#4caf50' : '#f44336'">
                  {{ this.parent.Offer.ShippingAddress?.ID === addr.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{addr.Country?.Name}} - {{addr.City}} - {{addr.AddressLine}}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Order Consolidation Type Dropdown -->
        <div class="CustomDropdownContainer" *ngIf="this.OfferMasterData?.OrderConsolidationTypes?.length > 0">
          <div class="SendEmailOverlayTransparent" *ngIf="showConsolidationTypeResults" (click)="showConsolidationTypeResults = false"></div>
          <div class="CustomDropdownBar" (click)="onConsolidationTypeFocus()">
            <span class="dropdown-label">{{ 'OrderConsolidationType' | translate }}</span>
            <i class="material-icons dropdown-icon-left">inventory_2</i>
            <i class="material-icons send-email-icon" [style.color]="this.parent.Offer?.ConsolidationType?.ID ? '#4caf50' : '#f44336'">
              {{ this.parent.Offer?.ConsolidationType?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.parent.Offer?.ConsolidationType" [value]="getConsolidationTypeLabel(true)" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>
          <div class="CustomDropdownResults" *ngIf="showConsolidationTypeResults">
            <div class="CustomDropdownResult" *ngFor="let type of this.OfferMasterData.OrderConsolidationTypes" (click)="selectConsolidationType(type, true)" [matTooltip]="type.Description" matTooltipClass='neutral-tool-tip'>
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="this.parent.Offer.ConsolidationType?.ID === type.ID ? '#4caf50' : '#f44336'">
                  {{ this.parent.Offer.ConsolidationType?.ID === type.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{type.Name}}</span>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>

      <!-- Popup Footer -->
      <div class="ModernPopupFooter" style="display: flex; gap: 12px; justify-content: flex-end; padding: 16px 20px; border-top: 1px solid #e5e7eb; background: #f9fafb;">
        <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="AskAddNewOfferQuestion = false;">
          {{ 'Configuration.DeleteNoButton' | translate }}
        </button>
        <button class="ModernButton warning" [disabled]="this.parent.loading" (click)="this.AddNewOffer(false, this.parent.Cart);">
          <i class="material-icons" *ngIf="!this.parent.loading">arrow_forward</i>
          <mat-spinner *ngIf="this.parent.loading" [diameter]="18" style="margin-right: 8px;"></mat-spinner>
          {{ 'RegisterNewOffer' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- ✅ Clear Grid Confirmation Popup - ModernPopup style -->
  <div class="ModernPopupOverlay" *ngIf="ClearGridQuestion" (click)="ClearGridQuestion = false;">
    <div class="ModernPopup" style="width: 420px; min-height: auto;" (click)="$event.stopPropagation()">
      <!-- Popup Header -->
      <div class="ModernPopupHeader" style="padding: 16px 20px;">
        <div class="ModernPopupTitle">
          <i class="material-icons" style="color: #f44336;">warning</i>
          <span>{{ 'ClearGridQuestion' | translate }}</span>
        </div>
        <button class="ModernPopupClose" (click)="ClearGridQuestion = false;">
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Popup Body -->
      <div class="ModernPopupBody" style="padding: 24px; text-align: center; padding-bottom: 0;">
        <i class="material-icons" style="font-size: 48px; color: #f44336; margin-bottom: 12px;">delete_sweep</i>
        <p style="margin: 0; font-size: 14px; color: #666; line-height: 1.5;">
          {{ 'ThisActionCannotBeUndone' | translate }}
        </p>
      </div>

      <!-- Popup Footer -->
      <div class="ModernPopupFooter" style="display: flex; gap: 12px; justify-content: flex-end; padding: 16px 20px; border-top: 1px solid #e5e7eb; background: #f9fafb;">
        <button class="ModernButton outline" [disabled]="this.loading" (click)="ClearGridQuestion = false;">
          {{ 'Configuration.DeleteNoButton' | translate }}
        </button>
        <button class="ModernButton danger" [disabled]="this.loading" (click)="ClearGridQuestion = false; ClearGrid();">
          <i class="material-icons">delete_forever</i>
          {{ 'ClearGrid' | translate }}
        </button>
      </div>
    </div>
  </div>
  <!-- ✅ Config Status Dropdown (Admin Grid Only) -->
  <div class="ConfigStatusDropdownContainer" *ngIf="useAdminGrid && parent.B2BPartner">
    <div class="SendEmailOverlayTransparent" *ngIf="showConfigStatusResults" (click)="showConfigStatusResults = false"></div>

    <div class="CustomDropdownResults" *ngIf="showConfigStatusResults">
      <div class="CustomDropdownResult"
           *ngFor="let status of this.parent.masterData?.ConfigStatuses"
           (click)="selectConfigStatus(status)">
        <div class="CustomDropdownResultMain">
          <i class="material-icons" [style.color]="selectedConfigStatus?.ID === status.ID ? '#4caf50' : '#f44336'">
            {{ selectedConfigStatus?.ID === status.ID ? 'check_circle' : 'cancel' }}
          </i>
          <span class="CustomDropdownResultText">{{status.Name}} <span class="config-status-description">({{status.Description}})</span></span>
        </div>
      </div>
    </div>
  </div>
  <!-- ✅ Message when no partner selected (positioned in GridTotals area) -->

  <!-- ✅ Compact Filter Bar (Period + Date Range + Filter Button) -->
  <div class="CompactFilterBar">
    <div class="FilterBarLeft">
      <mat-form-field class="CompactField" appearance="outline">
        <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
        <mat-select name="Period" [(ngModel)]="Filter.Period">
          <mat-option *ngFor="let a of this.MasterData.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); applyFilter();">
            {{a.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="CompactField" appearance="outline">
        <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
        <input matInput [matDatepicker]="dpFrom" [formControl]="FromDate" (dateChange)="ClearPeriod()">
        <mat-datepicker-toggle matSuffix [for]="dpFrom"></mat-datepicker-toggle>
        <mat-datepicker #dpFrom></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="CompactField" appearance="outline">
        <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
        <input matInput [matDatepicker]="dpTo" [formControl]="ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
        <mat-datepicker-toggle matSuffix [for]="dpTo"></mat-datepicker-toggle>
        <mat-datepicker #dpTo></mat-datepicker>
      </mat-form-field>

      <button mat-stroked-button class="CompactFilterButton" (click)="applyFilter();">
        <mat-icon>filter_alt</mat-icon>
        <span>{{ 'Filter' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- ✅ Products Pagination Row -->
  <div class="ProductsPaginationRow">
    <div class="PaginationInfo">
      <span>{{rowData?.length}} {{'OfWord' | translate}} {{ProductsPager?.TotalCount}} {{'Products' | translate}}</span>
    </div>
    <div class="PaginationControls">
      <button mat-stroked-button class="PaginationButton" [disabled]="ProductsPager?.PageIndex == 1" (click)="GetProductsFiltered(1);">
        <mat-icon>first_page</mat-icon>
      </button>
      <button mat-stroked-button class="PaginationButton" [disabled]="ProductsPager?.PageIndex == 1" (click)="GetProductsFiltered(ProductsPager?.PageIndex - 1);">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <div class="PageNumberDisplay">
        <span class="CurrentPage">{{ProductsPager?.PageIndex}}</span>
        <span class="PageSeparator">/</span>
        <span class="TotalPages">{{ProductsPager?.Pages}}</span>
      </div>
      <button mat-stroked-button class="PaginationButton" [disabled]="ProductsPager?.PageIndex == ProductsPager?.Pages" (click)="GetProductsFiltered(ProductsPager?.PageIndex + 1);">
        <mat-icon>chevron_right</mat-icon>
      </button>
      <button mat-stroked-button class="PaginationButton" [disabled]="ProductsPager?.PageIndex == ProductsPager?.Pages" (click)="GetProductsFiltered(ProductsPager?.Pages);">
        <mat-icon>last_page</mat-icon>
      </button>
      <input type="number" class="PageSizeInput" [(ngModel)]="Filter.Pager.PageSize" (change)="GetProductsFiltered(1)" min="10" max="500" title="Page Size">
    </div>
  </div>

  <!-- ✅ Actions Filter Row with Advanced Filters -->
  <div class="ActionsFilterRow">
    <!-- Left Side: Filters & Actions -->
    <div class="LeftActions">
      <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
        <i class="material-icons">tune</i>
        <span>{{ 'AdvancedFilters' | translate }}</span>
      </div>

      <div class="ActiveFiltersContainer">
        <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
          {{a.Name}}
          <i class="material-icons">close</i>
        </div>
      </div>
    </div>

    <!-- ✅ Legend: explains orange (Mandatory) and blue (Recommended) cell borders -->
    <div class="GridLegendContainer">
      <div class="GridLegendItem">
        <span class="GridLegendSquare GridLegendSquare--mandatory"></span>
        <span class="GridLegendLabel">{{ 'Mandatory' | translate }}</span>
      </div>
      <div class="GridLegendItem">
        <span class="GridLegendSquare GridLegendSquare--recommended"></span>
        <span class="GridLegendLabel">{{ 'Recommended' | translate }}</span>
      </div>
    </div>

    <!-- ✅ FilterContainer - Advanced Filters Popup -->
    <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
      <div class="FilterCloseContainer" (click)="this.showFilter = false;">
        <i class="material-icons">close</i>
      </div>

      <div class="FilterContainerBody">
        <div class="FilterGrid">
          <!-- Status Dropdown -->
          <div class="CustomDropdownContainer">
            <div class="DropdownOverlayTransparent" *ngIf="showStatusDropdown" (click)="showStatusDropdown = false"></div>
            <div class="CustomDropdownBar" (click)="onStatusDropdownFocus()">
              <span class="dropdown-label">{{ 'Status' | translate }}</span>
              <i class="material-icons dropdown-icon-left">flag</i>
              <i class="material-icons send-email-icon" [style.color]="Filter.IndividualStatus?.ID ? '#ab47bc' : '#9ab5d0'">
                {{ Filter.IndividualStatus?.ID ? 'check_circle' : 'radio_button_unchecked' }}
              </i>
              <input type="text" class="CustomDropdownInput" [class.placeholder]="!Filter.IndividualStatus?.Name" [value]="Filter.IndividualStatus?.Name || ('Status' | translate)" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="showStatusDropdown">
              <div class="CustomDropdownResult" *ngFor="let d of MasterData.OfferStatuses" (click)="selectStatusFilter(d)">
                <div class="CustomDropdownResultMain">
                  <span class="CustomDropdownResultText">{{d.Name}}</span>
                </div>
                <i class="material-icons CustomDropdownResultCheck" *ngIf="Filter.IndividualStatus?.ID === d.ID">check</i>
              </div>
            </div>
          </div>

          <!-- Currency Dropdown -->
          <div class="CustomDropdownContainer">
            <div class="DropdownOverlayTransparent" *ngIf="showCurrencyDropdown" (click)="showCurrencyDropdown = false"></div>
            <div class="CustomDropdownBar" (click)="onCurrencyDropdownFocus()">
              <span class="dropdown-label">{{'Currency' | translate}}</span>
              <i class="material-icons dropdown-icon-left">attach_money</i>
              <i class="material-icons send-email-icon" [style.color]="Filter.Currency?.ID ? '#ab47bc' : '#9ab5d0'">
                {{ Filter.Currency?.ID ? 'check_circle' : 'radio_button_unchecked' }}
              </i>
              <input type="text" class="CustomDropdownInput" [class.placeholder]="!Filter.Currency?.Name" [value]="Filter.Currency?.Name || ('Currency' | translate)" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="showCurrencyDropdown">
              <div class="CustomDropdownResult" *ngFor="let c of MasterData.Currencies" (click)="selectCurrencyFilter(c)">
                <div class="CustomDropdownResultMain">
                  <span class="CustomDropdownResultText">{{c.Name}}</span>
                </div>
                <i class="material-icons CustomDropdownResultCheck" *ngIf="Filter.Currency?.ID === c.ID">check</i>
              </div>
            </div>
          </div>

          <!-- Brand Dropdown -->
          <div class="CustomDropdownContainer">
            <div class="DropdownOverlayTransparent" *ngIf="showBrandDropdown" (click)="showBrandDropdown = false"></div>
            <div class="CustomDropdownBar" (click)="onBrandDropdownFocus()">
              <span class="dropdown-label">{{'Brand' | translate}}</span>
              <i class="material-icons dropdown-icon-left">label</i>
              <i class="material-icons send-email-icon" [style.color]="Filter.Brand?.ID ? '#ab47bc' : '#9ab5d0'">
                {{ Filter.Brand?.ID ? 'check_circle' : 'radio_button_unchecked' }}
              </i>
              <input type="text" class="CustomDropdownInput" [class.placeholder]="!Filter.Brand?.Name" [value]="Filter.Brand?.Name || ('Brand' | translate)" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="showBrandDropdown">
              <div class="CustomDropdownResult" *ngFor="let b of MasterData.Brands" (click)="selectBrandFilter(b)">
                <div class="CustomDropdownResultMain">
                  <span class="CustomDropdownResultText">{{b.Name}}</span>
                </div>
                <i class="material-icons CustomDropdownResultCheck" *ngIf="Filter.Brand?.ID === b.ID">check</i>
              </div>
            </div>
          </div>

          <!-- Supplier Dropdown -->
          <div class="CustomDropdownContainer">
            <div class="DropdownOverlayTransparent" *ngIf="showSupplierDropdown" (click)="showSupplierDropdown = false"></div>
            <div class="CustomDropdownBar" (click)="onSupplierDropdownFocus()">
              <span class="dropdown-label">{{'Supplier' | translate}}</span>
              <i class="material-icons dropdown-icon-left">local_shipping</i>
              <i class="material-icons send-email-icon" [style.color]="Filter.Supplier?.ID ? '#ab47bc' : '#9ab5d0'">
                {{ Filter.Supplier?.ID ? 'check_circle' : 'radio_button_unchecked' }}
              </i>
              <input type="text" class="CustomDropdownInput" [class.placeholder]="!Filter.Supplier?.Name" [value]="Filter.Supplier?.Name || ('Supplier' | translate)" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="showSupplierDropdown">
              <div class="CustomDropdownResult" *ngFor="let s of MasterData.Suppliers" (click)="selectSupplierFilter(s)">
                <div class="CustomDropdownResultMain">
                  <span class="CustomDropdownResultText">{{s.Name}}</span>
                </div>
                <i class="material-icons CustomDropdownResultCheck" *ngIf="Filter.Supplier?.ID === s.ID">check</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="FilterCommands">
        <button mat-raised-button color="primary" class="FilterButtonAction" (click)="applyFilter();">{{ 'Filter' | translate }}</button>
      </div>
    </div>
  </div>

  <!-- ✅ Shared Transparent Overlay - Closes ALL shipping config dropdowns when clicked -->
  <div class="ShippingOverlayTransparent" *ngIf="isAnyShippingDropdownOpen()" (click)="closeAllShippingDropdowns()"></div>
 
  <!-- ✅ Excel Export Column Control Row - EMPLOYEE GRID (15 columns to match columnDefs) -->
  <!-- Uses dynamic pixel widths from ag-Grid via getColumnWidth() -->
  <div class="ExcelExportControlRow" *ngIf="parent.B2BPartner && useAdminGrid">
    <!-- 1. index -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('index')">
      <mat-checkbox [checked]="allExportColumnsSelected" (change)="toggleAllExportColumns($event.checked)" color="primary"></mat-checkbox>
    </div>
    <!-- 2. brand -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('brand')"></div>
    <!-- 3. partNumber -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('partNumber')"></div>
    <!-- 4. name -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('name')"></div>
    <!-- 5. quantity -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('quantity')"></div>
    <!-- 6. officialListPrice -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('officialListPrice')">
      <mat-checkbox [checked]="includeListPriceInExport" (change)="onExportColumnChange('ListPrice', $event.checked)" color="primary"></mat-checkbox>
    </div>
    <!-- 7. officialDiscount -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('officialDiscount')">
      <mat-checkbox [checked]="includeDiscountInExport" (change)="onExportColumnChange('Discount', $event.checked)" color="primary"></mat-checkbox>
    </div>
    <!-- 8. price (finalPrice) -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('price')"></div>
    <!-- 9. total -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('total')"></div>
    <!-- 10. eta -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('eta')">
      <mat-checkbox [checked]="includeETAInExport" (change)="onExportColumnChange('ETA', $event.checked)" color="primary"></mat-checkbox>
    </div>
    <!-- 11. supplier -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('supplier')"></div>
    <!-- 12. purchase -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('purchase')"></div>
    <!-- 13. purchaseCurrency -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('purchaseCurrency')"></div>
    <!-- 14. hscode -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('hscode')">
      <mat-checkbox [checked]="includeHSCodeInExport" (change)="onExportColumnChange('HSCode', $event.checked)" color="primary"></mat-checkbox>
    </div>
    <!-- 15. coo -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('coo')">
      <mat-checkbox [checked]="includeCOOInExport" (change)="onExportColumnChange('COO', $event.checked)" color="primary"></mat-checkbox>
    </div>
    <!-- 16. weight -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('weight')">
      <mat-checkbox [checked]="includeWeightInExport" (change)="onExportColumnChange('Weight', $event.checked)" color="primary"></mat-checkbox>
    </div>
    <!-- 17. delete (save icon) -->
    <div class="ExcelExportControlCell" [ngStyle]="getColumnWidth('delete')"></div>
  </div>

  <div class="OwnAGGridContainer" style="position: relative!important;" [class.grid-disabled]="!parent.B2BPartner">

    <!-- ✅ Loading Shimmer Overlay -->
    <div class="grid-loading-overlay" *ngIf="loadingProducts">
      <div class="grid-loading-shimmer"></div>
    </div>



    <!-- ✅ Employee Grid (no Supplier column) -->
    <ag-grid-angular
      *ngIf="!useAdminGrid"
      class="ag-theme-alpine employee-grid"
      style="width: 100%;"
      [gridOptions]="gridOptions"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>

    <!-- ✅ Admin Grid (with Supplier column) -->
    <ag-grid-angular
      *ngIf="useAdminGrid"
      class="ag-theme-alpine admin-grid"
      style="width: 100%;"
      [gridOptions]="gridOptions"
      [rowData]="rowData"
      [columnDefs]="adminColumnDefs"
      [defaultColDef]="defaultColDef"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>

  <!-- ✅ Transparent overlay to close grid popups - UNDER popups, same stacking context -->
  <div class="grid-popup-close-overlay"
       *ngIf="ShowETAAlternatives || ShowSupplierAlternatives || ShowSearchResultsAlternatives || ShowFallbackSelection || ShowBrandCollateral || ShowBrandCollateralNewProduct || ShowRedRowETAPopup || ShowRevertConfirmationPopup || ShowPartnerSearchPopup || ShowCOOSearchPopup || ShowWeightPopup || ShowPartnerDetailsPopup"
       (click)="CloseGridPopupsOverlay();">
  </div>

  <div class="SearchResultsAlternativesContainer animated fadeIn" *ngIf="ShowSearchResultsAlternatives === true" [ngStyle]="SearchResultsPosition">
    <div class="SearchResultsHeader">
      <span>{{'AlternativeResults' | translate}}</span>
      <button class="CloseBtn" (click)="ShowSearchResultsAlternatives = false">×</button>
    </div>
    <div class="SearchResultsList" *ngIf="this.LoadingSideOffers == true;">
      <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
    </div>
    <div class="SearchResultsList" *ngIf="this.LoadingSideOffers != true;">
      <div class="SearchResultItem" *ngFor="let result of SearchResultAlternatives" (click)="SwitchGridResultAlternative(result)" [ngClass]="{ 'SelectedItem': result.IsSelected }">
    <div class="SearchResultTitle">
      {{ result.ProductName }} {{ result.ProductPartNumber }}
      <span *ngIf="result.IsSelected" class="SelectedTag">✓ {{ 'Selected' | translate }}</span>
    </div>

    <div class="SearchResultMeta">
      <span class="SearchResultBrand">{{ result.FKBrandName }}</span>
      <!-- <span class="SearchResultPrice">
        {{ result.Price?.UIUnitPrice }} {{ result.Price?.Currency?.Symbol }}
      </span> -->
    </div>
    </div>
    </div>
  </div>

  <!-- brand-only popup -->
  <div class="BrandCollateralContainer" *ngIf="ShowBrandCollateral == true" [ngStyle]="BrandPopupPosition">
    <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px; overflow: hidden;">
      <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
    </div>
    <div *ngIf="LoadingSideOffers != true;" class="SearchResultsList" style="overflow: hidden;">
  <!-- render your brands here -->
      <div class="brand-collateral-item" *ngFor="let b of BrandCollateralList" (click)="SwitchGridBrandVersion2(b);">
        <span>{{ b?.Name}}</span>
        <i class="material-icons" *ngIf="b.IsSelected == true;">check</i>
      </div>
    </div>
  </div>

  <!-- brand-only popup -->
  <div class="BrandCollateralContainer" *ngIf="ShowBrandCollateralNewProduct == true" [ngStyle]="BrandPopupPosition">
    <div class="BrandCollateralSearchContainer">
      <input placeholder="{{'SearchBrand' | translate}}" name="BrandCollateralSearchInput" type="text" class="BrandCollateralSearchInput" [(ngModel)]="this.BrandFilter.SearchTerm" matInput (ngModelChange)="this.brandSearchTermUpdate.next($event)">
    </div>
    <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px; overflow: hidden;">
      <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
    </div>
    <div *ngIf="LoadingSideOffers != true;" class="SearchResultsList" style="overflow: hidden;">
  <!-- render your brands here -->
      <div class="brand-collateral-item" *ngFor="let b of NewProductBrandsList" (click)="AttachBrandToNewProduct(b);">
        <span>{{ b?.Name}}</span>
        <i class="material-icons" *ngIf="b.IsSelected == true;">check</i>
      </div>
    </div>
  </div>

  <!-- ✅ Partner Search Popup (positioned under cell like brand popup) -->
  <div class="BrandCollateralContainer supplier-popup-container" *ngIf="ShowPartnerSearchPopup" [ngStyle]="SupplierPopupPosition">
    <!-- Search Input -->
    <div class="BrandCollateralSearchContainer">
      <input placeholder="Search supplier by name..."
             name="PartnerSearchInput"
             type="text"
             class="BrandCollateralSearchInput"
             [(ngModel)]="PartnerSearchTerm"
             (ngModelChange)="SearchPartners()">
    </div>

    <!-- Loading Indicator -->
    <div class="SearchResultsList" *ngIf="LoadingPartners" style="margin-top: 50px; margin-bottom: 50px; overflow: hidden;">
      <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
    </div>

    <!-- Search Results -->
    <div *ngIf="!LoadingPartners" class="SearchResultsList" style="overflow: hidden;">
      <!-- Results List -->
      <div *ngIf="PartnerSearchResults.length > 0">
        <div class="supplier-popup-item"
             *ngFor="let partner of PartnerSearchResults"
             (click)="SelectPartner(partner)">
          <div class="supplier-popup-column supplier-name-column">
            <span style="font-weight: 600;">{{ partner.Name }}</span>
          </div>
          <div class="supplier-popup-column purchase-info-column">
            <span style="color: #666; font-size: 11px;">
              <span *ngIf="partner.VATNumber">VAT: {{ partner.VATNumber }}</span>
              <span *ngIf="partner.Country"> • {{ partner.Country.Name }}</span>
            </span>
          </div>
        </div>
      </div>

      <!-- No Results -->
      <div *ngIf="PartnerSearchResults.length === 0"
           style="text-align: center; padding: 30px; color: #999;">
        <span *ngIf="PartnerSearchTerm && PartnerSearchTerm.length >= 2">No suppliers found</span>
        <span *ngIf="!PartnerSearchTerm || PartnerSearchTerm.length === 0">Type to search for suppliers</span>
        <span *ngIf="PartnerSearchTerm && PartnerSearchTerm.length === 1">Type at least 2 characters to search</span>
      </div>
    </div>
  </div>

  <!-- ✅ COO (Country of Origin) Search Popup (positioned under cell like brand popup) -->
  <div class="BrandCollateralContainer" *ngIf="ShowCOOSearchPopup" [ngStyle]="COOPopupPosition">
    <!-- Search Input -->
    <div class="BrandCollateralSearchContainer">
      <input placeholder="Search country of origin..."
             name="COOSearchInput"
             type="text"
             class="BrandCollateralSearchInput"
             [(ngModel)]="COOSearchTerm"
             (ngModelChange)="SearchCountries()">
    </div>

    <!-- Search Results -->
    <div class="SearchResultsList" style="overflow: hidden;">
      <!-- Results List -->
      <div *ngIf="COOSearchResults.length > 0">
        <div class="brand-collateral-item"
             *ngFor="let country of COOSearchResults"
             (click)="SelectCountry(country)">
          <div style="display: flex; flex-direction: column; gap: 4px; flex: 1;">
            <span style="font-weight: 600;">{{ country.ShortName }}</span>
            <span style="color: #666; font-size: 12px;" *ngIf="country.Name !== country.ShortName">{{ country.Name }}</span>
          </div>
        </div>
      </div>

      <!-- No Results -->
      <div *ngIf="COOSearchResults.length === 0"
           style="text-align: center; padding: 30px; color: #999;">
        <span>No countries found</span>
      </div>
    </div>
  </div>

  <!-- ✅ Purchase Currency Dropdown Popup -->
  <div class="BrandCollateralContainer" *ngIf="showPurchaseCurrencyDropdown" [ngStyle]="purchaseCurrencyDropdownPosition" style="position: fixed; max-height: 200px; overflow-y: auto; z-index: 201; min-height: auto;">
    <div class="SearchResultsList" style="overflow: hidden;">
      <div *ngIf="currencies.length > 0">
        <div class="brand-collateral-item"
             *ngFor="let currency of currencies"
             (click)="selectPurchaseCurrency(currency)">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="font-weight: 600; min-width: 30px;">{{ currency.Symbol }}</span>
            <span style="color: #666; font-size: 12px;">{{ currency.Name }}</span>
          </div>
        </div>
      </div>
      <div *ngIf="currencies.length === 0" style="text-align: center; padding: 20px; color: #999;">
        <span>No currencies available</span>
      </div>
    </div>
  </div>

  <div class="SearchResultsAlternativesContainer grid-style-popup animated fadeIn"
      *ngIf="ShowFallbackSelection === true"
      [ngStyle]="SearchResultsPosition">

    <div class="SearchResultsHeader" *ngIf="LoadingSideOffers !== true">
      <span>{{ 'PleaseChooseAnItem' | translate }}</span>
      <button class="CloseBtn" (click)="ShowFallbackSelection = false">×</button>
    </div>

    <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px;">
      <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
    </div>

    <div class="SearchResultsList" *ngIf="LoadingSideOffers !== true">
      <div class="OfferRow">
        <div class="GridCell indexx-column" style="font-style: italic;">
          #
        </div>
        <div class="GridCell brand-column" style="font-style: italic;">
          {{'Brand' | translate}}
        </div>

        <div class="GridCell partnumber-column" style="font-style: italic;">
        {{'ProductCode' | translate}}
        </div>

        <div class="GridCell name-column" style="font-style: italic;">
        {{'ProductName' |  translate}}
        </div>

      <div class="GridCell qty-column" style="font-style: italic;">
        min.{{'Quantity' |  translate}}
      </div>

      <div class="GridCell price-column" style="font-style: italic;">
        {{'SellPrice' |  translate}}
      </div>

      <div class="GridCell total-column" style="font-style: italic;">
        {{'Total' |  translate}}
      </div>

      <div class="GridCell eta-column" style="font-style: italic;">
        {{'ETA' |  translate}}
      </div>

      <div class="GridCell supplier-column" style="font-style: italic;" *ngIf="isAdministrator()">
        Supplier
      </div>

      <div class="GridCell purchase-column" style="font-style: italic;" *ngIf="isAdministrator()">
        Purchase
      </div>

      <div class="GridCell hscode-column" style="font-style: italic;">
        {{'HSCode' |  translate}}
      </div>

      <div class="GridCell coo-column" style="font-style: italic;">
        {{'COO' |  translate}}
      </div>

      <div class="GridCell weight-column" style="font-style: italic;">
        {{'Weight' |  translate}}
      </div>
      <div class="GridCell x-column" style="font-style: italic;">

      </div>
  </div>
      <div class="OfferRow"
      *ngFor="let result of FallbackOffers; index as i"
      [ngClass]="{ 'SelectedRow': result.IsSelected, 'GridValid': result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true }"
      (click)="SwitchGridResultProduct(result)">

      <div class="GridCell indexx-column">
        {{i + 1}}
      </div>
      <div class="GridCell brand-column">
        {{result.Product?.Brand?.Name}}
      </div>

      <div class="GridCell partnumber-column">
        {{result.Product?.PartNumber}}
      </div>

      <div class="GridCell name-column">
      <span>{{result.Product?.Name}}</span>
      <span class="GridCellSpecialPriceSignal" *ngIf="result.SelectedOffer?.Configuration?.SpecialPriceList == true;">({{'SpecialPriceOffer' | translate}})</span>
      </div>

      <div class="GridCell qty-column">
      {{result.Quantity}}
      </div>

      <div class="GridCell price-column">
      <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
        <span *ngIf="result.Price?.UIUnitPrice > 0;">{{result.Price?.UIUnitPrice}} {{result.Price?.Currency?.Symbol}}</span>
        <span *ngIf="!(result.Price?.UIUnitPrice > 0)" class="RequestPriceGridCellButton">{{'RequestPrice' | translate}}</span>
      </span>
      </div>

      <div class="GridCell total-column">
      <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
            <span *ngIf="result.Price?.UIQtyPrice > 0;">{{result.Price?.UIQtyPrice}} {{result.Price?.Currency?.Symbol}}</span>
            <span *ngIf="!(result.Price?.UIQtyPrice > 0)">------- {{result.Price?.Currency?.Symbol}}</span>
      </span>
      </div>

      <div class="GridCell eta-column" style="display: flex; align-items: center;">
      <i class="material-icons"
         *ngIf="result.Product?.Stats?.TrustedManufacturerLeadTime === true"
         style="color: #32aa3a; font-size: 18px; margin-right: 6px; vertical-align: middle; cursor: help;"
         [matTooltip]="'Manufacturer stock: ' + (result.Product?.Stats?.ManufacturerStock != null ? result.Product?.Stats?.ManufacturerStock : '-') + '\nTrusted information'"
         matTooltipClass="trusted-tooltip">verified</i>
      <span>{{result.SelectedOffer?.LeadTime?.UIOutput}}</span>
      <span *ngIf="result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true;">(Stock)</span>
      </div>

      <div class="GridCell supplier-column" *ngIf="isAdministrator()">
      <span *ngIf="result.SelectedOffer?.Partner?.Name">{{result.SelectedOffer?.Partner?.Name}}</span>
      <span *ngIf="!result.SelectedOffer?.Partner?.Name">{{result.SelectedOffer?.Configuration?.Name}}</span>
      </div>

      <div class="GridCell purchase-column" *ngIf="isAdministrator()">
      <span *ngIf="result.SelectedOffer?.ListPrice > 0;"
            [ngClass]="{
              'purchase-price-green': result.SelectedOffer?.ListPrice < result.Price?.UIUnitPrice,
              'purchase-price-red': result.SelectedOffer?.ListPrice >= result.Price?.UIUnitPrice
            }">
      {{result.SelectedOffer?.ListPrice}} {{result.SelectedOffer?.Currency?.Symbol}}
      </span>
      </div>

      <div class="GridCell hscode-column">
      {{result.Product?.Stats?.HSCode}}
      </div>

      <div class="GridCell coo-column">
      {{result.Product?.Stats?.COO?.ShortName}}
      </div>

      <div class="GridCell weight-column">
      <span *ngIf="result.Product?.Stats?.Weight > 0;">
      {{result.Product?.Stats?.Weight}} {{result.Product?.Stats?.WeightMeasurementType?.Name}}
      </span>
      </div>
      <div class="GridCell x-column">

      </div>
      </div>
    </div>
  </div>

  <div class="SearchResultsAlternativesContainer grid-style-popup animated fadeIn"
      *ngIf="ShowETAAlternatives === true"
      [ngStyle]="SearchResultsPosition">

    <div class="SearchResultsHeader">
      <span>{{ 'OtherOffers' | translate }}</span>
      <button class="CloseBtn" (click)="ShowETAAlternatives = false">×</button>
    </div>

    <!-- ✅ Tabs for unified popup -->
    <div class="GridModeTabsWrapper" style="display: flex; width: 100%;">
      <div class="GridModeTab"
           style="width: 33.33%; flex: 1;"
           [ngClass]="{'SelectedGridModeTab': selectedNamePopupTab === 1}"
           (click)="onNamePopupTabChange(1)">
        <span>{{ 'Suppliers' | translate }}</span>
      </div>
      <div class="GridModeTab"
           style="width: 33.33%; flex: 1;"
           [ngClass]="{'SelectedGridModeTab': selectedNamePopupTab === 2}"
           (click)="onNamePopupTabChange(2)">
        <span>{{ 'OtherOffers' | translate }}</span>
      </div>
      <div class="GridModeTab"
           style="width: 33.33%; flex: 1;"
           [ngClass]="{'SelectedGridModeTab': selectedNamePopupTab === 3}"
           (click)="onNamePopupTabChange(3)">
        <span>{{ 'SimilarProducts' | translate }}</span>
      </div>
    </div>

    <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px;">
      <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
    </div>

    <!-- ✅ Tab 1: Suppliers (list of supplier offers for the same product) -->
    <div class="SearchResultsList" *ngIf="LoadingSideOffers !== true && selectedNamePopupTab === 1">
      <div *ngIf="SideOffers?.length > 0">
        <div class="PartnerSearchResult" *ngFor="let offer of SideOffers; let i = index"
             (click)="SelectSupplierFromPopup(offer)"
             [ngClass]="{'SelectedItem': offer?.IsSelected}"
             style="cursor: pointer;"
             [style.background]="offer?.IsSelected ? '#e3f2fd' : 'transparent'"
             onmouseover="this.style.background='#f5f5f5'"
             onmouseout="this.style.background=this.classList.contains('SelectedItem') ? '#e3f2fd' : 'transparent'">
          <div class="PartnerResultMain" style="display: flex; align-items: center; gap: 10px; padding: 8px 12px;">
            <span style="color: #888; font-size: 11px; min-width: 20px;">{{ i + 1 }}</span>
            <span class="PartnerName" style="flex: 2; font-weight: 500;">
              <span *ngIf="offer?.SelectedOffer?.MOQ > 0" style="color: #888; font-size: 11px;">[{{ offer?.SelectedOffer?.MOQ }}] </span>
              {{ offer?.SelectedOffer?.Partner?.Name || 'N/A' }}
            </span>
            <span class="PartnerCountryBadge" style="background: #e3f2fd; color: #1976d2; padding: 2px 8px; border-radius: 4px; font-size: 11px;">
              {{ offer?.SelectedOffer?.ListPrice | number:'1.2-2' }} {{ offer?.SelectedOffer?.PurchaseCurrency?.Symbol || offer?.SelectedOffer?.Currency?.Symbol || '' }}
            </span>
            <span *ngIf="offer?.SelectedOffer?.StockQuantity > 0" class="PartnerCountryBadge" style="background: #e8f5e9; color: #388e3c; padding: 2px 8px; border-radius: 4px; font-size: 11px;">
              STOCK: {{ offer?.SelectedOffer?.StockQuantity }}
            </span>
            <span *ngIf="offer?.SelectedOffer?.LeadTime?.Units > 0" style="font-size: 11px; color: #666;">
              {{ offer?.SelectedOffer?.LeadTime?.Units }} {{ offer?.SelectedOffer?.LeadTime?.Type?.Name || '' }}
            </span>
            <span *ngIf="offer?.IsSelected" style="color: #4caf50; font-size: 14px;">✓</span>
          </div>
        </div>
      </div>
      <div *ngIf="!SideOffers || SideOffers?.length === 0" style="text-align: center; color: #999; font-size: 12px; padding: 20px;">
        {{ 'NoSupplierAlternatives' | translate }}
      </div>
    </div>

    <!-- ✅ Tab 2: Other Offers (EXACT HTML from original ShowETAAlternatives popup) -->
    <div class="SearchResultsList" *ngIf="LoadingSideOffers !== true && selectedNamePopupTab === 2">
      <div class="OfferRow">
        <div class="GridCell indexx-column" style="font-style: italic;">
          #
        </div>
        <div class="GridCell brand-column" style="font-style: italic;">
          {{'Brand' | translate}}
        </div>

        <div class="GridCell partnumber-column" style="font-style: italic;">
        {{'ProductCode' | translate}}
        </div>

        <div class="GridCell name-column" style="font-style: italic;">
        {{'ProductName' |  translate}}
        </div>

      <div class="GridCell qty-column" style="font-style: italic;">
        min.{{'Quantity' |  translate}}
      </div>

      <div class="GridCell price-column" style="font-style: italic;">
        {{'SellPrice' |  translate}}
      </div>

      <div class="GridCell total-column" style="font-style: italic;">
        {{'Total' |  translate}}
      </div>

      <div class="GridCell eta-column" style="font-style: italic;">
        {{'ETA' |  translate}}
      </div>

      <div class="GridCell supplier-column" style="font-style: italic;" *ngIf="isAdministrator()">
        Supplier
      </div>

      <div class="GridCell purchase-column" style="font-style: italic;" *ngIf="isAdministrator()">
        Purchase
      </div>

      <div class="GridCell hscode-column" style="font-style: italic;">
        {{'HSCode' |  translate}}
      </div>

      <div class="GridCell coo-column" style="font-style: italic;">
        {{'COO' |  translate}}
      </div>

      <div class="GridCell weight-column" style="font-style: italic;">
        {{'Weight' |  translate}}
      </div>
      <div class="GridCell x-column" style="font-style: italic;">
      </div>
  </div>
      <div class="OfferRow"
          *ngFor="let result of SideOffers; index as i"
          (click)="SwitchGridProductOffer(result)"
          [ngClass]="{ 'SelectedRow': result.IsSelected, 'GridValid': result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true }">

          <div class="GridCell indexx-column">
            {{i + 1}}
          </div>
          <div class="GridCell brand-column">
            {{result.Product?.Brand?.Name}}
          </div>

          <div class="GridCell partnumber-column">
            {{result.Product?.PartNumber}}
          </div>

          <div class="GridCell name-column">
            <i class="material-icons SelectedGridRowName" *ngIf="result.IsSelected == true;">check</i>
            <span>{{result.Product?.Name}}</span>
            <span class="GridCellSpecialPriceSignal" *ngIf="result.SelectedOffer?.Configuration?.SpecialPriceList == true;">({{'SpecialPriceOffer' | translate}})</span>
          </div>

        <div class="GridCell qty-column">
            {{result.Quantity}}
        </div>

        <div class="GridCell price-column">
          <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
            {{result.Price?.UIUnitPrice}} {{result.Price?.Currency?.Symbol}}
          </span>
        </div>

        <div class="GridCell total-column">
          <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
            {{result.Price?.UIQtyPrice}}  {{result.Price?.Currency?.Symbol}}
          </span>
        </div>

        <div class="GridCell eta-column" style="display: flex; align-items: center;">
          <i class="material-icons"
             *ngIf="result.Product?.Stats?.TrustedManufacturerLeadTime === true"
             style="color: #32aa3a; font-size: 18px; margin-right: 6px; vertical-align: middle; cursor: help;"
             [matTooltip]="'Manufacturer stock: ' + (result.Product?.Stats?.ManufacturerStock != null ? result.Product?.Stats?.ManufacturerStock : '-') + '\nTrusted information'"
             matTooltipClass="trusted-tooltip">verified</i>
          <span>{{result.SelectedOffer?.LeadTime?.UIOutput}}</span>
          <span *ngIf="result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true;">(Stock)</span>
        </div>

        <div class="GridCell supplier-column" *ngIf="isAdministrator()">
          <span *ngIf="result.SelectedOffer?.Partner?.Name">{{result.SelectedOffer?.Partner?.Name}}</span>
          <span *ngIf="!result.SelectedOffer?.Partner?.Name">{{result.SelectedOffer?.Configuration?.Name}}</span>
        </div>

        <div class="GridCell purchase-column" *ngIf="isAdministrator()">
          <span *ngIf="result.SelectedOffer?.ListPrice > 0;"
                [ngClass]="{
                  'purchase-price-green': result.SelectedOffer?.ListPrice < result.Price?.UIUnitPrice,
                  'purchase-price-red': result.SelectedOffer?.ListPrice >= result.Price?.UIUnitPrice
                }">
            {{result.SelectedOffer?.ListPrice}} {{result.SelectedOffer?.Currency?.Symbol}}
          </span>
        </div>

        <div class="GridCell hscode-column">
          {{result.Product?.Stats?.HSCode}}
        </div>

        <div class="GridCell coo-column">
          {{result.Product?.Stats?.COO?.ShortName}}
        </div>

        <div class="GridCell weight-column">
          <span *ngIf="result.Product?.Stats?.Weight > 0;">
            {{result.Product?.Stats?.Weight}} {{result.Product?.Stats?.WeightMeasurementType?.Name}}
          </span>
        </div>
        <div class="GridCell x-column">

        </div>
      </div>
    </div>

    <!-- ✅ Tab 3: Similar Products -->
    <div class="SearchResultsList" *ngIf="LoadingSideOffers !== true && selectedNamePopupTab === 3">

      <!-- ✅ Admin Grid: Grid-style alternative products -->
      <ng-container *ngIf="isAdministrator()">
        <div class="OfferRow">
          <div class="GridCell indexx-column" style="font-style: italic;">
            #
          </div>
          <div class="GridCell brand-column" style="font-style: italic;">
            {{'Brand' | translate}}
          </div>

          <div class="GridCell partnumber-column" style="font-style: italic;">
          {{'ProductCode' | translate}}
          </div>

          <div class="GridCell name-column" style="font-style: italic;">
          {{'ProductName' |  translate}}
          </div>

        <div class="GridCell qty-column" style="font-style: italic;">
          min.{{'Quantity' |  translate}}
        </div>

        <div class="GridCell price-column" style="font-style: italic;">
          {{'SellPrice' |  translate}}
        </div>

        <div class="GridCell total-column" style="font-style: italic;">
          {{'Total' |  translate}}
        </div>

        <div class="GridCell eta-column" style="font-style: italic;">
          {{'ETA' |  translate}}
        </div>

        <div class="GridCell supplier-column" style="font-style: italic;">
          Supplier
        </div>

        <div class="GridCell purchase-column" style="font-style: italic;">
          Purchase
        </div>

        <div class="GridCell hscode-column" style="font-style: italic;">
          {{'HSCode' |  translate}}
        </div>

        <div class="GridCell coo-column" style="font-style: italic;">
          {{'COO' |  translate}}
        </div>

        <div class="GridCell weight-column" style="font-style: italic;">
          {{'Weight' |  translate}}
        </div>
        <div class="GridCell x-column" style="font-style: italic;">
        </div>
    </div>
        <div class="OfferRow"
            *ngFor="let result of AlternativeProducts; index as i"
            (click)="SwitchGridResultProduct(result)"
            [ngClass]="{ 'SelectedRow': result.IsSelected, 'GridValid': result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true }">

            <div class="GridCell indexx-column">
              {{i + 1}}
            </div>
            <div class="GridCell brand-column">
              {{result.Product?.Brand?.Name}}
            </div>

            <div class="GridCell partnumber-column">
              {{result.Product?.PartNumber}}
            </div>

            <div class="GridCell name-column">
              <i class="material-icons SelectedGridRowName" *ngIf="result.IsSelected == true;">check</i>
              <span>{{result.Product?.Name}}</span>
              <span class="GridCellSpecialPriceSignal" *ngIf="result.SelectedOffer?.Configuration?.SpecialPriceList == true;">({{'SpecialPriceOffer' | translate}})</span>
            </div>

          <div class="GridCell qty-column">
              {{result.Quantity}}
          </div>

          <div class="GridCell price-column">
            <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
              {{result.Price?.UIUnitPrice}} {{result.Price?.Currency?.Symbol}}
            </span>
          </div>

          <div class="GridCell total-column">
            <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
              {{result.Price?.UIQtyPrice}}  {{result.Price?.Currency?.Symbol}}
            </span>
          </div>

          <div class="GridCell eta-column" style="display: flex; align-items: center;">
            <i class="material-icons"
               *ngIf="result.Product?.Stats?.TrustedManufacturerLeadTime === true"
               style="color: #32aa3a; font-size: 18px; margin-right: 6px; vertical-align: middle; cursor: help;"
               [matTooltip]="'Manufacturer stock: ' + (result.Product?.Stats?.ManufacturerStock != null ? result.Product?.Stats?.ManufacturerStock : '-') + '\nTrusted information'"
               matTooltipClass="trusted-tooltip">verified</i>
            <span>{{result.SelectedOffer?.LeadTime?.UIOutput}}</span>
            <span *ngIf="result.SelectedOffer?.IsStockOffer == true && result.SelectedOffer?.IsManufacturerStockOffer != true;">(Stock)</span>
          </div>

          <div class="GridCell supplier-column">
            <span *ngIf="result.SelectedOffer?.Partner?.Name">{{result.SelectedOffer?.Partner?.Name}}</span>
            <span *ngIf="!result.SelectedOffer?.Partner?.Name">{{result.SelectedOffer?.Configuration?.Name}}</span>
          </div>

          <div class="GridCell purchase-column">
            <span *ngIf="result.SelectedOffer?.ListPrice > 0;"
                  [ngClass]="{
                    'purchase-price-green': result.SelectedOffer?.ListPrice < result.Price?.UIUnitPrice,
                    'purchase-price-red': result.SelectedOffer?.ListPrice >= result.Price?.UIUnitPrice
                  }">
              {{result.SelectedOffer?.ListPrice}} {{result.SelectedOffer?.Currency?.Symbol}}
            </span>
          </div>

          <div class="GridCell hscode-column">
            {{result.Product?.Stats?.HSCode}}
          </div>

          <div class="GridCell coo-column">
            {{result.Product?.Stats?.COO?.ShortName}}
          </div>

          <div class="GridCell weight-column">
            <span *ngIf="result.Product?.Stats?.Weight > 0;">
              {{result.Product?.Stats?.Weight}} {{result.Product?.Stats?.WeightMeasurementType?.Name}}
            </span>
          </div>
          <div class="GridCell x-column">

          </div>
        </div>
      </ng-container>

      <!-- ✅ Regular User: Simple list design -->
      <ng-container *ngIf="!isAdministrator()">
        <div class="SearchResultItem" *ngFor="let result of SearchResultAlternatives" (click)="SwitchGridResultAlternative(result)" [ngClass]="{ 'SelectedItem': result.IsSelected }">
          <div class="SearchResultTitle">
            {{ result.ProductName }} {{ result.ProductPartNumber }}
            <span *ngIf="result.IsSelected" class="SelectedTag">✓ {{ 'Selected' | translate }}</span>
          </div>

          <div class="SearchResultMeta">
            <span class="SearchResultBrand">{{ result.FKBrandName }}</span>
          </div>
        </div>
      </ng-container>

    </div>

  </div>

  <!-- ✅ NEW: Supplier Alternatives Popup (only shows when data is loaded) -->
  <div class="SearchResultsAlternativesContainer grid-style-popup supplier-alternatives-popup animated fadeIn"
      *ngIf="ShowSupplierAlternatives === true && LoadingSideOffers !== true && (SideOffers?.length > 0 || SupplierPopupSearchTerm?.length > 0)"
      [ngStyle]="SearchResultsPosition">

    <!-- ✅ Search Textbox -->
    <div style="padding: 8px; border-bottom: 1px solid #e0e0e0;">
      <input
        type="text"
        class="supplier-popup-search-input"
        placeholder="Search supplier..."
        [(ngModel)]="SupplierPopupSearchTerm"
        (ngModelChange)="SearchSupplierPopup()"
        style="width: 100%; padding: 6px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 11px; outline: none; box-sizing: border-box;"
      />
    </div>

    <!-- ✅ Show search results when searching -->
    <div *ngIf="SupplierPopupSearchTerm?.length > 0 && SupplierPopupSearchResults?.length > 0">
      <div class="supplier-popup-item" *ngFor="let partner of SupplierPopupSearchResults" (click)="SelectPartnerFromSearch(partner)">
        <div class="supplier-popup-column" style="flex: 1; padding: 8px 12px;">
          {{ partner?.Name }}
        </div>
      </div>
    </div>

    <!-- ✅ Show original side offers when NOT searching -->
    <div *ngIf="!SupplierPopupSearchTerm || SupplierPopupSearchTerm?.length === 0">
      <div class="supplier-popup-item" *ngFor="let cartItem of SideOffers" (click)="SelectSideOffer(cartItem)">
        <div class="supplier-popup-column supplier-name-column">
          <span *ngIf="cartItem?.SelectedOffer?.MOQ > 0">[{{ cartItem?.SelectedOffer?.MOQ }}] </span>{{ cartItem?.SelectedOffer?.Partner?.Name || 'N/A' }}
        </div>
        <div class="supplier-popup-column purchase-info-column">
          {{ cartItem?.SelectedOffer?.ListPrice || 'N/A' }} {{ cartItem?.SelectedOffer?.PurchaseCurrency?.Symbol || cartItem?.SelectedOffer?.Currency?.Symbol || 'N/A' }}
        </div>
        <div class="supplier-popup-column stock-column">
          <span *ngIf="cartItem?.SelectedOffer?.StockQuantity > 0">STOCK</span>
        </div>
        <div class="supplier-popup-column leadtime-column">
          <span *ngIf="cartItem?.SelectedOffer?.LeadTime?.Units > 0">
            {{ cartItem.SelectedOffer.LeadTime.Units }} {{ cartItem.SelectedOffer.LeadTime.Type?.Name || '' }}
          </span>
          <span *ngIf="!cartItem?.SelectedOffer?.LeadTime?.Units || cartItem?.SelectedOffer?.LeadTime?.Units <= 0">
            ------
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- ✅ NEW: Red Row ETA Popup -->
  <div class="SearchResultsAlternativesContainer grid-style-popup animated fadeIn"
      *ngIf="ShowRedRowETAPopup === true"
      [ngStyle]="SearchResultsPosition">

    <div class="SearchResultsHeader">
      <span>{{ 'ConfigureLeadTime' | translate }}</span>
      <button class="CloseBtn" (click)="ShowRedRowETAPopup = false">×</button>
    </div>

    <div class="SearchResultsList" style="padding: 30px;">

      <!-- ✅ Smart Autocomplete Textbox (PartnerSearchBar style) -->
      <div style="margin-bottom: 20px; position: relative;">
        <div class="PartnerSearchBar" style="height: 38px;">
          <!-- ✅ Search Icon -->
          <i class="material-icons search-icon">schedule</i>

          <!-- ✅ Container for layered inputs -->
          <div style="flex: 1; position: relative; display: flex; align-items: center;">
            <!-- ✅ Faded suggestion text (background layer) - shows full suggestion with user input invisible -->
            <div class="lead-time-suggestion-overlay">
              <span style="visibility: hidden;">{{ LeadTimeSmartInput }}</span><span style="color: #777; font-weight: 600;">{{ LeadTimeInlineSuggestion?.substring(LeadTimeSmartInput?.length || 0) }}</span>
            </div>

            <!-- ✅ Actual input (foreground layer) -->
            <input type="text"
                   class="PartnerSearchInput"
                   [(ngModel)]="LeadTimeSmartInput"
                   name="leadTimeSmartInput"
                   (ngModelChange)="OnLeadTimeSmartInputChange($event)"
                   (keydown.tab)="OnLeadTimeSmartInputTab($event)"
                   (keydown.enter)="OnLeadTimeSmartInputEnter($event)"
                   (keydown.arrowRight)="OnLeadTimeSmartInputArrowRight($event)"
                   autocomplete="off"
                   placeholder="Type lead time (e.g., 2 weeks, 1 month)"
                   style="position: relative; z-index: 2; background: transparent; font-size: 14px; font-weight: 600;">
          </div>

          <!-- ✅ Clear Icon (Red X) -->
          <i class="material-icons clear-icon"
             (click)="ClearLeadTime()"
             *ngIf="LeadTimeSmartInput?.length > 0"
             style="color: #d32f2f;"
             title="Clear lead time">close</i>
        </div>
      </div>

      <!-- OK Button (GridCommandButtonBlue style) -->
      <div style="display: flex; justify-content: center;">
        <button class="GridCommandButton GridCommandButtonBlue"
                style="width: 100%; justify-content: center; height: 38px; font-size: 13px; font-weight: 600;"
                (click)="SaveRedRowLeadTime()">
          <i class="material-icons">check</i>
          <span>OK</span>
        </button>
      </div>
    </div>
  </div>

  <!-- ✅ NEW: Weight Popup for Red Rows -->
  <div class="SearchResultsAlternativesContainer grid-style-popup animated fadeIn"
      *ngIf="ShowWeightPopup === true"
      [ngStyle]="SearchResultsPosition">

    <div class="SearchResultsHeader">
      <span>Configure Weight</span>
      <button class="CloseBtn" (click)="ShowWeightPopup = false">×</button>
    </div>

    <div class="SearchResultsList" style="padding: 30px;">
      <div style="display: flex; gap: 20px; align-items: center; justify-content: flex-start; margin-bottom: 20px;">

        <!-- Weight Type Dropdown -->
        <mat-form-field appearance="outline" style="width: 250px;">
          <mat-label>Weight Type</mat-label>
          <mat-select [(ngModel)]="SelectedWeightType" name="weightType" [compareWith]="parent.compareFn">
            <mat-option *ngFor="let type of WeightMeasurementTypes" [value]="type">
              {{ type.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Weight Units Dropdown (0-100) -->
        <mat-form-field appearance="outline" style="width: 150px;">
          <mat-label>Units (0-100)</mat-label>
          <mat-select [(ngModel)]="SelectedWeightUnits" name="weightUnits">
            <mat-option *ngFor="let unit of WeightUnits" [value]="unit">
              {{ unit }}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>

      <!-- OK Button -->
      <div style="display: flex; justify-content: center; margin-top: 10px;">
        <button mat-raised-button
                style="width: 100%;
                       background-color: #32aa3a;
                       color: white;
                       font-weight: 600;
                       font-size: 16px;
                       padding: 0px;
                       border-radius: 4px;"
                (click)="SaveWeight()">
          OK
        </button>
      </div>
    </div>
  </div>

  </div>
</div>

<!-- ✅ Stock Readjusted Popup (Apple-style) -->
<div class="stock-readjusted-popup-container" *ngIf="showStockReadjustedPopup">
  <div class="stock-readjusted-popup">
    <div class="stock-readjusted-icon">
      <i class="material-icons">info</i>
    </div>
    <div class="stock-readjusted-message">
      {{ stockReadjustedMessage }}
    </div>
    <div class="stock-readjusted-products" *ngIf="stockReadjustedProducts?.length > 0">
      <div class="stock-readjusted-product" *ngFor="let product of stockReadjustedProducts">
        [{{ product }}]
      </div>
    </div>
    <div class="stock-readjusted-actions">
      <button class="stock-readjusted-ok-btn" (click)="showStockReadjustedPopup = false;">
        OK
      </button>
    </div>
  </div>
</div>

<!-- Delete Year Settings Confirmation Popup -->
<div class="ModernInfoQuestion" *ngIf="ShowDeleteYearSettingsQuestion">
  <div class="ModernInfoQuestionHeader">
    <div class="ModernInfoQuestionIcon danger">
      <i class="material-icons">warning</i>
    </div>
    <div class="ModernInfoQuestionTitle">{{ 'Configuration.DeleteQuestion' | translate }}</div>
  </div>
  <div class="ModernInfoQuestionBody">
    <p class="ModernInfoQuestionText">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
  </div>
  <div class="ModernInfoQuestionFooter">
    <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowDeleteYearSettingsQuestion = false;">
      {{ 'Configuration.DeleteNoButton' | translate }}
    </button>
    <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowDeleteYearSettingsQuestion = false; DeletePartnersB2BHistoryYearSettings(this.CurrentYearSettings);">
      <i class="material-icons">delete</i>
      {{ 'Configuration.DeleteYesButton' | translate }}
    </button>
  </div>
</div>

<!-- Year Settings Brand Change Popup -->
<div class="NewProfitSettingsContainer" style="height: 40vh;" *ngIf="ShowYearSettingsBrandChange == true;">
  <div class="NewProfitSettingsContainerTitle">{{'ChooseBrand' | translate}}</div>
  <div class="NewProfitSettingsContainerClose" (click)="ShowYearSettingsBrandChange = false;">
    <i class="material-icons">close</i>
  </div>
  <div class="NewProfitSettingsContainerBody">
    <div class="NewProfitSettingsContainerBodyRow">
      <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
        <label class="ModernFormLabel">{{'SelectBrand' | translate}}</label>
        <div class="ModernDropdownContainer">
          <input class="ModernFormInput" type="text"
                 placeholder="{{'SelectBrand' | translate}}"
                 [(ngModel)]="YearSettingBrandSearchTerm"
                 (ngModelChange)="SearchBrandsForYearSettings($event)">
          <div class="ModernDropdownResults" *ngIf="YearSettingBrands?.length > 0" style="top: 100%; margin-top: 4px;">
            <div class="ModernDropdownOption" *ngFor="let brand of YearSettingBrands"
                 (click)="SelectBrandForYearsSetting(brand); YearSettingBrandSearchTerm = brand.Name;">
              {{brand.Name}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="NewProfitSettingsContainerCommands">
    <button class="GridCommandButton success" (click)="ShowYearSettingsBrandChange = false;">
      <i class="material-icons">save_alt</i>
      <span>{{'SaveButton' | translate}}</span>
    </button>
  </div>
</div>

<!-- New Year Settings Brand Change Popup -->
<div class="NewProfitSettingsContainer" style="height: 40vh;" *ngIf="ShowNewYearSettingsBrandChange == true;">
  <div class="NewProfitSettingsContainerTitle">{{'ChooseBrand' | translate}}</div>
  <div class="NewProfitSettingsContainerClose" (click)="ShowNewYearSettingsBrandChange = false;">
    <i class="material-icons">close</i>
  </div>
  <div class="NewProfitSettingsContainerBody">
    <div class="NewProfitSettingsContainerBodyRow">
      <div class="ModernFormGroup" style="margin-left: 5%; width: 90%;">
        <label class="ModernFormLabel">{{'SelectBrand' | translate}}</label>
        <div class="ModernDropdownContainer">
          <input class="ModernFormInput" type="text"
                 placeholder="{{'SelectBrand' | translate}}"
                 [(ngModel)]="YearSettingBrandSearchTerm"
                 (ngModelChange)="SearchBrandsForYearSettings($event)">
          <div class="ModernDropdownResults" *ngIf="YearSettingBrands?.length > 0" style="top: 100%; margin-top: 4px;">
            <div class="ModernDropdownOption" *ngFor="let brand of YearSettingBrands"
                 (click)="SelectBrandForNewYearsSetting(brand); YearSettingBrandSearchTerm = brand.Name;">
              {{brand.Name}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="NewProfitSettingsContainerCommands">
    <button class="GridCommandButton success" (click)="ShowNewYearSettingsBrandChange = false;">
      <i class="material-icons">save_alt</i>
      <span>{{'SaveButton' | translate}}</span>
    </button>
  </div>
</div>

<!-- ✅ Partner Details Popup - Matching partnersdata component design (Read-Only) -->
<div class="ModernPopupOverlay" *ngIf="ShowPartnerDetailsPopup">
  <div class="ModernPopup xlarge" style="height: 90vh;">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">business</i>
        <span>{{'PartnerDetails' | translate}}: {{PartnerDetails?.Name}} ({{PartnerDetails?.Code}})</span>
      </div>
      <button class="ModernPopupClose" (click)="ClosePartnerDetailsPopup()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Tab Navigation -->
    <div class="GridCommandCenter" style="padding: 12px 20px; background: #f8f9fa; border-bottom: 1px solid #e9ecef; margin: 0; width: auto;">
      <button class="GridCommandButton" [class.primary]="ShowBillingInfo"
              (click)="ShowB2BRestrictions = false; ShowBillingInfo = true; ShowShippingInfo = false; ShowAgentsInfo = false; ShowProcessingSettings = false; ShowProfitSettings = false; ShowContractualConditions = false;">
        <i class="material-icons">receipt</i>
        {{'ViewBillingInformation' | translate}}
      </button>

      <!-- Shipping Info - Data already loaded on popup open -->
      <button class="GridCommandButton" [class.primary]="ShowShippingInfo"
              (click)="ShowB2BRestrictions = false; ShowShippingInfo = true; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProcessingSettings = false; ShowProfitSettings = false; ShowContractualConditions = false;">
        <i class="material-icons">local_shipping</i>
        {{'ViewShippingInformation' | translate}}
      </button>

      <!-- Agents - Load on click -->
      <button class="GridCommandButton" [class.primary]="ShowAgentsInfo"
              (click)="ShowB2BRestrictions = false; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = true; ShowProcessingSettings = false; ShowProfitSettings = false; ShowContractualConditions = false; LoadPartnerAgents();">
        <i class="material-icons">people</i>
        {{'ViewAgentsInformation' | translate}}
      </button>

      <!-- Profit Settings - Load on click -->
      <button class="GridCommandButton" [class.primary]="ShowProfitSettings"
              (click)="ShowB2BRestrictions = false; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProcessingSettings = false; ShowProfitSettings = true; ShowContractualConditions = false; LoadPartnerProfitSettings();">
        <i class="material-icons">trending_up</i>
        {{'ViewProfitSettings' | translate}}
      </button>

      <!-- Processing Settings - Load on click -->
      <button class="GridCommandButton" [class.primary]="ShowProcessingSettings"
              (click)="ShowB2BRestrictions = false; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProfitSettings = false; ShowProcessingSettings = true; ShowContractualConditions = false; LoadPartnerProcessingSettings();">
        <i class="material-icons">settings</i>
        {{'ProcessingSettings' | translate}}
      </button>

      <!-- B2B Settings & Restrictions - Load on click -->
      <button class="GridCommandButton" [class.primary]="ShowB2BRestrictions"
              (click)="ShowB2BRestrictions = true; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProfitSettings = false; ShowProcessingSettings = false; ShowContractualConditions = false; LoadPartnerB2BData();">
        <i class="material-icons">security</i>
        {{'B2BSettingsAndRestrictions' | translate}}
      </button>

      <!-- Contractual Conditions - Load on click -->
      <button class="GridCommandButton" [class.primary]="ShowContractualConditions"
              (click)="ShowB2BRestrictions = false; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProfitSettings = false; ShowProcessingSettings = false; ShowContractualConditions = true; LoadPartnerContractualConditions();">
        <i class="material-icons">description</i>
        {{'ContractualConditions' | translate}}
      </button>
    </div>

    <div class="ModernPopupBody" style="height: calc(90vh - 180px); padding: 20px; padding-bottom: 0;">

      <!-- Billing Info Tab -->
      <div *ngIf="ShowBillingInfo" class="fullWidth">
        <div class="ModernFormHalf">
          <div class="ModernFormSectionTitle">
            <i class="material-icons">business</i>
            {{'GeneralInformation' | translate}}
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Name' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Name' | translate }}" autocomplete="off" [(ngModel)]="PartnerDetails.Name">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'VAT' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'VAT' | translate }}" autocomplete="off" [(ngModel)]="PartnerDetails.VAT">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'UPN' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'UPN' | translate }}" autocomplete="off" [(ngModel)]="PartnerDetails.UPN">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'COCRegNumber' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'COCRegNumber' | translate }}" autocomplete="off" [(ngModel)]="PartnerDetails.COCRegNumber">
          </div>

          <div class="ModernFormSectionTitle" style="margin-top: 24px;">
            <i class="material-icons">location_on</i>
            {{'BillingAddress' | translate}}
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel">{{ 'Country' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showPartnerBillingCountryDropdown" (click)="showPartnerBillingCountryDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showPartnerBillingCountryDropdown" (click)="showPartnerBillingCountryDropdown = !showPartnerBillingCountryDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.BillingAddress?.Country">
                  {{PartnerDetails?.BillingAddress?.Country?.Name || ('SelectCountry' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showPartnerBillingCountryDropdown">
                <div class="ModernDropdownOption" *ngFor="let c of PartnerCountries"
                     [class.selected]="PartnerDetails?.BillingAddress?.Country?.ID === c.ID"
                     (click)="PartnerDetails.BillingAddress.Country = c; showPartnerBillingCountryDropdown = false;">
                  {{c.Name}}
                  <i class="material-icons check-icon" *ngIf="PartnerDetails?.BillingAddress?.Country?.ID === c.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'StateProvince' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'StateProvince' | translate }}" autocomplete="off" [(ngModel)]="PartnerDetails.BillingAddress.StateProvince">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'City' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'City' | translate }}" autocomplete="off" [(ngModel)]="PartnerDetails.BillingAddress.City">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Address' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Address' | translate }}" autocomplete="off" [(ngModel)]="PartnerDetails.BillingAddress.AddressLine">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'ZipCode' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'ZipCode' | translate }}" autocomplete="off" [(ngModel)]="PartnerDetails.BillingAddress.ZipCode">
          </div>
        </div>

        <div class="ModernFormHalf">
          <div class="ModernFormSectionTitle">
            <i class="material-icons">account_balance</i>
            {{'Partners.PartnerWindow.Bank' | translate}}
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel">{{ 'Partners.PartnerWindow.Bank' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showPartnerBankDropdown" (click)="showPartnerBankDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showPartnerBankDropdown" (click)="showPartnerBankDropdown = !showPartnerBankDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.Bank">
                  {{PartnerDetails?.Bank?.Name || ('SelectBank' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showPartnerBankDropdown">
                <div class="ModernDropdownOption" *ngFor="let b of PartnerBanks"
                     [class.selected]="PartnerDetails?.Bank?.ID === b.ID"
                     (click)="PartnerDetails.Bank = b; showPartnerBankDropdown = false;">
                  {{b.Name}}
                  <i class="material-icons check-icon" *ngIf="PartnerDetails?.Bank?.ID === b.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Swift' | translate }}</label>
            <input type="text" class="ModernFormInput" disabled placeholder="{{ 'Swift' | translate }}" autocomplete="off" [(ngModel)]="PartnerDetails.Bank.Swift">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}" autocomplete="off" [(ngModel)]="PartnerDetails.Bank.BankAccount">
          </div>

          <div class="ModernFormSectionTitle" style="margin-top: 24px;">
            <i class="material-icons">person</i>
            {{'Partners.PartnerWindow.ContactInfo' | translate}}
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel">Email</label>
            <input type="email" class="ModernFormInput" placeholder="Email" autocomplete="off" [(ngModel)]="PartnerDetails.ContactInfo.Email">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Partners.PartnerWindow.Name' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Partners.PartnerWindow.Name' | translate }}" autocomplete="off" [(ngModel)]="PartnerDetails.ContactInfo.Name">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Login.Phone' | translate }}</label>
            <input type="tel" class="ModernFormInput" placeholder="{{ 'Login.Phone' | translate }}" autocomplete="off" [(ngModel)]="PartnerDetails.ContactInfo.Phone">
          </div>

          <div style="margin-top: 24px;">
            <button class="ModernActionButton primary" (click)="UpdatePartnerDetails();">
              <i class="material-icons">save</i>
              {{'SaveButton' | translate}}
            </button>
          </div>
        </div>
      </div>

      <!-- Shipping Info Tab -->
      <div *ngIf="ShowShippingInfo" class="fullWidth" style="height: auto; float: left; padding: 0;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">local_shipping</i>
          {{'ShippingAddresses' | translate}}
        </div>

        <div style="margin-bottom: 20px;">
          <button class="ModernActionButton success" (click)="GeneratePartnerInitialShippingAddress();">
            <i class="material-icons">add</i>
            {{'GenerateInitialShippingAddress' | translate}}
          </button>
        </div>

        <div class="ModernFormGroup" *ngIf="PartnerDetails?.ShippingAddresses?.length > 0;">
          <label class="ModernFormLabel">{{ 'ShippingAddresses' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownOverlay" *ngIf="showPartnerShippingAddressDropdown" (click)="showPartnerShippingAddressDropdown = false"></div>
            <div class="ModernDropdownBar" [class.open]="showPartnerShippingAddressDropdown" (click)="showPartnerShippingAddressDropdown = !showPartnerShippingAddressDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!CurrentPartnerShippingAddress">
                {{CurrentPartnerShippingAddress ? (CurrentPartnerShippingAddress.Country?.Name + ' ' + CurrentPartnerShippingAddress.City + ' ' + CurrentPartnerShippingAddress.AddressLine) : ('SelectAddress' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="showPartnerShippingAddressDropdown">
              <div class="ModernDropdownOption" *ngFor="let a of PartnerDetails.ShippingAddresses"
                   [class.selected]="CurrentPartnerShippingAddress?.ID === a.ID"
                   (click)="CurrentPartnerShippingAddress = a; showPartnerShippingAddressDropdown = false;">
                {{a.Country?.Name}} {{a.City}} {{a.AddressLine}}
                <i class="material-icons check-icon" *ngIf="CurrentPartnerShippingAddress?.ID === a.ID">check</i>
              </div>
            </div>
          </div>
        </div>

        <div class="ModernFormHalf" *ngIf="CurrentPartnerShippingAddress" style="margin-top: 20px;">
          <div class="ModernFormSectionTitle">
            <i class="material-icons">edit_location</i>
            {{'AddressDetails' | translate}}
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel">{{ 'Country' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showPartnerShippingCountryDropdown" (click)="showPartnerShippingCountryDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showPartnerShippingCountryDropdown" (click)="showPartnerShippingCountryDropdown = !showPartnerShippingCountryDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!CurrentPartnerShippingAddress?.Country">
                  {{CurrentPartnerShippingAddress?.Country?.Name || ('SelectCountry' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showPartnerShippingCountryDropdown">
                <div class="ModernDropdownOption" *ngFor="let c of PartnerCountries"
                     [class.selected]="CurrentPartnerShippingAddress?.Country?.ID === c.ID"
                     (click)="CurrentPartnerShippingAddress.Country = c; showPartnerShippingCountryDropdown = false;">
                  {{c.Name}}
                  <i class="material-icons check-icon" *ngIf="CurrentPartnerShippingAddress?.Country?.ID === c.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'StateProvince' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'StateProvince' | translate }}" autocomplete="off" [(ngModel)]="CurrentPartnerShippingAddress.State">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'City' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'City' | translate }}" autocomplete="off" [(ngModel)]="CurrentPartnerShippingAddress.City">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Address' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Address' | translate }}" autocomplete="off" [(ngModel)]="CurrentPartnerShippingAddress.AddressLine">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'ZipCode' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'ZipCode' | translate }}" autocomplete="off" [(ngModel)]="CurrentPartnerShippingAddress.ZipCode">
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="CurrentPartnerShippingAddress.IsSelected">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'MainAddress' | translate}}</span>
          </div>
        </div>

        <div class="ModernFormHalf" *ngIf="CurrentPartnerShippingAddress" style="margin-top: 20px;">
          <div class="ModernFormSectionTitle">
            <i class="material-icons">person</i>
            {{'Partners.PartnerWindow.ContactInfo' | translate}}
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Partners.PartnerWindow.ContactInfo' | translate }}" autocomplete="off" [(ngModel)]="CurrentPartnerShippingAddress.ContactPerson">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Company' | translate }}</label>
            <input type="text" class="ModernFormInput" placeholder="{{ 'Company' | translate }}" autocomplete="off" [(ngModel)]="CurrentPartnerShippingAddress.ContactCompany">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Email' | translate }}</label>
            <input type="email" class="ModernFormInput" placeholder="{{ 'Email' | translate }}" autocomplete="off" [(ngModel)]="CurrentPartnerShippingAddress.Email">
          </div>

          <div class="ModernFormGroup">
            <label class="ModernFormLabel required">{{ 'Login.Phone' | translate }}</label>
            <input type="tel" class="ModernFormInput" placeholder="{{ 'Login.Phone' | translate }}" autocomplete="off" [(ngModel)]="CurrentPartnerShippingAddress.Phone">
          </div>

          <button class="ModernActionButton success" (click)="AddUpdatePartnerShippingAddress();">
            <i class="material-icons">save</i>
            {{'SaveButton' | translate}}
          </button>
        </div>

        <div *ngIf="!PartnerDetails?.ShippingAddresses || PartnerDetails.ShippingAddresses.length === 0" class="no-data-message" style="padding: 40px; text-align: center; color: #666;">
          <i class="material-icons" style="font-size: 48px; color: #ccc;">local_shipping</i>
          <p>{{'NoShippingAddresses' | translate}}</p>
        </div>
      </div>

      <!-- Agents Tab -->
      <div *ngIf="ShowAgentsInfo" class="fullWidth" style="height: auto; float: left; padding: 0;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">people</i>
          {{'AgentsInfo' | translate}}
        </div>

        <div class="ModernFormGroup" *ngIf="PartnerAgentsList?.length > 0;">
          <label class="ModernFormLabel">{{ 'Agents' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownOverlay" *ngIf="showPartnerAgentsDropdown" (click)="showPartnerAgentsDropdown = false"></div>
            <div class="ModernDropdownBar" [class.open]="showPartnerAgentsDropdown" (click)="showPartnerAgentsDropdown = !showPartnerAgentsDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!CurrentPartnerAgent">
                {{CurrentPartnerAgent?.Name || ('SelectAgent' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="showPartnerAgentsDropdown">
              <div class="ModernDropdownOption" *ngFor="let p of PartnerAgentsList"
                   [class.selected]="CurrentPartnerAgent?.ID === p.ID"
                   (click)="CurrentPartnerAgent = p; showPartnerAgentsDropdown = false;">
                {{p.Name}}
                <i class="material-icons check-icon" *ngIf="CurrentPartnerAgent?.ID === p.ID">check</i>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-bottom: 20px;">
          <button class="ModernActionButton success" (click)="InitializePartnerAgent();">
            <i class="material-icons">person_add</i>
            {{'AddNewAgent' | translate}}
          </button>
        </div>

        <div *ngIf="CurrentPartnerAgent">
          <div class="ModernFormGroup" *ngIf="PartnerDetails?.ShippingAddresses?.length > 0;">
            <label class="ModernFormLabel">{{ 'ShippingAddresses' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showPartnerAgentShippingDropdown" (click)="showPartnerAgentShippingDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showPartnerAgentShippingDropdown" (click)="showPartnerAgentShippingDropdown = !showPartnerAgentShippingDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!CurrentPartnerAgent.AllocatedShippingAddress">
                  {{CurrentPartnerAgent.AllocatedShippingAddress ? (CurrentPartnerAgent.AllocatedShippingAddress.Country?.Name + ' ' + CurrentPartnerAgent.AllocatedShippingAddress.City) : ('SelectAddress' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showPartnerAgentShippingDropdown">
                <div class="ModernDropdownOption" *ngFor="let a of PartnerDetails.ShippingAddresses"
                     [class.selected]="CurrentPartnerAgent.AllocatedShippingAddress?.ID === a.ID"
                     (click)="CurrentPartnerAgent.AllocatedShippingAddress = a; showPartnerAgentShippingDropdown = false;">
                  {{a.Country?.Name}} {{a.City}} {{a.AddressLine}}
                  <i class="material-icons check-icon" *ngIf="CurrentPartnerAgent.AllocatedShippingAddress?.ID === a.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormHalf">
            <div class="ModernFormGroup">
              <label class="ModernFormLabel required">{{ 'Name' | translate }}</label>
              <input type="text" class="ModernFormInput" placeholder="{{ 'Name' | translate }}" autocomplete="off" [(ngModel)]="CurrentPartnerAgent.Name">
            </div>

            <div class="ModernFormGroup">
              <label class="ModernFormLabel required">{{ 'Phone' | translate }}</label>
              <input type="tel" class="ModernFormInput" placeholder="{{ 'Phone' | translate }}" autocomplete="off" [(ngModel)]="CurrentPartnerAgent.Phone">
            </div>

            <div class="ModernFormGroup">
              <label class="ModernFormLabel required">{{ 'Email' | translate }}</label>
              <input type="email" class="ModernFormInput" placeholder="{{ 'Email' | translate }}" autocomplete="off" [(ngModel)]="CurrentPartnerAgent.Email">
            </div>

            <button class="ModernActionButton success" (click)="AddUpdatePartnerAgent();">
              <i class="material-icons">save</i>
              {{'SaveButton' | translate}}
            </button>
          </div>
        </div>

        <div *ngIf="!PartnerAgentsList || PartnerAgentsList.length === 0" class="no-data-message" style="padding: 40px; text-align: center; color: #666;">
          <i class="material-icons" style="font-size: 48px; color: #ccc;">people</i>
          <p>{{'NoAgentsAvailable' | translate}}</p>
        </div>
      </div>

      <!-- Profit Settings Tab -->
      <div *ngIf="ShowProfitSettings" class="fullWidth" style="height: auto; float: left; padding: 0;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">trending_up</i>
          {{'ProfitSettings' | translate}}
        </div>

        <div class="fullWidth">
          <div class="ProfitSettingsTable">
            <div class="ProfitSettingsRow ProfitSettingsHeadder">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>#</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 20%;">
                <span>{{'Client' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'DiscountGroup' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'ImportConfiguration' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'Brand' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'Percentage' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'Profit' | translate}}</span>
              </div>
            </div>

            <div class="ProfitSettingsRow" *ngFor="let ps of PartnerDetails?.PartnerProfitSettings; let i=index;">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>{{i + 1}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 20%;">
                <span *ngIf="ps.PartnerName != null && ps.PartnerName?.length > 0;">{{ps.PartnerName}}</span>
                <span *ngIf="ps.PartnerName == null || ps.PartnerName?.length == 0;">-----</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span *ngIf="ps.DiscountGroup != null;">{{ps.DiscountGroup?.GroupName}} </span>
                <span *ngIf="ps.DiscountGroup != null;">({{ps.DiscountGroup?.DiscountValue}}%)</span>
                <span *ngIf="ps.DiscountGroup == null;">-----</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span *ngIf="ps.ImportConfiguration != null;">{{ps.ImportConfiguration?.Name}}</span>
                <span *ngIf="ps.ImportConfiguration == null;">-----</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span *ngIf="ps.Brand != null;">{{ps.Brand?.Name}}</span>
                <span *ngIf="ps.Brand == null;">-----</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span *ngIf="ps.Percentage != null;">{{ps.Percentage}}% {{ps.PercentageImpact?.Name}}</span>
                <span *ngIf="ps.Percentage == null;">-----</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span *ngIf="ps.PercentageImpact != null;">{{ps.PercentageImpact?.PercentageProfitMargin}}%</span>
                <span *ngIf="ps.PercentageImpact == null;">-----</span>
              </div>
            </div>
          </div>

          <div *ngIf="!PartnerDetails?.PartnerProfitSettings || PartnerDetails?.PartnerProfitSettings?.length === 0" class="no-data-message" style="padding: 40px; text-align: center; color: #666;">
            <i class="material-icons" style="font-size: 48px; color: #ccc;">trending_up</i>
            <p>{{'NoProfitSettingsAvailable' | translate}}</p>
          </div>
        </div>
      </div>

      <!-- Processing Settings Tab -->
      <div *ngIf="ShowProcessingSettings" class="fullWidth" style="height: auto; float: left; padding: 0;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">settings</i>
          <span>{{'ProcessingSettings' | translate}}</span>
        </div>

        <div class="ModernFormHalf">
          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="PartnerDetails.ProcessingSettings.NotifiesWithAttachments">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'NotifiesWithAttachments' | translate}}</span>
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="PartnerDetails.ProcessingSettings.AutoPrinting">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'AutoPrinting' | translate}}</span>
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="PartnerDetails.ProcessingSettings.GenerateInvoice">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'GenerateInvoice' | translate}}</span>
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="PartnerDetails.ProcessingSettings.GenerateTrackingLabel">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'GenerateTrackingLabel' | translate}}</span>
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="PartnerDetails.ProcessingSettings.SeparateOrderInvoices">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'SeparateOrderInvoices' | translate}}</span>
          </div>
        </div>

        <div class="ModernFormHalf">
          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="PartnerDetails.ProcessingSettings.GenerateQWCertificate">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'GenerateQWCertificate' | translate}}</span>
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="PartnerDetails.ProcessingSettings.PrintOnlyDeliveryNote">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'PrintOnlyDeliveryNote' | translate}}</span>
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="PartnerDetails.ProcessingSettings.SendInvoiceOnlyToAccountingDepartment">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'SendInvoiceOnlyToAccountingDepartment' | translate}}</span>
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="PartnerDetails.ProcessingSettings.SellThroughPartnerCompany">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'SellingPartnerCompany' | translate}}</span>
          </div>
        </div>

        <div style="width: 100%; float: left; clear: both; margin-top: 20px; padding-bottom: 250px;">
          <div class="ModernFormRow">
            <div class="ModernFormGroup" style="width: 30%;">
              <label class="ModernFormLabel">{{ 'ProcessingSettingsCurrency' | translate }}</label>
              <div class="ModernDropdownContainer">
                <div class="ModernDropdownOverlay" *ngIf="showProcessingCurrencyDropdown" (click)="showProcessingCurrencyDropdown = false"></div>
                <div class="ModernDropdownBar" [class.open]="showProcessingCurrencyDropdown" (click)="showProcessingCurrencyDropdown = !showProcessingCurrencyDropdown">
                  <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.ProcessingSettings?.Currency">
                    {{PartnerDetails?.ProcessingSettings?.Currency?.Name || ('SelectCurrency' | translate)}}
                  </span>
                  <i class="material-icons ModernDropdownArrow">expand_more</i>
                </div>
                <div class="ModernDropdownResults" *ngIf="showProcessingCurrencyDropdown">
                  <div class="ModernDropdownOption" *ngFor="let c of Currencies"
                       [class.selected]="PartnerDetails?.ProcessingSettings?.Currency?.ID === c.ID"
                       (click)="PartnerDetails.ProcessingSettings.Currency = c; showProcessingCurrencyDropdown = false;">
                    {{c.Name}}
                    <i class="material-icons check-icon" *ngIf="PartnerDetails?.ProcessingSettings?.Currency?.ID === c.ID">check</i>
                  </div>
                </div>
              </div>
            </div>

            <div class="ModernFormGroup" style="width: 30%;">
              <label class="ModernFormLabel">{{ 'DecimalPercision' | translate }}</label>
              <div class="ModernDropdownContainer">
                <div class="ModernDropdownOverlay" *ngIf="showProcessingDecimalDropdown" (click)="showProcessingDecimalDropdown = false"></div>
                <div class="ModernDropdownBar" [class.open]="showProcessingDecimalDropdown" (click)="showProcessingDecimalDropdown = !showProcessingDecimalDropdown">
                  <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.ProcessingSettings?.DecimalPrecision">
                    {{PartnerDetails?.ProcessingSettings?.DecimalPrecision?.Meaning || ('SelectPrecision' | translate)}}
                  </span>
                  <i class="material-icons ModernDropdownArrow">expand_more</i>
                </div>
                <div class="ModernDropdownResults" *ngIf="showProcessingDecimalDropdown">
                  <div class="ModernDropdownOption" *ngFor="let d of DecimalPrecisions"
                       [class.selected]="PartnerDetails?.ProcessingSettings?.DecimalPrecision?.ID === d.ID"
                       (click)="PartnerDetails.ProcessingSettings.DecimalPrecision = d; showProcessingDecimalDropdown = false;">
                    {{d.Meaning}}
                    <i class="material-icons check-icon" *ngIf="PartnerDetails?.ProcessingSettings?.DecimalPrecision?.ID === d.ID">check</i>
                  </div>
                </div>
              </div>
            </div>

            <div class="ModernFormGroup" style="width: 30%;">
              <label class="ModernFormLabel">{{'OrderRank' | translate}}</label>
              <input type="number" class="ModernFormInput" [(ngModel)]="PartnerDetails.ProcessingSettings.UnpaidTolleranceDays" min="0" max="100" step="1">
            </div>
          </div>

          <div class="ModernFormGroup" *ngIf="PartnerDetails?.ProcessingSettings?.SellThroughPartnerCompany == true;" style="width: 50%; margin-top: 16px;">
            <label class="ModernFormLabel">{{ 'ChooseSellingPartnerCompany' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showProcessingPartnerCompanyDropdown" (click)="showProcessingPartnerCompanyDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showProcessingPartnerCompanyDropdown" (click)="showProcessingPartnerCompanyDropdown = !showProcessingPartnerCompanyDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.ProcessingSettings?.PartnerCompany">
                  {{PartnerDetails?.ProcessingSettings?.PartnerCompany?.Name || ('SelectCompany' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showProcessingPartnerCompanyDropdown">
                <div class="ModernDropdownOption" *ngFor="let c of Companies"
                     [class.selected]="PartnerDetails?.ProcessingSettings?.PartnerCompany?.ID === c.ID"
                     (click)="PartnerDetails.ProcessingSettings.PartnerCompany = c; showProcessingPartnerCompanyDropdown = false;">
                  {{c.Name}}
                  <i class="material-icons check-icon" *ngIf="PartnerDetails?.ProcessingSettings?.PartnerCompany?.ID === c.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div style="margin-top: 24px;">
            <button class="ModernActionButton primary" (click)="AddUpdatePartnerProcessingSettings();">
              <i class="material-icons">save</i>
              {{'SaveProcessingSettings' | translate}}
            </button>
          </div>
        </div>
      </div>

      <!-- B2B Settings & Restrictions Tab -->
      <div *ngIf="ShowB2BRestrictions" class="fullWidth" style="height: auto; float: left; padding: 0;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">security</i>
          <span>{{'B2BSettingsAndRestrictions' | translate}}</span>
        </div>

        <div class="ModernFormSubtitle">
          {{'B2BSettings' | translate}}
        </div>

        <div class="ModernFormGroup" style="width: 50%;">
          <label class="ModernFormLabel">{{ 'B2BPartnerCategory' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownOverlay" *ngIf="showB2BCategoryDropdown" (click)="showB2BCategoryDropdown = false"></div>
            <div class="ModernDropdownBar" [class.open]="showB2BCategoryDropdown" (click)="showB2BCategoryDropdown = !showB2BCategoryDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.B2BSettings?.B2BPartnerCategory">
                {{PartnerDetails?.B2BSettings?.B2BPartnerCategory?.Name || ('SelectCategory' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="showB2BCategoryDropdown">
              <div class="ModernDropdownOption" *ngFor="let c of B2BPartnerCategories"
                   [class.selected]="PartnerDetails?.B2BSettings?.B2BPartnerCategory?.ID === c.ID"
                   (click)="PartnerDetails.B2BSettings.B2BPartnerCategory = c; showB2BCategoryDropdown = false;"
                   matTooltip="{{c.Description}}" matTooltipClass='neutral-tool-tip-management'>
                {{c.Name}}
                <i class="material-icons check-icon" *ngIf="PartnerDetails?.B2BSettings?.B2BPartnerCategory?.ID === c.ID">check</i>
              </div>
            </div>
          </div>
        </div>

        <div class="fullWidth" *ngIf="PartnerDetails?.B2BSettings != null;" style="margin-top: 20px;">
          <div class="ModernFormRow">
            <div class="ModernToggleContainer">
              <label class="ModernToggle">
                <input type="checkbox" [(ngModel)]="PartnerDetails.B2BSettings.PrioritizePriceHistory">
                <span class="ModernToggleSlider"></span>
              </label>
              <span class="ModernToggleLabel">{{'ClientHistoryPricePriority' | translate}}</span>
            </div>

            <div class="ModernToggleContainer">
              <label class="ModernToggle">
                <input type="checkbox" [(ngModel)]="PartnerDetails.B2BSettings.CanDownloadPriceLists">
                <span class="ModernToggleSlider"></span>
              </label>
              <span class="ModernToggleLabel">{{'CanDownloadPriceLists' | translate}}</span>
            </div>

            <div class="ModernToggleContainer">
              <label class="ModernToggle">
                <input type="checkbox" [(ngModel)]="PartnerDetails.B2BSettings.Blocked">
                <span class="ModernToggleSlider"></span>
              </label>
              <span class="ModernToggleLabel">{{'Blocked' | translate}}</span>
            </div>
          </div>

          <div class="ModernFormFormSubtitle" style="margin-top: 20px;">
            {{'APIRateLimitSettings' | translate}}
          </div>

          <div class="ModernFormRow" style="margin-top: 12px;">
            <div class="ModernFormGroup" style="width: 25%; margin-right: 16px;">
              <label class="ModernFormLabel">{{ 'APICallsMinutesWindow' | translate }}</label>
              <input class="ModernFormInput" type="number" min="1" max="60"
                     [(ngModel)]="PartnerDetails.B2BSettings.APICallsMinutesWindow"
                     placeholder="10">
              <span class="ModernFormHint">{{'APICallsMinutesWindowHint' | translate}}</span>
            </div>

            <div class="ModernFormGroup" style="width: 25%; margin-right: 16px;">
              <label class="ModernFormLabel">{{ 'APIMaxAllowedCalls' | translate }}</label>
              <input class="ModernFormInput" type="number" min="1" max="10000"
                     [(ngModel)]="PartnerDetails.B2BSettings.APIMaxAllowedCalls"
                     placeholder="100">
              <span class="ModernFormHint">{{'APIMaxAllowedCallsHint' | translate}}</span>
            </div>

            <div class="ModernFormGroup" style="width: 25%;">
              <label class="ModernFormLabel">{{ 'MaxItemsPerApiCall' | translate }}</label>
              <input class="ModernFormInput" type="number" min="1" max="100"
                     [(ngModel)]="PartnerDetails.B2BSettings.MaxItemsPerApiCall"
                     placeholder="10">
              <span class="ModernFormHint">{{'MaxItemsPerApiCallHint' | translate}}</span>
            </div>
          </div>

          <div class="ModernFormRow" style="margin-top: 16px;">
            <div class="ModernFormGroup" style="width: 100%;">
              <mat-checkbox [(ngModel)]="PartnerDetails.B2BSettings.IncludeMasterData"
                            [title]="'IncludeMasterDataHint' | translate">
                {{ 'IncludeMasterData' | translate }} - <span style="font-weight: normal; opacity: 0.8;">{{'IncludeMasterDataHint' | translate}}</span>
              </mat-checkbox>
            </div>
          </div>

          <div style="margin-top: 16px;">
            <button class="ModernActionButton success" (click)="AddUpdatePartnerB2BSettings();">
              <i class="material-icons">save</i>
              {{'SaveButton' | translate}}
            </button>
          </div>
        </div>

        <!-- B2B History Year Settings Section -->
        <div class="ModernFormSubtitle" style="margin-top: 24px;">
          {{'B2BHistoryYearSettings' | translate}}
        </div>

        <div class="fullWidth" style="margin-top: 20px; margin-bottom: 20px;">
          <div class="ProfitSettingsTable">
            <div class="ProfitSettingsRow ProfitSettingsHeadder">
              <div class="ProfitSettingsCol" style="width: 5%;"><span>#</span></div>
              <div class="ProfitSettingsCol" style="width: 20%;"><span>{{'Client' | translate}}</span></div>
              <div class="ProfitSettingsCol" style="width: 7.5%;"><span>{{'YearsBehind' | translate}}</span></div>
              <div class="ProfitSettingsCol" style="width: 7.5%;"><span>{{'YearsBehindTargetYear' | translate}}</span></div>
              <div class="ProfitSettingsCol" style="width: 5%;"><span>% {{'ExtraAddedPercentageValue' | translate}}</span></div>
              <div class="ProfitSettingsCol" style="width: 20%;"><span>{{'Brand' | translate}}</span></div>
              <div class="ProfitSettingsCol" style="width: 10%;"><span>{{'OnlyPerosnalHistory' | translate}}</span></div>
              <div class="ProfitSettingsCol" style="width: 10%;"><span>{{'CompareHistoryPriceWithListPrice' | translate}}</span></div>
              <div class="ProfitSettingsCol" style="width: 15%;"><span>{{'Actions' | translate}}</span></div>
            </div>

            <!-- Existing Year Settings Rows -->
            <div class="ProfitSettingsRow" *ngFor="let setting of PartnerDetails?.B2BSettings?.YearSettings; let i=index;">
              <div class="ProfitSettingsCol" style="width: 5%;"><span>{{i + 1}}</span></div>
              <div class="ProfitSettingsCol" style="width: 20%;"><span style="font-size: 10px;">{{PartnerDetails.Name}}</span></div>
              <div class="ProfitSettingsCol" style="width: 7.5%;">
                <input class="ModernFormInput" type="text" style="width: 90%; height: 28px; font-size: 10px;"
                       placeholder="{{'YearsBehind' | translate}}"
                       (keypress)="restrictNonNumericInput($event)"
                       (change)="onYearsBehindChange(setting)"
                       [(ngModel)]="setting.YearsBehind" maxlength="5">
              </div>
              <div class="ProfitSettingsCol" style="width: 7.5%;"><span>{{setting.YearsBehindTargetYear}}</span></div>
              <div class="ProfitSettingsCol" style="width: 5%;">
                <input class="ModernFormInput" type="text" style="width: 90%; height: 28px; font-size: 10px;"
                       placeholder="%" [(ngModel)]="setting.ExtraAddedPercentageValue" maxlength="5">
              </div>
              <div class="ProfitSettingsCol" style="width: 20%;" (click)="CurrentYearSetting = setting; OpenYearSettingsBrandChange();">
                <span *ngIf="setting?.Brand?.ID > 0">{{setting?.Brand?.Name}}</span>
                <span *ngIf="!(setting?.Brand?.ID > 0)">-------------</span>
              </div>
              <div class="ProfitSettingsCol" style="width: 10%;">
                <label class="ModernToggle compact">
                  <input type="checkbox" [(ngModel)]="setting.OnlyPerosnalHistory">
                  <span class="ModernToggleSlider"></span>
                </label>
              </div>
              <div class="ProfitSettingsCol" style="width: 10%;">
                <label class="ModernToggle compact">
                  <input type="checkbox" [(ngModel)]="setting.CompareHistoryPriceWithListPrice">
                  <span class="ModernToggleSlider"></span>
                </label>
              </div>
              <div class="ProfitSettingsCol" style="width: 15%; gap: 8px;">
                <i class="material-icons RestrictionIcon success" (click)="AddUpdateHistoryYearSetting(setting);">check</i>
                <i class="material-icons RestrictionIcon danger" (click)="PrepareYearSettingsDelete(setting);">close</i>
              </div>
            </div>

            <!-- New Year Settings Row -->
            <div class="ProfitSettingsRow">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <div class="AddYearSettingsButton" (click)="InitializeNewYearsSettings();" *ngIf="NewYearSettings?.DBID != 0;">
                  <i class="material-icons">add</i>
                </div>
              </div>
              <div class="ProfitSettingsCol" style="width: 20%;" *ngIf="NewYearSettings?.DBID == 0;">
                <span style="font-size: 10px;">{{PartnerDetails.Name}}</span>
              </div>
              <div class="ProfitSettingsCol" style="width: 7.5%;" *ngIf="NewYearSettings?.DBID == 0;">
                <input class="ModernFormInput" type="text" style="width: 90%; height: 28px; font-size: 10px;"
                       placeholder="{{'YearsBehind' | translate}}"
                       (keypress)="restrictNonNumericInput($event)"
                       (change)="onYearsBehindChange(NewYearSettings)"
                       [(ngModel)]="NewYearSettings.YearsBehind" maxlength="5">
              </div>
              <div class="ProfitSettingsCol" style="width: 7.5%;" *ngIf="NewYearSettings?.DBID == 0;">
                <span>{{NewYearSettings.YearsBehindTargetYear}}</span>
              </div>
              <div class="ProfitSettingsCol" style="width: 5%;" *ngIf="NewYearSettings?.DBID == 0;">
                <input class="ModernFormInput" type="text" style="width: 90%; height: 28px; font-size: 10px;"
                       placeholder="%" [(ngModel)]="NewYearSettings.ExtraAddedPercentageValue" maxlength="5">
              </div>
              <div class="ProfitSettingsCol" style="width: 20%;" *ngIf="NewYearSettings?.DBID == 0;" (click)="OpenNewYearSettingsBrandChange();">
                <span *ngIf="NewYearSettings?.Brand?.ID > 0">{{NewYearSettings?.Brand?.Name}}</span>
                <span *ngIf="!(NewYearSettings?.Brand?.ID > 0)">-------------</span>
              </div>
              <div class="ProfitSettingsCol" style="width: 10%;" *ngIf="NewYearSettings?.DBID == 0;">
                <label class="ModernToggle compact">
                  <input type="checkbox" [(ngModel)]="NewYearSettings.OnlyPerosnalHistory">
                  <span class="ModernToggleSlider"></span>
                </label>
              </div>
              <div class="ProfitSettingsCol" style="width: 10%;" *ngIf="NewYearSettings?.DBID == 0;">
                <label class="ModernToggle compact">
                  <input type="checkbox" [(ngModel)]="NewYearSettings.CompareHistoryPriceWithListPrice">
                  <span class="ModernToggleSlider"></span>
                </label>
              </div>
              <div class="ProfitSettingsCol" style="width: 15%; gap: 8px;" *ngIf="NewYearSettings?.DBID == 0;">
                <i class="material-icons RestrictionIcon success" (click)="AddUpdateHistoryYearSetting(NewYearSettings);">check</i>
                <i class="material-icons RestrictionIcon danger" (click)="NewYearSettings = {};">close</i>
              </div>
            </div>
          </div>
        </div>

        <div class="ModernFormDivider"></div>

        <!-- B2B Restrictions Section -->
        <div class="ModernFormSubtitle" style="margin-top: 24px;">
          {{'B2BRestrictions' | translate}}
        </div>

        <div class="fullWidth" style="margin-top: 20px; margin-bottom: 20px;">
          <div class="ProfitSettingsTable">
            <div class="ProfitSettingsRow ProfitSettingsHeadder">
              <div class="ProfitSettingsCol" style="width: 5%;"><span>#</span></div>
              <div class="ProfitSettingsCol" style="width: 20%;"><span>{{'Client' | translate}}</span></div>
              <div class="ProfitSettingsCol" style="width: 15%;"><span>{{'RestrictionType' | translate}}</span></div>
              <div class="ProfitSettingsCol" style="width: 15%;"><span>{{'ImportConfiguration' | translate}}</span></div>
              <div class="ProfitSettingsCol" style="width: 20%;"><span>{{'Brand' | translate}}</span></div>
              <div class="ProfitSettingsCol" style="width: 10%;"><span>{{'Country' | translate}}</span></div>
              <div class="ProfitSettingsCol" style="width: 15%;"><span>{{'Actions' | translate}}</span></div>
            </div>

            <div class="ProfitSettingsRow" *ngFor="let r of PartnerDetails?.B2BRestrictions; let i=index;">
              <div class="ProfitSettingsCol" style="width: 5%;"><span>{{i + 1}}</span></div>
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span *ngIf="r.PartnerName?.length > 0;">{{r.PartnerName}}</span>
                <span *ngIf="!r.PartnerName?.length;">-----</span>
              </div>
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span *ngIf="r.RestrictionType?.Name?.length > 0;">{{r.RestrictionType?.Name}}</span>
                <span *ngIf="!r.RestrictionType?.Name?.length;">-----</span>
              </div>
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span *ngIf="r.ImportConfiguration?.Name?.length > 0;">{{r.ImportConfiguration?.Name}}</span>
                <span *ngIf="!r.ImportConfiguration?.Name?.length;">-----</span>
              </div>
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span *ngIf="r.Brand?.Name?.length > 0;">{{r.Brand?.Name}}</span>
                <span *ngIf="!r.Brand?.Name?.length;">-----</span>
              </div>
              <div class="ProfitSettingsCol" style="width: 10%;">
                <span *ngIf="r.Country?.Name?.length > 0;">{{r.Country?.Name}}</span>
                <span *ngIf="!r.Country?.Name?.length;">-----</span>
              </div>
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span style="font-size: 10px; color: #999;">{{'ReadOnly' | translate}}</span>
              </div>
            </div>
          </div>

          <div *ngIf="!PartnerDetails?.B2BRestrictions || PartnerDetails?.B2BRestrictions?.length === 0" class="no-data-message" style="padding: 40px; text-align: center; color: #666;">
            <i class="material-icons" style="font-size: 48px; color: #ccc;">security</i>
            <p>{{'NoB2BRestrictionsAvailable' | translate}}</p>
          </div>
        </div>
      </div>

      <!-- Contractual Conditions Tab -->
      <div *ngIf="ShowContractualConditions" class="fullWidth" style="height: auto; float: left; padding: 0;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">description</i>
          <span>{{'ContractualConditions' | translate}}</span>
        </div>

        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'BuyPaymentTerms' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualBuyPaymentTermsDropdown" (click)="showContractualBuyPaymentTermsDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualBuyPaymentTermsDropdown" (click)="showContractualBuyPaymentTermsDropdown = !showContractualBuyPaymentTermsDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.ContractualConditions?.BuyPaymentTerms">
                  {{PartnerDetails?.ContractualConditions?.BuyPaymentTerms?.Name || ('SelectPaymentTerm' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualBuyPaymentTermsDropdown">
                <div class="ModernDropdownOption" *ngFor="let pt of parent.CartMasterData?.PaymentTerms"
                     [class.selected]="PartnerDetails?.ContractualConditions?.BuyPaymentTerms?.ID === pt.ID"
                     (click)="PartnerDetails.ContractualConditions.BuyPaymentTerms = pt; showContractualBuyPaymentTermsDropdown = false;">
                  {{pt.Name}}
                  <i class="material-icons check-icon" *ngIf="PartnerDetails?.ContractualConditions?.BuyPaymentTerms?.ID === pt.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'SellPaymentTerms' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualSellPaymentTermsDropdown" (click)="showContractualSellPaymentTermsDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualSellPaymentTermsDropdown" (click)="showContractualSellPaymentTermsDropdown = !showContractualSellPaymentTermsDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.ContractualConditions?.SellPaymentTerms">
                  {{PartnerDetails?.ContractualConditions?.SellPaymentTerms?.Name || ('SelectPaymentTerm' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualSellPaymentTermsDropdown">
                <div class="ModernDropdownOption" *ngFor="let pt of parent.CartMasterData?.PaymentTerms"
                     [class.selected]="PartnerDetails?.ContractualConditions?.SellPaymentTerms?.ID === pt.ID"
                     (click)="PartnerDetails.ContractualConditions.SellPaymentTerms = pt; showContractualSellPaymentTermsDropdown = false;">
                  {{pt.Name}}
                  <i class="material-icons check-icon" *ngIf="PartnerDetails?.ContractualConditions?.SellPaymentTerms?.ID === pt.ID">check</i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Shipping Company & Shipping Responsability -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'ShippingCompany' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualShippingCompanyDropdown" (click)="showContractualShippingCompanyDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualShippingCompanyDropdown" (click)="showContractualShippingCompanyDropdown = !showContractualShippingCompanyDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.ContractualConditions?.ShippingCompany">
                  {{PartnerDetails?.ContractualConditions?.ShippingCompany?.Name || ('SelectShippingCompany' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualShippingCompanyDropdown">
                <div class="ModernDropdownOption" *ngFor="let sc of parent.CartMasterData?.ShippingCompanies"
                     [class.selected]="PartnerDetails?.ContractualConditions?.ShippingCompany?.ID === sc.ID"
                     (click)="PartnerDetails.ContractualConditions.ShippingCompany = sc; showContractualShippingCompanyDropdown = false;">
                  {{sc.Name}}
                  <i class="material-icons check-icon" *ngIf="PartnerDetails?.ContractualConditions?.ShippingCompany?.ID === sc.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'ShippingResponsability' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualShippingResponsabilityDropdown" (click)="showContractualShippingResponsabilityDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualShippingResponsabilityDropdown" (click)="showContractualShippingResponsabilityDropdown = !showContractualShippingResponsabilityDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.ContractualConditions?.ShippingResponsability">
                  {{PartnerDetails?.ContractualConditions?.ShippingResponsability?.Name || ('SelectShippingResponsability' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualShippingResponsabilityDropdown">
                <div class="ModernDropdownOption" *ngFor="let sr of parent.CartMasterData?.ShippingResponsabilities"
                     [class.selected]="PartnerDetails?.ContractualConditions?.ShippingResponsability?.ID === sr.ID"
                     (click)="PartnerDetails.ContractualConditions.ShippingResponsability = sr; showContractualShippingResponsabilityDropdown = false;">
                  {{sr.Name}}
                  <i class="material-icons check-icon" *ngIf="PartnerDetails?.ContractualConditions?.ShippingResponsability?.ID === sr.ID">check</i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Payment Type & Shipping Service Type -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'PaymentType' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualPaymentTypeDropdown" (click)="showContractualPaymentTypeDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualPaymentTypeDropdown" (click)="showContractualPaymentTypeDropdown = !showContractualPaymentTypeDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.ContractualConditions?.PaymentType">
                  {{PartnerDetails?.ContractualConditions?.PaymentType?.Name || ('SelectPaymentType' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualPaymentTypeDropdown">
                <div class="ModernDropdownOption" *ngFor="let ptype of parent.CartMasterData?.PaymentTypes"
                     [class.selected]="PartnerDetails?.ContractualConditions?.PaymentType?.ID === ptype.ID"
                     (click)="PartnerDetails.ContractualConditions.PaymentType = ptype; showContractualPaymentTypeDropdown = false;">
                  {{ptype.Name}}
                  <i class="material-icons check-icon" *ngIf="PartnerDetails?.ContractualConditions?.PaymentType?.ID === ptype.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'ShippingServiceType' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualShippingServiceTypeDropdown" (click)="showContractualShippingServiceTypeDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualShippingServiceTypeDropdown" (click)="showContractualShippingServiceTypeDropdown = !showContractualShippingServiceTypeDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.ContractualConditions?.ShippingServiceType">
                  {{PartnerDetails?.ContractualConditions?.ShippingServiceType?.Name || ('SelectShippingServiceType' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualShippingServiceTypeDropdown">
                <div class="ModernDropdownOption" *ngFor="let sst of parent.CartMasterData?.ShippingServiceTypes"
                     [class.selected]="PartnerDetails?.ContractualConditions?.ShippingServiceType?.ID === sst.ID"
                     (click)="PartnerDetails.ContractualConditions.ShippingServiceType = sst; showContractualShippingServiceTypeDropdown = false;">
                  {{sst.Name}}
                  <i class="material-icons check-icon" *ngIf="PartnerDetails?.ContractualConditions?.ShippingServiceType?.ID === sst.ID">check</i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Consolidation Type & Delivery Preference -->
        <div class="ModernFormRow">
          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'ConsolidationType' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualConsolidationTypeDropdown" (click)="showContractualConsolidationTypeDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualConsolidationTypeDropdown" (click)="showContractualConsolidationTypeDropdown = !showContractualConsolidationTypeDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.ContractualConditions?.ConsolidationType">
                  {{PartnerDetails?.ContractualConditions?.ConsolidationType?.Name || ('SelectConsolidationType' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualConsolidationTypeDropdown">
                <div class="ModernDropdownOption" *ngFor="let ct of parent.CartMasterData?.ConsolidationTypes"
                     [class.selected]="PartnerDetails?.ContractualConditions?.ConsolidationType?.ID === ct.ID"
                     (click)="PartnerDetails.ContractualConditions.ConsolidationType = ct; showContractualConsolidationTypeDropdown = false;">
                  {{ct.Name}}
                  <i class="material-icons check-icon" *ngIf="PartnerDetails?.ContractualConditions?.ConsolidationType?.ID === ct.ID">check</i>
                </div>
              </div>
            </div>
          </div>

          <div class="ModernFormGroup" style="width: 50%;">
            <label class="ModernFormLabel">{{ 'DeliveryPreference' | translate }}</label>
            <div class="ModernDropdownContainer">
              <div class="ModernDropdownOverlay" *ngIf="showContractualDeliveryPreferenceDropdown" (click)="showContractualDeliveryPreferenceDropdown = false"></div>
              <div class="ModernDropdownBar" [class.open]="showContractualDeliveryPreferenceDropdown" (click)="showContractualDeliveryPreferenceDropdown = !showContractualDeliveryPreferenceDropdown">
                <span class="ModernDropdownText" [class.placeholder]="!PartnerDetails?.ContractualConditions?.DeliveryPreference">
                  {{PartnerDetails?.ContractualConditions?.DeliveryPreference?.Name || ('SelectDeliveryPreference' | translate)}}
                </span>
                <i class="material-icons ModernDropdownArrow">expand_more</i>
              </div>
              <div class="ModernDropdownResults" *ngIf="showContractualDeliveryPreferenceDropdown">
                <div class="ModernDropdownOption" *ngFor="let dp of parent.CartMasterData?.DeliveryPreferences"
                     [class.selected]="PartnerDetails?.ContractualConditions?.DeliveryPreference?.ID === dp.ID"
                     (click)="PartnerDetails.ContractualConditions.DeliveryPreference = dp; showContractualDeliveryPreferenceDropdown = false;">
                  {{dp.Name}}
                  <i class="material-icons check-icon" *ngIf="PartnerDetails?.ContractualConditions?.DeliveryPreference?.ID === dp.ID">check</i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ModernFormDivider"></div>

        <div class="ModernFormRow">
          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="PartnerDetails.ContractualConditions.HasContract">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'HasContract' | translate}}</span>
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="PartnerDetails.ContractualConditions.RequiresContract">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'RequiresContract' | translate}}</span>
          </div>

          <div class="ModernToggleContainer">
            <label class="ModernToggle">
              <input type="checkbox" [(ngModel)]="PartnerDetails.ContractualConditions.SignedByOurCompany">
              <span class="ModernToggleSlider"></span>
            </label>
            <span class="ModernToggleLabel">{{'SignedByOurCompany' | translate}}</span>
          </div>
        </div>

        <div class="ModernFormRow" style="margin-top: 16px;">
          <div class="ModernFormGroup" style="width: 33%;">
            <label class="ModernFormLabel">{{ 'ContractSignedDate' | translate }}</label>
            <input class="ModernFormInput" type="date" [(ngModel)]="PartnerDetails.ContractualConditions.ContractSignedDate">
          </div>

          <div class="ModernFormGroup" style="width: 33%;">
            <label class="ModernFormLabel">{{ 'ContractExpirationDate' | translate }}</label>
            <input class="ModernFormInput" type="date" [(ngModel)]="PartnerDetails.ContractualConditions.ContractExpirationDate">
          </div>

          <div class="ModernFormGroup" style="width: 33%;">
            <label class="ModernFormLabel">{{ 'ContractPath' | translate }}</label>
            <input class="ModernFormInput" type="text" [(ngModel)]="PartnerDetails.ContractualConditions.ContractPath" placeholder="{{'ContractPath' | translate}}">
          </div>
        </div>

        <div class="ModernFormDivider"></div>

        <div style="margin-top: 16px;">
          <button class="ModernButton primary" (click)="AddUpdatePartnerContractualConditions();">
            <i class="material-icons">save</i>
            {{'Save' | translate}}
          </button>
        </div>
      </div>

    </div>

    <div class="ModernPopupFooter">
      <button class="ModernButton outline" (click)="ClosePartnerDetailsPopup()">
        {{ 'Close' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- ✅ Add New Partner Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowAddNewPartnerPopup" (click)="CloseAddNewPartnerPopup()">
  <div class="ModernPopup xlarge animated fadeInDown" style="max-width: 500px; height: auto;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">person_add</i>
        <span>{{'Partners.AddNewPartner' | translate}}</span>
      </div>
      <button class="ModernPopupClose" (click)="CloseAddNewPartnerPopup()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <div class="ModernPopupBody" style="padding: 24px; padding-bottom: 0;">
      <!-- Partner Name -->
      <div class="ModernFormGroup" style="margin-bottom: 20px;">
        <label class="ModernFormLabel">{{'Partners.Name' | translate}} *</label>
        <input class="ModernFormInput" type="text" [(ngModel)]="NewPartnerName"
               placeholder="{{'Partners.Name' | translate}}" />
      </div>

      <!-- VAT -->
      <div class="ModernFormGroup" style="margin-bottom: 20px;">
        <label class="ModernFormLabel">{{'Partners.VAT' | translate}}</label>
        <input class="ModernFormInput" type="text" [(ngModel)]="NewPartnerVAT"
               placeholder="ex. RO1234567" />
      </div>

      <!-- Country with Search -->
      <div class="ModernFormGroup" style="margin-bottom: 20px; position: relative;">
        <label class="ModernFormLabel">{{'Partners.PartnerWindow.ChooseCountry' | translate}} *</label>
        <div class="PartnerSearchBar" style="background: #fff; border: 1px solid #ddd; border-radius: 6px;">
          <i class="material-icons search-icon" *ngIf="!NewPartnerCountrySearchTerm || NewPartnerCountrySearchTerm.length === 0">public</i>
          <i class="material-icons clear-icon" *ngIf="NewPartnerCountrySearchTerm?.length > 0" (click)="NewPartnerClearCountry()">close</i>
          <input type="text" class="PartnerSearchInput"
                 [(ngModel)]="NewPartnerCountrySearchTerm"
                 (ngModelChange)="NewPartnerSearchCountries()"
                 (focus)="NewPartnerSearchCountries()"
                 placeholder="{{'Partners.PartnerWindow.ChooseCountry' | translate}}" />
        </div>
        <!-- Country Search Results -->
        <div class="PartnerSearchResults" *ngIf="NewPartnerFilteredCountries.length > 0"
             style="position: absolute; top: 100%; left: 0; right: 0; z-index: 1000; max-height: 200px; overflow-y: auto;">
          <div class="PartnerSearchResult" *ngFor="let country of NewPartnerFilteredCountries"
               (click)="NewPartnerSelectCountry(country)" style="padding: 10px 12px; cursor: pointer;">
            <span style="font-weight: 600; margin-right: 8px;">{{ country.ShortName }}</span>
            <span style="color: #666;">{{ country.Name }}</span>
          </div>
        </div>
        <!-- Selected Country Badge -->
        <div *ngIf="NewPartnerSelectedCountry" style="margin-top: 8px;">
          <span style="background: #e3f2fd; color: #1976d2; padding: 4px 10px; border-radius: 4px; font-size: 12px; font-weight: 500;">
            <i class="material-icons" style="font-size: 14px; vertical-align: middle; margin-right: 4px;">check_circle</i>
            {{ NewPartnerSelectedCountry.Name }} ({{ NewPartnerSelectedCountry.ShortName }})
          </span>
        </div>
      </div>

      <!-- Address Line -->
      <div class="ModernFormGroup" style="margin-bottom: 20px;">
        <label class="ModernFormLabel">{{'Partners.PartnerWindow.AddressLine' | translate}} *</label>
        <input class="ModernFormInput" type="text" [(ngModel)]="NewPartnerAddressLine"
               placeholder="{{'Partners.PartnerWindow.AddressLine' | translate}}" />
      </div>

      <!-- Email -->
      <div class="ModernFormGroup" style="margin-bottom: 20px;">
        <label class="ModernFormLabel">Email</label>
        <input class="ModernFormInput" type="email" [(ngModel)]="NewPartnerEmail"
               placeholder="Email" />
      </div>
    </div>

    <div class="ModernPopupFooter" style="display: flex; justify-content: flex-end; gap: 12px; padding: 16px 24px; border-top: 1px solid #e9ecef;">
      <button class="ModernButton outline" (click)="CloseAddNewPartnerPopup()" [disabled]="NewPartnerSaving">
        {{ 'Cancel' | translate }}
      </button>
      <button class="ModernButton primary" (click)="AddNewPartner()" [disabled]="NewPartnerSaving">
        <mat-spinner *ngIf="NewPartnerSaving" [diameter]="16" style="margin-right: 8px;"></mat-spinner>
        <i class="material-icons" *ngIf="!NewPartnerSaving">save</i>
        {{'Partners.AddNewPartner' | translate}}
      </button>
    </div>
  </div>
</div>
